import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  Input,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  ElementRef,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  AlertController,
  ToastController,
  IonSlides,
  IonInfiniteScroll,
  ModalController,
  LoadingController,
  IonContent,
  PopoverController,
  Platform
} from '@ionic/angular';
import { ServicesProvider } from 'src/providers/services';
import { InViewportMetadata } from 'ng-in-viewport';
import { DatePipe } from '@angular/common';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { FileUploadService } from 'src/providers/upload';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { AddmemPage } from '../addmem/addmem.page';
import { ReviewPage } from '../review/review.page';
import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { AddCall } from 'src/providers/addvCall';
import { ViewmodelPage } from '../viewmodel/viewmodel.page';
import { Payment } from 'src/providers/payment';
import { MediapopupPage } from '../mediapopup/mediapopup.page';
import { RatingSortpagePage } from '../rating-sortpage/rating-sortpage.page';
import { CommonService } from 'src/providers/common';
import { AdvertisementPage } from '../advertisement/advertisement.page';
import { SuccessPage } from 'src/app/success/success.page';
import { knetPaymentDetailsPage } from '../success/knetPaymentDetails/knetPaymentDetails.page';
import * as moment from 'moment';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { VendorTCComponent } from '../termscond/vendor-tc/vendor-tc.component';
import { MediaElementPlayer } from 'mediaelement';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}


declare var google;
@Component({
  selector: 'app-dietmeal',
  templateUrl: './dietmeal.page.html',
  styleUrls: ['./dietmeal.page.scss'],
})
export class DietmealPage implements OnInit {
  sendLinkid: string;
  terms_and_condition_file: any;
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');
  private longPressTimer: any;
  private readonly LONG_PRESS_DURATION = 500;
  private readonly selected_DURATION = 500;
  @ViewChild('map', { static: false }) mapElement: ElementRef;
  @ViewChild('slides', { static: false }) slides: IonSlides;
  slideOpts = {
    initialSlide: 0,
    speed: 400,
    slidesPerView: 'auto', // Allows slides to adjust based on content
    centeredSlides: false,
    allowTouchMove: true, // Ensure dragging is enabled
    simulateTouch: true,  // Allows click-and-drag on desktop
    grabCursor: true,     // Provides visual feedback for drag action
    longSwipes: true,     // Allows for long drag gestures
    shortSwipes: true,    // Enables short drag gestures
    touchStartPreventDefault: false, 
    mousewheel: true,
  };
  // @ViewChildren('newVdo') vdoPlayer: QueryList<ElementRef>;
  @ViewChild(IonContent, { static: false }) content: IonContent;
  // @ViewChildren('newVdo') vdoPlayer: QueryList<ElementRef>;
  @ViewChildren('newVdo') vdoPlayer: MediaElementPlayer;
  @Output() ChangeEventDiet = new EventEmitter<string>();
  currentPlaying = null;
  // @ViewChild(IonContent, { read: IonContent, static: false }) content: IonContent;
  // @ViewChild( "videoSlide", { static: false }) videoSlide: QueryList<IonSlides >;
  @ViewChild('videoSlide', { static: false }) videoSlide: any;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  // @ViewChild(IonContent) ionContent: IonContent;
  @Input() showTypeofBooking;
  rate: number;
  presentView: string;
  Hspice: string;
  week: string = this.addCall.title686 + "1";
  day: string = 'Fri';
  heiweiType: string;
  showWeightCalc: boolean;
  MealbookingInfo: boolean;
  MealbookingList: boolean;
  CanMealbookingList: boolean;
  backValue: string;
  headerValue: string;
  selectedDish: any;
  from_date: any;
  after48hours_view: any;
  readonly: boolean;
  EditOrSave: string;
  dietCheckboxBtn: any = '';
  save_and_select: any = '';
  height: string;
  weight: string;
  getHeight: any;
  getWeight: any;
  alertInstance: any;
  spice: any[];
  menu_item_details_list: any[];
  DeliveryAddress: string = 'No Address';
  showRefundPopUp: boolean;
  playVid: any;
  ProfileVideo: any;
  playMode: boolean = false;
  loaddata: boolean = true;
  start_cheatday: boolean = false;
  private isLongPress = false;
  storeValue: string;
  slctdMemVal: any = 'Name';
  swipe1: boolean = false;
  swipe2: boolean = false;
  swipe3: boolean = false;
  no_repeat: boolean = false;
  acceptTerms: boolean

  viwemorcl: boolean;
  click: number = 0;
  //API variabel only---------
  getDietCompanyList: any = [];
  total_selected_date: any = [];
  finalArrayFood_dates: any = [];
  search: any = false;
  searchValue: any = null;
  activeVideoId: any;
  daysDifference: any;
  storeParticulardataview: any;
  oldActiveVideoId: any;
  checked: any;
  food: any;
  sundayinarabic: any;
  storeDietVendorId: any;
  storDietCmpnyProDetls: any = null;
  storeDietpackageDetails: any = [];
  storeFilterCategry: any = [];
  storeIntruction: any = [];
  storeBookingList: any = [];
  bookedDates: any = [];
  cheat_days_dates: any = [];
  storeParticularData: any;
  storeBookingHisList: any = [];
  dietBookingInfo: any;
  storeBookingId: any;
  storeDietFromDate: any;
  storeSessionList: any = [];
  durationDetailMenuList: any = [];
  storeDietMenuId: any;
  storeDietPkgId: any;
  storeFilterCatId: any = [];
  storeDietPkgListIndex: any;
  StoreWeekDaysDiet: any = [];
  storeWeekDiet: any = [];
  storeDietDuration: any;
  storeNmOfWeek: any = [];
  storeWeekDays: any = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  particulrSessionList: any = [];
  storeWeekIndex: any = 0;
  storeDaysIndex: any = 0;
  BMIvalue: any = null;
  package_image: any;
  twodaysbefore: any;
  saveandselect: boolean = false;
  BMICategory: string = null;
  getGoalWeight: any = null;
  patientBasicDetails: any;
  prtclrDietPkgInfo: any;
  getAnyMadication: string = null;
  getAnyDisease: string = null;
  getAnySurgery: string = null;
  getAnyHabits: string = null;
  heightUnit: string = null;
  weightUnit: string = null;
  inTakeClsPerDay: any = null;
  durationDays: number;
  pageNo: number = 1;
  showVideoOptins: boolean = true;
  selectedDate: any;
  selectedsdate: any;
  currentDatevalue: any;
  durationidvalue: any;
  Date: any;
  setDate: string;
  wekitem: any = null;
  storeSelectedDiet: any = [];
  storeFilterInstId: any = [];
  dietToDate: string = null;
  dietFromDate: string = null;
  storeBookingAmnt: any;
  RepeatWeek: any;
  dietCompanyName: any;
  repeatDietData: { bkgId: any; venId: any; bkgDate: any };
  EmptyData: any;
  nextCount: any;
  isData: any = null;
  isData1: any;
  selectedMemberId: any;
  currentMemberId: any;
  getDayId: number;
  aniMat: string = 'animatedList';
  scrollEvent: any;
  isMealSeld: boolean = false;
  showcoment: boolean = true;
  storedPath: null;
  hitApi = [];
  cardNum = 5;
  selDays: number = 0;
  totlCalories: number;
  weightCalc: any;
  oldVideoTarget: any;
  Gender: any;
  Age: any;
  calPerDay: any = 0;
  dealOtp: any = null;
  dealOtp1: any = null;
  dealAmt: any;
  totalPrice: any;
  finalAmt: number;
  refEvent: any;
  cmpnyListReq: any;
  partCompDietPlanReq: any;
  getCatMealPlanReq: any;
  dietInstReq: any;
  addMealReq: any;
  repMenuReq: any;
  patProReq: any;
  checking: any;
  bookdeddata_view: any;
  bookListReq: any;
  bookHisListReq: any;
  insertDietBookReq: any;
  tymVal: any;
  // selectOptiondis: any = true;
  rat: any;
  weekvalue: any;
  wekary = [];
  wekar2 = [];
  selected_days: any;
  wekval: any;
  pressindex: any;
  inst: any;
  wekary3 = [];
  ary = ['test', 'test2', 'test3', 'test4'];
  ide: any;
  ngaray = [];
  ngaray2 = [];
  ngary3 = [];
  temp_ary = [];
  weekDropdown: any;
  selected: any;
  wekit: any;
  instruction: any;
  wekday: number;
  daysh: string;
  wek: number;
  dayk: number;
  viewmore: boolean;
  add_inst = [];
  rateSoring: boolean;
  offerSoring: boolean;
  rateSortOrder: any;
  offrSortOrder: any;
  instra1: any = [];
  instra: any = [];
  instadd: any;
  Email: any;
  Phonno: any;
  cccode: any;
  paymentid: any;
  revArr: any = [];
  referenceid: any;
  orderId: any;
  paymentGateway: any;
  isShow: any;
  dynClass: string;
  addImg: any;
  offerAmt: any;
  currentDate: any;
  calories_visible: boolean = false;
  payType: any;
  gopayment: boolean = false;
  isMuteVideo: boolean = false;
  deliver_error: boolean = false;
  package_list: any = [];
  dution_detail_data: any[] = [];
  duration_id: any = 0;
  package_id: any = 0;
  duration_detail_id: any = 0;
  package_general_detail_data: any = [];
  delivery_time_id: any = 0;
  master_menu_list: any = [];
  diet_menu_list: any = [];
  duration_detail_menu_list: any = [];
  duration_detail_menu_list_copy: any = [];
  week_duration_detail_menu_list: any = [];
  weekDietDetail: any = [];
  weekdayarray: any = [];
  is_cheat_day_available: boolean = false;
  cheat_days: any = [];
  cheat_day: any = [];
  diet_package_name: string = '';
  deliver_in_time: any;
  is_save_later: boolean = false;
  isScrolling: boolean = false;
  package_diet_detail_name: string = '';
  dayoff: string = '';
  delivery_time: string = '';
  booking_id: any = 0;
  delivery_contact_no: any = '';
  cc_code_details: any = '';
  delivery_instruction: any = '';
  edited_diet_menu: any = [];
  edited_data: any;
  datevalue: any;
  diet_details_id: any;
  detailId: any;
  Addcheckvarible: boolean = true;
  booking_updated: boolean = false;
  daysoff: any;
  allDatesFound: boolean = false;
  mouseDownTimer: any;
  isShowHeaderValue: any;
  map: any;
  latitude: number;
  longitude: number;
  address: any;
  LocationIcon: any;
  lattitude: any;
  longititude: any;
  dietExplainervideo: boolean = false;
  tempMemberName:any;
  Phoneno:any;
  payload:any;
  DietReq: any;
  Email_w:any;
  PaymentGateways:any=[];
  constructor(
    public alertCtrl: AlertController,
    private router: Router,
    private services: ServicesProvider,
    public toastController: ToastController,
    private datePipe: DatePipe,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public fileupload: FileUploadService,
    public popoverCtrl: PopoverController,
    public addCall: AddCall,
    private payment: Payment,
    public activeRoute: ActivatedRoute,
    public common: CommonService,
    private http: HttpClient,
    public cdr: ChangeDetectorRef,
    public geolocation: Geolocation,
    public platform: Platform,
    private file: File,
    private fileOpener: FileOpener,
    private httpClient: HttpClient,
  ) {
    console.log('from booking=====');
    // this.acceptTerms = true
  }
  async ngOnInit() {
    this.activeRoute.queryParams.subscribe((params:any) => {
      this.sendLinkid = params['id'];  
      localStorage.setItem('bookindId', this.sendLinkid);
      console.log('ID from URL:', this.sendLinkid);
    });
     await this.paymentCheck()
    // this.localClear();
    localStorage.setItem('VendorType', "8");
    console.log("paymentstatus paymentstatus",localStorage.getItem("paymentstatus"))
    this.rate = 3;
  }

  async paymentCheck() {
    console.log("paymentssss",localStorage.getItem("paymentstatus"))
    if (localStorage.getItem("paymentstatus") == "cancel") {
      await this.localClear();
    } else if (localStorage.getItem("paymentstatus") == "completed") {
      let payloaddata = {
        bookId: localStorage.getItem('bookindId'),
        paymentId: localStorage.getItem('resultindicator'),
        sessionid: localStorage.getItem('session'),
        referrence: localStorage.getItem("referenceid"),
        orderId: localStorage.getItem("order_on"),
        paymentGatewayName: localStorage.getItem("gatewayName"),
        paymentGatewayId :localStorage.getItem("gatewayId"),
        paymentStatus: "C",
        status: 1,
        result: "Success",
        amount : localStorage.getItem("paymentAmt")
      }
      console.log("paymentssss cc",payloaddata)
      if("KNET" == payloaddata.paymentGatewayName){
        await this.paymentGatewayFunction(payloaddata, "KNET");
      }else{
        await this.paymentGatewayFunction(payloaddata, "MASTER");
      }
      console.log(payloaddata);
      let data = JSON.parse(localStorage.getItem("paymentObject"));
      await this.localClear();
    } else if (localStorage.getItem("paymentstatus") == "failed") {
      this.localClear();
    }
  }
  async localClear () {
    localStorage.removeItem("paymentstatus")
    localStorage.removeItem("resultindicator")
    localStorage.removeItem("session")
    localStorage.removeItem("order_on")
    localStorage.removeItem("paymentGatewayName")
    localStorage.removeItem("requestdata")
    localStorage.removeItem("gatewayName");
    localStorage.removeItem("gatewayId");
  }

  isSaveLatertime: any;
  isUpdateBtn: any;
  isSaveSelectLaterCheatDay: boolean = false;
  selected_daysSave: any;
  patient_id_walk :any;
  vendor_id_walk : any;
  async ionViewWillEnter() {
    this.isShow = true;
    await this.getWalkinPaymentDetails()
    await this.getVendorPaymentGateway() 
    // this.activeRoute.queryParams.subscribe((params:any) => {
    //   this.sendLinkid = params['id'];  
    //   localStorage.setItem('bookindId', this.sendLinkid);
    //   console.log('ID from URL:', this.sendLinkid);
    // });
    

  }




  async getWalkinPaymentDetails(){
    console.log("getWalkinPaymentDetails func")
    const requestdata = {
      "id": this.sendLinkid
  }
    this.DietReq = this.services.postRequest("getWalkinPaymentDetails", requestdata).subscribe(async response => {
      const data = response.data;
      this.Email = data[0].email;
      this.Phoneno = data[0].mobile_number;
      localStorage.setItem("patient_id", data[0].patient_id);
      localStorage.setItem("vendor_id", data[0].vendor_id);
      localStorage.setItem("Email", data[0].email);
      if (data[0].Paymentstatus == "Already Paid" && localStorage.getItem("paymentstatus") != "completed") {
        console.log("Already Paid  condition")
        this.presentView = "paid";
        localStorage.setItem("walkPaymentstatus", data[0].Paymentstatus)
      } else if (data[0].Paymentstatus == "Payable") {
        // this.presentView = "";
        localStorage.setItem("walkPaymentstatus", data[0].Paymentstatus);
        await this.paymentProfilefunc();
      } 
      else {
        await this.paymentProfilefunc();
        console.log(data);
      }
    })
  }



//   async getVendorPaymentGateway() {
//     const data = {
//         vendor_id: localStorage.getItem("vendor_id") || "",
//     };
//     try {
//       const response1 = this.services.postRequest2("getVendorPaymentGateway", data).subscribe(async response => {
//         if (response.data.data.length > 0) {
//           const gateways = response.data.data;
//           this.PaymentGateways = gateways;
//           const selectedPayments = await this.getSelectedVendorPayment();
          
//           const selectedGatewayIds = selectedPayments.map(payment => payment.gateway_id);
//           const filteredGateways = gateways.filter(gateway =>
//               selectedGatewayIds.includes(gateway.gateway_id)
//           );
//           console.log("filteredGateways", filteredGateways);
//           this.PaymentGateways = filteredGateways;
//           console.log("this.PaymentGateways this.PaymentGateways",this.PaymentGateways)
//       }
//       })
   
//     } catch (error) {
//         console.error(error);
//     }
// };

// async getSelectedVendorPayment(){
//   const data = {
//       vendor_id: localStorage.getItem("vendor_id") || "",
//   };
//   try {
//     const response1 = this.services.postRequest2("getSelectedVendorPaymentGateway", data).subscribe(async response => {
//       if (response.data.data.length > 0) {
//         return response.data.data; // Return selected payment gateways
//     }
//     return [];
//     })

//   } catch (error) {
//       console.error(error);
//       return [];
//   }
// };


async getVendorPaymentGateway() {
  let apiData = {
      vendor_id: localStorage.getItem("vendor_id") || "",
  };
  try {
    this.services
    .postRequest2('getVendorPaymentGateway', apiData)
    .subscribe(async (res) => {
      console.log("response1response1,",res)
      if (res.data.length > 0) {
          var gateways = res.data;
          this.PaymentGateways = gateways;
          this.services
          .postRequest2('getSelectedVendorPaymentGateway', apiData)
          .subscribe(async (res) => {
            console.log("resres",res.data.length)
            if (res.data.length > 0) {
              debugger;
              console.log("resres If", res.data.length);
          
              // Extract `res.data` for processing, assuming `res` is an object
              var selectedGatewayIds = res.data.map((payment: { gateway_id: any }) => payment.gateway_id);
          
              // Filter gateways using the extracted gateway IDs
              console.log("gatewaysgateways",gateways)
              var filteredGateways = gateways.filter((gateway: { gateway_id: any }) =>
                  selectedGatewayIds.includes(gateway.gateway_id)
              );
          
              console.log("Filtered Gateways", filteredGateways);
                this.PaymentGateways = filteredGateways;
                console.log("this.PaymentGateways", this.PaymentGateways);
                // return res.data; // Return selected payment gateways
            }
          })




          // let selectedPayments = await this.getSelectedVendorPayment();
          // console.log("selectedPayments",selectedPayments)
          // let selectedGatewayIds = selectedPayments.map(payment => payment.gateway_id);

          // let filteredGateways = gateways.filter(gateway =>
          //     selectedGatewayIds.includes(gateway.gateway_id)
          // );

          // console.log("filteredGateways", filteredGateways);
          // this.PaymentGateways = filteredGateways;
          // console.log("this.PaymentGateways", this.PaymentGateways);
      }
    })
  } catch (error) {
      console.error(error);
  }
}







async paymentProfilefunc(){
try {
  let apiData = JSON.stringify({
    send_link_id: this.sendLinkid,
  });
 this.services
    .postRequest('getDietWalkinDet', apiData)
    .subscribe((res) => {
      console.log(res);
      if (res.data.length > 0) {
        console.log("res.data", res.data);
        this.patient_id_walk = res.data[0].patient_id,
        this.vendor_id_walk = res.data[0].vendor_id, 
        this.tempMemberName = res.data[0].name,
        this.Phoneno = res.data[0].mobile_number,
        this.Email_w = res.data[0].email,
        localStorage.setItem("vendor_id",this.vendor_id_walk);
        this.selectProfile(res.data[0].vendor_id);
      }
    });  
} catch (error) {
  console.log("error")
}
}





  // async ionViewWillEnter() {
  //   this.selectProfile(1270);
  //   this.backValue = 'goHome';
  //   const loading = await this.loadingCtrl.create({
  //     message: 'Please wait...',
  //   });
  //   await loading.present();
  //   await this.location();
  //   console.log("this.backValue", this.backValue)
  //   this.dietCheckboxBtn = true;
  //   if (Number(this.activeRoute.snapshot.paramMap.get('booking_id')) == 0) {
  //     this.getAdd();
  //   }
  //   this.finalArrayFood = [];
  //   this.addCall.changeDateLan(new Date());
  //   setTimeout(async () => {
  //     if (this.activeRoute.snapshot.paramMap.get('booking_id')) {
  //       this.booking_id = parseInt(
  //         this.activeRoute.snapshot.paramMap.get('booking_id')
  //       );
  //       let apidata = JSON.stringify({
  //         booking_id: this.booking_id,
  //       });
  //       this.services
  //         .postRequest('getDietBookingById', apidata)
  //         .subscribe(async (res) => {
  //           if (res.data.length > 0) {
  //             this.bookdeddata_view = res.data[0];
  //             this.from_date = this.bookdeddata_view.from_date;
  //             if (new Date(this.from_date) > new Date()) {

  //               this.after48hours_view = this.from_date;
  //             }
  //             else {
  //               this.after48hours_view = this.calculdate48HoursFromCurrentDate();

  //             }
  //             let dateAfter48Hours = new Date(this.after48hours_view);
  //             let todiffDate_view = new Date(this.bookdeddata_view.to_date);
  //             dateAfter48Hours.setHours(0, 0, 0, 0);
  //             todiffDate_view.setHours(0, 0, 0, 0);

  //             const dayNameToId = {
  //               Sun: 0,
  //               Mon: 1,
  //               Tue: 2,
  //               Wed: 3,
  //               Thu: 4,
  //               Fri: 5,
  //               Sat: 6,
  //             };
  //             const dayNameToIdarabic = {
  //               'الأحد': 0,
  //               "الاثنين": 1,
  //               'الثلاثاء': 2,
  //               'الأربعاء': 3,
  //               'الخميس': 4,
  //               'الجمعة': 5,
  //               'السبت': 6
  //             };

  //             let cheatDayIds = this.bookdeddata_view.cheat_days
  //               .split(',')
  //               .map((day) => dayNameToId[day] || dayNameToIdarabic[day]);
  //             let includedDates_view = [];
  //             for (
  //               let d = new Date(dateAfter48Hours);
  //               d <= todiffDate_view;
  //               d.setDate(d.getDate() + 1)
  //             ) {
  //               if (!cheatDayIds.includes(d.getDay())) {
  //                 let formattedDate = `${d.getDate().toString().padStart(2, '0')}-${(
  //                   d.getMonth() + 1
  //                 )
  //                   .toString()
  //                   .padStart(2, '0')}-${d.getFullYear()}`;
  //                 includedDates_view.push(formattedDate);
  //               }
  //             }
  //             let menu_items_view = JSON.parse(this.bookdeddata_view.menu_items);
  //             this.menu_item_details_list = menu_items_view;
  //             let menuDates_view = menu_items_view.map((item) => item.date);
  //             this.total_selected_date = menuDates_view.map((selected) => ({
  //               ...selected,
  //               date: this.formatDatetocorrect(selected)
  //             }));

  //             this.allDatesFound = true;
  //             for (let date of includedDates_view) {
  //               if (!menuDates_view.includes(date)) {
  //                 this.allDatesFound = false;
  //                 break;
  //               }
  //             }
  //             this.acceptTerms = true;
  //             this.saveandselect = true;
  //             let data = res.data[0];
  //             this.isUpdateBtn = true;
  //             this.acceptTerms = true;
  //             this.package_id = data.diet_package_id;
  //             this.DeliveryAddress = data.delivery_address
  //             const deliveryTimeDetails = JSON.parse(data.delivery_time_details);
  //             const deliverytime = deliveryTimeDetails.map((obj: any) => {
  //               return {
  //                 id: obj.delivery_time_id,
  //                 value:
  //                   moment(obj.from_time, 'HH:mm:ss.SSSSSS').format('hh:mm a') +
  //                   ' - ' +
  //                   moment(obj.to_time, 'HH:mm:ss.SSSSSS').format('hh:mm a'),
  //               };
  //             });
  //             const targetDeliveryTime = deliverytime.find((item: any) => item.id === data.delivery_time_id);
  //             this.delivery_time = targetDeliveryTime.value;
  //             this.delivery_instruction = data.delivery_instructions
  //             this.Phonno = data.delivery_contact_no
  //             this.duration_id = data.package_duration_id;
  //             this.duration_detail_id = data.package_duration_detail_id;
  //             this.durationDays = data.duration_days;
  //             this.diet_package_name = data.package_name;
  //             this.cheat_day =
  //               data.cheat_days != '' ? data.cheat_days.split(',') : '';
  //             this.isSaveSelectLaterCheatDay = false;
  //             this.generateCheatDaysArray();
  //             this.is_save_later = data.is_save_later == 1 ? true : false;
  //             this.save_and_select = data.is_save_later;
  //             this.dietFromDate = data.from_date.split('T')[0];
  //             this.storeDietFromDate = this.getFormattedDateTime(
  //               new Date(data.from_date),
  //               'Date1'
  //             );
  //             this.dietToDate = data.to_date.split('T')[0];
  //             this.dietToDate = data.to_date;
  //             this.selected_daysSave = data.selected_days;
  //             var edited_diet_menu_changed = JSON.parse(data.menu_items);
  //             this.edited_diet_menu = edited_diet_menu_changed.sort((a, b) => {
  //               let dateA = new Date(a.date.split('-').reverse().join('-')).getTime();
  //               let dateB = new Date(b.date.split('-').reverse().join('-')).getTime();
  //               return dateA - dateB; 
  //             });
  //             data.delivery_time_details = JSON.parse(
  //               data.delivery_time_details
  //             );
  //             if (data.delivery_time_details.length > 0) {
  //               if (this.addCall.selectedLanguage != 'ea') {
  //                 this.package_general_detail_data =
  //                   data.delivery_time_details.map((obj: any) => {
  //                     return {
  //                       id: obj.delivery_time_id,
  //                       value:
  //                         moment(obj.from_time, 'HH:mm:ss.SSSSSS').format(
  //                           'hh:mm a'
  //                         ) +
  //                         ' - ' +
  //                         moment(obj.to_time, 'HH:mm:ss.SSSSSS').format(
  //                           'hh:mm a'
  //                         ),
  //                     };
  //                   });
  //               } else if (this.addCall.selectedLanguage == 'ea') {
  //                 this.package_general_detail_data =
  //                   data.delivery_time_details.map((obj: any) => {
  //                     return {
  //                       id: obj.delivery_time_id,
  //                       value:
  //                         moment(obj.to_time, 'HH:mm:ss.SSSSSS').format(
  //                           'hh:mm a'
  //                         ) +
  //                         ' - ' +
  //                         moment(obj.from_time, 'HH:mm:ss.SSSSSS').format(
  //                           'hh:mm a'
  //                         ),
  //                     };
  //                   });
  //               }
  //             } else {
  //               this.package_general_detail_data = [];
  //             }
  //             let time = this.package_general_detail_data.find(
  //               (x) => x.id == data.delivery_time_id
  //             );
  //             this.delivery_time_id = time.id;
  //             this.edited_data = data;
  //             this.selectProfile(data.diet_vendor_id);
  //           }
  //           await loading.dismiss();
  //         });
  //     } else {
  //       console.log('this.common.profileaddress', this.common.profileaddress);
  //       this.deal_dealid = null;
  //       this.isShow = true;
  //       this.instadd = null;
  //       this.instra = [];
  //       this.instra1 = [];
  //       this.offerSoring = false;
  //       this.rateSortOrder = 'ASC';
  //       this.offrSortOrder = 'ASC';
  //       this.weekvalue = this.addCall.title686 + "1";
  //       this.wekary = [];
  //       this.temp_ary = [];
  //       this.EmptyData = null;
  //       this.searchValue = '';
  //       this.resetDietVariabels();
  //       switch (localStorage.getItem('NopayGoBack')) {
  //         case 'newEnter': {
  //           setTimeout(async () => {
  //             this.showListDietPage();
  //             await loading.dismiss();
  //           }, 90);

  //           break;
  //         }
  //         case 'BookingConPage': {
  //           this.confirmBook();
  //           await loading.dismiss();
  //           break;
  //         }
  //         default: {
  //           this.showListDietPage();
  //           await loading.dismiss();
  //         }
  //       }

  //       await loading.dismiss();
  //     }
  //   }, 1500);
  // }



  async location() {
    try {
      let options = {
        enableHighAccuracy: true,
        timeout: 5000
      };
      await this.geolocation.getCurrentPosition(options).then((resp) => {
        this.LocationIcon = true;
        this.latitude = resp.coords.latitude;
        this.longitude = resp.coords.longitude;
        console.log("this.latitude,this.longitude", this.latitude, this.longitude)
      }, err => {
        this.LocationIcon = false;
        this.latitude = 29.62107798734671;
        this.longitude = 47.587719496877924;
        console.log('Error getting location', err);
        console.log("this.latitude,this.longitude", this.latitude, this.longitude)
      });
    } catch (error) {
      this.lattitude = 29.62107798734671;
      this.longititude = 47.587719496877924;
    }
  }




  formatDatetocorrect(date: string): string {
    // Use regex to check if the date is already in YYYY-MM-DD format
    const isCorrectFormat = /^\d{4}-\d{2}-\d{2}$/.test(date);

    if (isCorrectFormat) {
      // If already in YYYY-MM-DD, return as is
      return date;
    }

    // Otherwise, reformat from DD-MM-YYYY to YYYY-MM-DD
    const dateParts = date.split('-'); // Split the date by '-'
    const day = dateParts[0];          // Extract day
    const month = dateParts[1];        // Extract month
    const year = dateParts[2];         // Extract year

    // Rearrange to 'YYYY-MM-DD' format
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  }


  isDateInSelectedDates(itemDate: string): boolean {
    this.finalArrayFood_dates = this.finalArrayFood.map((foodItem) => ({
      ...foodItem,
      selectedDate: this.formatDatetocorrect(foodItem.selectedDate)
    }));
    // const isInTotalSelectedDates = this.total_selected_date.some(selectedDate => selectedDate.date === itemDate);
    const isInFinalArrayFood = this.finalArrayFood_dates.some(foodItem => foodItem.selectedDate === itemDate);
    // isInTotalSelectedDates ||
    return isInFinalArrayFood;
  }


  async OpenMapMethod(dietcompanyname: any, vendor_address: any, vendor_latlong: any) {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: dietcompanyname,
        clinic_address: vendor_address,
        clinic_lat_long: vendor_latlong,
      }
    });
    modal.onDidDismiss()
      .then((data) => {
        if (data.data == "Map_Not_Show") {
          //  this.ionViewWillEnter();
        }
      });
    return await modal.present();
  }

  generateCheatDaysArray() {
    let cheat_days = [];
    for (let index = 0; index <= this.cheat_day.length; index++) {
      if (this.cheat_day[index] != undefined) {
        let obj = {
          value: '',
          is_checked: true,
          day: 0,
          days: '',
        };
        switch (this.cheat_day[index]) {
          case 'Mon':
            (obj.value = 'Mon'),
              (obj.day = 1),
              (obj.days = 'Mon'),
              (obj.is_checked = true);
            break;
          case "الاثنين":
            (obj.value = "الاثنين"),
              (obj.day = 1),
              (obj.days = "الاثنين"),
              (obj.is_checked = true);
            break;
          case 'Tue':
            (obj.value = 'Tue'),
              (obj.day = 2),
              (obj.days = 'Tue'),
              (obj.is_checked = true);
            break;
          case 'الثلاثاء':
            (obj.value = 'الثلاثاء'),
              (obj.day = 2),
              (obj.days = 'الثلاثاء'),
              (obj.is_checked = true);
            break;
          case 'Wed':
            (obj.value = 'Wed'),
              (obj.day = 3),
              (obj.days = 'Wed'),
              (obj.is_checked = true);
            break;
          case 'الأربعاء':
            (obj.value = 'الأربعاء'),
              (obj.day = 3),
              (obj.days = 'الأربعاء'),
              (obj.is_checked = true);
            break;
          case 'Thu':
            (obj.value = 'Thu'),
              (obj.day = 4),
              (obj.days = 'Thu'),
              (obj.is_checked = true);
            break;
          case 'الخميس':
            (obj.value = 'الخميس'),
              (obj.day = 4),
              (obj.days = 'الخميس'),
              (obj.is_checked = true);
            break;
          case 'Fri':
            (obj.value = 'Fri'),
              (obj.day = 5),
              (obj.days = 'Fri'),
              (obj.is_checked = true);
            break;
          case 'الجمعة':
            (obj.value = 'الجمعة'),
              (obj.day = 5),
              (obj.days = 'الجمعة'),
              (obj.is_checked = true);
            break;
          case 'Sat':
            (obj.value = 'Sat'),
              (obj.day = 6),
              (obj.days = 'Sat'),
              (obj.is_checked = true);
            break;
          case 'السبت':
            (obj.value = 'السبت'),
              (obj.day = 6),
              (obj.days = 'السبت'),
              (obj.is_checked = true);
            break;
          case 'Sun':
            (obj.value = 'Sun'),
              (obj.day = 7),
              (obj.days = 'Sun'),
              (obj.is_checked = true);
            break;
          case 'الأحد':
            (obj.value = 'الأحد'),
              (obj.day = 7),
              (obj.days = 'الأحد'),
              (obj.is_checked = true);
            break;
          default:
            break;
        }
        cheat_days.push(obj);
      }
    }
    this.cheat_day = [];
    this.cheat_day = cheat_days;
    this.cheat_days = cheat_days;
  }

  getMasterMenuList() {
    let data = {
      vendor_id: this.storeDietVendorId,
      module: 'MasterMenu',
    };

    this.services.dietRequest('getMasterMenus', data).subscribe(
      (res) => {
        if (res.data.length > 0) {
          let diet_menu_list = [];
          res.data.map((obj) => {
            obj['is_active'] = false;
            diet_menu_list.push(obj);
          });
          this.diet_menu_list = diet_menu_list;
          this.getMasterList();
        } else {
          this.diet_menu_list = [];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getMasterList() {
    let data = {
      vendor_id: this.storeDietVendorId,
      module: this.booking_id > 0 ? "Bookedmenu" : "managepackage",
    };

    this.services.dietRequest('getMasterMenuItemList', data).subscribe(
      (res) => {
        if (res.data.length > 0) {
          const uniqueMasterMenuIds = [
            ...new Set(res.data.map((item) => item.master_menu_id)),
          ];
          let master_menu_list = [];
          uniqueMasterMenuIds.map((menu_id) => {
            let menu_detail =
              this.diet_menu_list.find(
                (diet_menu) => diet_menu.master_menu_id == menu_id
              ) || {};
            let item_list = res.data.filter(
              (data) => data.master_menu_id == menu_id
            );
            item_list = item_list.map((data, index) => {
              if (data.is_delete == '0' || data.is_active == '0') {
                let available_dates = this.menu_item_details_list.filter(item => item.diet_menu_id === menu_id && item.diet_menu_item_id === data.item_id).map(item => item.date);
                if (available_dates) {

                  data['available_date'] = available_dates.join(',');
                  available_dates = [];
                }
              }
              data['order_no'] = index + 1;
              return data;
            });
            let obj = {
              package_name: menu_detail.master_menu_name || '',
              id: menu_id,
              item_list: item_list,
            };
            master_menu_list.push(obj);
          });
          this.master_menu_list = master_menu_list;
          if (this.booking_id > 0) {
            this.getPackageDetailMenu();
            this.getDurationDetail();
            // this.getPackageGeneralDetail();
          }
        } else {
          this.master_menu_list = [];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  checkdr() {
    console.log('checking ng test ', this.ide);
  }

  commonheadervalue: string = 'Dietheader';
  ngOnChanges() {
    this.commonheadervalue = 'commonbooking';
    // create header using child_id
    console.log(this.showTypeofBooking);
    if (this.showTypeofBooking == 'booking' || this.showTypeofBooking == '') {
      this.bookingListPage();
    } else if (this.showTypeofBooking == 'booking hitory') {
      this.canBookingListPage();
    }
  }

  // ionViewWillLeave() {
  //   this.duration_id = "";
  //   this.package_list = []
  //   this.dution_detail_data = []
  //   this.package_general_detail_data = []
  //   this.EmptyData = null;
  //   this.scrollEvent = null;
  //   this.resetDietVariabels();
  //   this.currentPlaying.muted = true
  //   this.isMuteVideo = false;
  // }
  Videobruff(el) {
    return true;
  }

  // async onImageLongPress(food: any ,status: any) {
  //
  //   this.calories_visible = true;
  // }
  //   onMouseUp() {
  //     this.calories_visible = false;
  //   clearTimeout(this.mouseDownTimer); // Cancel the long-press action
  // }

  ionViewDidLeave() {
    const inViewPort = this.vdoPlayer.find((player) =>
      this.Videobruff(player.nativeElement)
    );
    if (inViewPort) {
      inViewPort.nativeElement.pause();
    }
    this.didScrollEvent('leave');
    this.isMuteVideo = false;
    this.acceptTerms = false

    this.common.videoSound = false;
    if (this.currentPlaying) {
      this.currentPlaying.muted = true;
      this.currentPlaying?.pause();
      this.currentPlaying = null;
    }
    this.duration_id = '';
    this.package_list = [];
    this.dution_detail_data = [];
    this.package_general_detail_data = [];
    this.EmptyData = null;
    this.scrollEvent = null;
    this.resetDietVariabels();
    setTimeout(() => {
      this.duration_id = '';
      this.package_list = [];
      this.dution_detail_data = [];
      this.package_general_detail_data = [];
      this.EmptyData = null;
      this.scrollEvent = null;
      this.resetDietVariabels();
      this.didScrollEvent('leave');
      this.isMuteVideo = false;
      this.acceptTerms = false
      this.common.videoSound = false;
      if (this.currentPlaying) {
        this.currentPlaying.muted = true;
        this.currentPlaying?.pause();
        this.currentPlaying = null;
      }
    }, 500);
  }

  // ------\/-------PRE DEFINE FUNCTION-----\/----------//

  doRefresh(event: any, pageType: any) {
    this.refEvent = event;
    this.getDietCompanyList = [];
    this.pageNo = 1;
    this.EmptyData = null;
    if (pageType == 'listDiet') {
      this.getDietCompanyList = null;
      this.showListDietPage();
    } else if (pageType == 'listDietPkg') {
      this.selectProfile(this.storeDietVendorId);
    } else if (pageType == 'listBkgPage') {
      if (this.MealbookingList) {
        this.storeBookingList = [];
        this.bookingList();
      } else if (this.CanMealbookingList) {
        this.storeBookingHisList = [];
        this.canBookingList();
      }
    }
  }
  async presentToast(msg: any) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  loadData1(event: any) {
    if (this.loaddata) {
      this.scrollEvent = event;
      this.pageNo += 1;
      this.showListDietPage();
    }
    event.target.complete();
  }

  loadData(event: any, page: any) {
    this.scrollEvent = event;
    this.pageNo += 1;
    if (page == 'listBkgPage') {
      if (this.MealbookingList) {
        this.bookingList();
      } else if (this.CanMealbookingList) {
        this.canBookingList();
      }
    }
  }
  // onLongPress(event: any,data: any, i: any): void {
  //   // event.preventDefault();
  //
  //   this.clearLongPressTimer();
  //   this.longPressTimer = setTimeout(() => {
  //     // this.selectFood(data, i)
  //     console.log("Long press start");
  //     this.calories_visible = true;
  //     this.pressindex =data.item_id
  //     this.clearLongPressTimer();
  //   }, this.LONG_PRESS_DURATION);
  // }

  onMouseDown(event: MouseEvent, data: any, i: any): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.booking_id == 0) {
      this.calories_visible = true;
      this.pressindex = data.item_id;
      this.clearLongPressTimer();
      this.longPressTimer = setTimeout(() => {
        console.log('Long press detected.');
      }, this.LONG_PRESS_DURATION);
    }
  }
  async onTouchEnd(event: TouchEvent, food: any, index: number) {
    this.clearLongPressTimer();
    this.calories_visible = false;
    if (!this.isScrolling) {
      await this.selectFood(event, food, index);
    }
    console.log('Touch ended.');
  }

  async selectfooditems(event, data, i) {
    event.stopPropagation();
    event.preventDefault();
    if (!this.isLongPress && !this.isScrolling) {
      await this.selectFood(event, data, i);
    }
  }
  onTouchStart(event: TouchEvent, data: any, i: any): void {


    this.isLongPress = false;
    this.isScrolling = false;
    this.clearLongPressTimer();
    this.longPressTimer = setTimeout(() => {
      if (!this.isScrolling) {
        this.isLongPress = true;
        event.preventDefault();
        console.log('Long press start');
        this.calories_visible = true;
        this.pressindex = data.item_id;
        this.clearLongPressTimer();
      }
    }, this.LONG_PRESS_DURATION);
  }

  private clearLongPressTimer(): void {
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }
  }

  async openDatePicker() {
    if (this.selectedsdate == undefined || this.selectedsdate == '') {
      this.currentDatevalue = new Date();
      let daysToAdd = parseInt(this.datevalue);
      this.currentDatevalue.setDate(
        this.currentDatevalue.getDate() + (daysToAdd + 1)
      );
    }
    if (this.booking_id == 0) {
      const datePickerModal = await this.modalCtrl.create({
        component: DatePikerPage,
        cssClass: 'datePicker',
        componentProps: {
          selectedDate: this.selectedDate,
          calenderType: 'dietnormal',
          cheat_days_list: this.cheat_days,
          diet_from_date: this.dietFromDate,
          startDateselect:
            this.selectedsdate == undefined || this.selectedsdate == ''
              ? this.currentDatevalue
              : this.selectedsdate,
          disabled: this.initalValueDisabled,
          curdate:
            new Date().toString().split(' ')[0] +
            ', ' +
            new Date().toString().split(' ')[1] +
            ' ' +
            new Date().toString().split(' ')[2], //normal/dob
        },
      });
      await datePickerModal.present();

      datePickerModal.onDidDismiss().then((data) => {


        if (data.data != undefined) {
          let currentDate = new Date();
          currentDate.setDate(currentDate.getDate() + parseInt(this.datevalue));
          let checkTimestamp = currentDate.getTime();
          let checkDate = new Date(checkTimestamp);
          console.log(checkDate);
          this.calPerDay = 0;
          this.finalArrayFood = [];
          this.selectedsdate = data.data;
          if (data.data) {
            if (checkDate < data.data) {
              this.Date = data.data;
              let getDay = new Date(this.Date);
              this.getDayId = getDay.getDay() + 1;

              this.storeDietFromDate = this.getFormattedDateTime(
                this.Date,
                'Date1'
              );
              this.dietFromDate =
                this.Date.getFullYear() +
                '-' +
                ('0' + (this.Date.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + this.Date.getDate()).slice(-2);
              // For Select Date is Cheat day or not

              let date = new Date(this.dietFromDate);
              let popupShown = false;
              if (this.cheat_days != "") {

                while (this.isCheatDay(date)) {
                  // If it's a cheat day, add one day to the date
                  if (!popupShown) {
                    this.openStartDateModel('This is a cheat day. Please select some other day.');
                    popupShown = true;
                  }
                  date.setDate(date.getDate() + 1);
                }
              }
              this.dietFromDate = this.getFormattedDateTime(
                date,
                'Date1'
              );
              this.storeDietFromDate = this.dietFromDate;

              // let day = date.getDay();
              // let dayName = Days[day];
              // let dayNameinarabic = Daysinarabic[day];
              // if (this.cheat_days.length > 0) {
              //   let isCheatDay = this.cheat_days.filter(
              //     (x) => x.value == dayName || x.value == dayNameinarabic
              //   );
              //   if (isCheatDay.length > 0) {
              //     this.storeDietFromDate = null;
              //     this.dietFromDate = null;
              //     this.openStartDateModel(
              //       'This is a cheat day. Please select some other day.'
              //     );
              //     return;
              //   }
              // }
              getDay.setDate(getDay.getDate() + (this.durationDays - 1));
              this.Date = getDay;
              // To Set is a Cheat Day or Not

              this.dietToDate =
                this.Date.getFullYear() +
                '-' +
                ('0' + (this.Date.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + this.Date.getDate()).slice(-2);
              //this.splitIntoWeeks()
              this.week = '1';
              this.generateWeekArray();
              this.setDayOrder();
              this.pushDietPerDay();
            } else {
              let test =
                'Booking can be done ' +
                this.datevalue +
                ' days from current date.';
              this.openStartDateModel(test);
            }
          }
        }
      });
    }
  }

  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    await alert.present();
    alert.onDidDismiss().then((data) => {
      let mdlctrl_res = data.data;
      if (mdlctrl_res == 'yes') {
        this.selectProfile(this.pariculardiet);
      }
    });
  }
  // ------/\-------PRE DEFINE FUNCTION-------/\--------//

  // -------\/------SOME SPECIAL FUNCTION------\/---------//

  selectFilterCat(index, index2) {
    this.selected_pack.filterCatList[index2].choose =
      !this.selected_pack.filterCatList[index2].choose;
  }

  saltyss(index, index2, item) {
    console.log('item', item);
    console.log('choose', item.choose);
    if (!item.choose) {
      this.instruction = item.instruction;

      if (!this.instra.includes(item)) {
        this.instra.push(item.instruction);
      }

      console.log('true', this.instruction);
    } else {
      this.instruction = '';
      console.log('false', this.instruction);
      this.instra.splice(this.instra.indexOf(item.instruction), 1);
    }
    this.selected_pack.intructions[index2].choose =
      !this.selected_pack.intructions[index2].choose;
    console.log(this.instra);
  }
  spicess(value) {
    this.spice[value].value = !this.spice[value].value;
  }

  playVideo(index, Sindex, id, value) {
    this.playVid = document.getElementById(id);
    if (
      this.getDietCompanyList[index].dietmediaDetails[Sindex].playMode
    ) {
      this.playVid.pause();
      this.getDietCompanyList[index].dietmediaDetails[Sindex].playMode = false;
    } else {
      this.playVid.play();
      this.getDietCompanyList[index].dietmediaDetails[Sindex].playMode = true;
    }
  }

  checkVideo(id, index, Sindex) {
    let video = document.getElementById(id);
    let d = this;
    video.onended = function () {
      d.getDietCompanyList[index].dietmediaDetails[Sindex].playMode = false;
    };

  }

  onIntersection($event, id, index, Sindex) {
    const {
      [InViewportMetadata]: { entry },
      target,
    } = $event;
    const ratio = entry.intersectionRatio;

    const vid = target;
    let _obj = this;
    let playPromise;
    if (ratio == 1) {
      playPromise = vid.play();
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {
            vid.play();
            _obj.getDietCompanyList[index].dietmediaDetails[Sindex].playMode =
              true;
          })
          .catch((error) => {
            vid.pause();
            _obj.getDietCompanyList[index].dietmediaDetails[Sindex].playMode =
              false;
          });
      }
    }
    else {
      vid.pause();
    }
  }

  onIntersection1($event, id, index, Sindex) {
    console.log('event', $event);
    console.log('play', $event.target.autoplay);

    let _obj = this;
    const {
      [InViewportMetadata]: { entry },
      target,
    } = $event;
    const ratio = entry.intersectionRatio;
    const vid = target;
    if (!$event.visible) {
      console.log('condition');

      $event.target.autoplay = true;
    }
    let playPromise;
    console.log(
      'ratio -> ',
      ratio,
      'index---->',
      index,
      'screen height',
      window.screen.height
    );
    if (ratio == 1 || (ratio >= 0.25 && ratio <= 0.65)) {
      if (this.oldVideoTarget && this.oldVideoTarget != vid) {
        this.oldVideoTarget.pause();
      }
      playPromise = vid.play();
      this.oldVideoTarget = vid;
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {
            vid.play();
            _obj.getDietCompanyList[index].dietmediaDetails[Sindex].playMode =
              true;
            _obj.checkVideo(id, index, Sindex);
          })
          .catch((error) => {
            console.log('error so Pause : ', error);
            vid.pause();
            if (_obj.getDietCompanyList)
              _obj.getDietCompanyList[index].dietmediaDetails[Sindex].playMode =
                false;
          });
      }
    } else {
      if (
        _obj.getDietCompanyList[index]?.dietmediaDetails[Sindex].playMode ==
        true
      ) {
        vid.pause();
        _obj.getDietCompanyList[index].dietmediaDetails[Sindex].playMode =
          false;
      }
    }
  }

  playProVideo(id: any, value: any) {
    this.ProfileVideo = document.getElementById(id);
    if (this.playMode) {
      this.ProfileVideo.pause();
      this.playMode = false;
    } else {
      this.ProfileVideo.play();
      this.playMode = true;
    }
  }
  weekRepeatOff: any;
  weekRepeatOffValue: any[] = [];
  rep(event) {

    if (!this.allDatesFound) {
      this.no_repeat = false
      let weeks = this.wekary.filter((x) => x.id == this.weekDropdown);

      let alreadyRepeat = this.finalArrayFood.filter(
        (x) =>
          (x.week_name == this.week_name && x.isWeekRepeat == true) ||
          x.is_selected == true
      );
      if (alreadyRepeat.length > 0) {
        this.finalArrayFood = this.finalArrayFood.filter(
          (x) => x.week_name != this.week_name
        );
      }
      let weekRepeatOffCount = this.finalArrayFood.length;
      this.weekRepeatOffValue = [];
      this.changeWeeks = 'select';
      if (weeks.length > 0) {
        if (this.weekDropdown != undefined) {
          let repeatOff = this.finalArrayFood;
          for (let i = 0; i < this.weekdayarray.length; i++) {
            for (let j = 0; j < repeatOff.length; j++) {
              if (
                !this.weekdayarray[i].is_availdisabled &&
                !this.weekdayarray[i].is_cheat_day_available &&
                repeatOff[j].day_id == this.weekdayarray[i].day_id &&
                repeatOff[j].available_date.includes(
                  this.weekdayarray[i].date.split('-').reverse().join('-')
                ) &&
                repeatOff[j].day_name == this.weekdayarray[i].day_txt &&
                repeatOff[j].week_name == weeks[0].text
              ) {
                let data = {
                  item_id: repeatOff[j].item_id,
                  master_menu_id: repeatOff[j].master_menu_id,
                  item_name: repeatOff[j].item_name,
                  item_calories: repeatOff[j].item_calories,
                  item_protein: repeatOff[j].item_protein,
                  item_crab: repeatOff[j].item_crab,
                  item_fiber: repeatOff[j].item_fiber,
                  item_fat: repeatOff[j].item_fat,
                  available_date: repeatOff[j].available_date,
                  item_image_path: repeatOff[j].item_image_path,
                  is_active: 1,
                  created_at: '',
                  updated_at: null,
                  is_selected: true,
                  selectedDate: this.weekdayarray[i].date,
                  week_id: this.week,
                  isWeekRepeat: true,
                  repeatedWeekBy: weeks[0].id,
                  week_name: this.week_name,
                  day_name: this.weekdayarray[i].day_txt,
                  day_id: this.weekdayarray[i].day_id,
                };
                this.weekRepeatOffValue.push(data);
              }
            }
          }
          this.finalArrayFood.push(...this.weekRepeatOffValue);
          // After Week Repeat Off Get Count
          let WeekRepeatOffAfter = this.finalArrayFood.length;
          if (weekRepeatOffCount == WeekRepeatOffAfter) {
            this.no_repeat = true
            this.pushDietPerDay();
            this.loadDataForParticularDates();
            this.weekRepeatOffModel();
          } else {
            var availabledates = this.weekdayarray.filter(
              (x) => x.is_availdisabled == false && x.is_cheat_day_available == false
            );
            this.LoadInitialItemLoad(availabledates[0].date, 'SelectedDate');
            this.selectDate = availabledates[0].date;
            this.pushDietPerDay();
            this.loadDataForParticularDates();
          }
        }
        // }
      }
      this.checking = false;
    }
  }

  async weekRepeatOffModel() {
    const weekRepeatOffModel = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: 'weekRepeatOffModel',
        weekName: this.week_name,
      },
      cssClass: 'weekRepeatOffModel',
    });
    await weekRepeatOffModel.present();

    weekRepeatOffModel.onDidDismiss().then((data) => { });
  }
  month: any;
  week_name: any;
  changeWeeks: any;
  repeatOffChange: any;
  isUiWeekLoaded: any;
  selectWeek(value, index) {

    this.checking = true;
    this.changeWeeks = 'selectWeeks';
    this.weekdayarray = value.date_arr;
    this.week = value.week_id;
    this.week_name = value.week_name;
    this.month = value.month_name;
    this.LoadWeekRepeatOffSelect(value.week_id);
    let week = this.finalArrayFood.find(
      (x) => x.week_id == this.week && x.isWeekRepeat == true
    );
    if (week != undefined) {
      let weeksdrop = this.wekary.find((x) => x.id == week.repeatedWeekBy);
      this.weekDropdown = weeksdrop.id;
      this.isUiWeekLoaded = 1;
      // var weeks = this.wekary.filter(x => x.id == );
    } else {
      this.isUiWeekLoaded = 1;
      this.weekDropdown = '';
    }

    this.repeatOffChange = false;
    this.week_duration_detail_menu_list = value.duration_detail_menu_list;
    // Replace Week and Week Id When Change Week

    for (
      let index = 0;
      index < this.week_duration_detail_menu_list.length;
      index++
    ) {
      for (
        let i = 0;
        i < this.week_duration_detail_menu_list[index].item_list.length;
        i++
      ) {
        if (
          this.week_duration_detail_menu_list[index].item_list[i] != undefined
        ) {
          this.week_duration_detail_menu_list[index].item_list[i].week_id =
            this.week;
          this.week_duration_detail_menu_list[index].item_list[i].week_name =
            this.week_name;
        }
      }
    }

    let weekFirstDate;
    if (value.date_arr.length > 0) {
      for (let index = 0; index <= value.date_arr.length; index++) {
        if (
          value.date_arr[index] != undefined &&
          !value.date_arr[index].is_availdisabled &&
          !value.date_arr[index].is_cheat_day_available
        ) {
          weekFirstDate = value.date_arr[index];
          break;
        }
      }
    }
    this.selectDay(weekFirstDate, 0, 'Normal');
  }
  async openPopovr1(event: any, selecteddays: any, averagecalories: any) {

    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: event,
      translucent: true,
      componentProps: {
        from: 'diet_info',
        reportdata: this.addCall.selectedLanguage != 'ea' ? 'Average calories for the selected (' + (selecteddays) + ') days = ' + averagecalories : 'متوسط ​​السعرات الحرارية للأيام (' + (selecteddays) + ') المحددة = ' + averagecalories,
      },
      cssClass: this.addCall.selectedLanguage != 'ea' ? 'diet_info_css' : "arabic_diet_info_css",
    });
    return await popover.present();
  }

  Assign() {

    if (!this.allDatesFound) {
      this.no_repeat = false;
      this.isUiWeekLoaded = 0;
    }
  }
  isDisabled: any = true;
  LoadWeekRepeatOffSelect(week_id) {
    this.wekary = [];
    let weekValues = this.finalArrayFood.filter(
      (obj) => obj.week_id != week_id
    );
    if (weekValues.length > 0) {
      for (let index = 0; index < weekValues.length; index++) {
        let obj = {
          text: weekValues[index].week_name,
          id: weekValues[index].week_id,
        };
        this.wekary.push(obj);
      }
    }
    this.wekary = this.wekary.filter(
      (item, index, self) => index === self.findIndex((t) => t.id === item.id)
    );

    if (this.wekary.length == 0) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
  }
  // showCaloriesDetail(food : any,i): void {
  //
  //   this.calories_visible = true;
  //   this.pressindex = food.item_id;
  //   setTimeout(() => {
  //     this.calories_visible = false;
  //   }, 5000);
  // }

  mealsMaterMenu: any[] = [1, 2, 3, 4, 5, 6];
  snacksMasterMenu: any[] = [7, 8, 9];
  finalArrayFood: any[] = [];

  async selectFood(event: any, data: any, i: any) {

    if (!this.isScrolling && !this.allDatesFound) {
      event.stopPropagation();
      event.preventDefault();
      this.slideOpts.initialSlide = await i;
      this.showcoment = false;

      if (Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0) {
        let checkDate = this.calculdate72HoursFromCurrentDate();
        console.log(checkDate);
        let isDateFormat = this.isValidDateFormat(this.selectDate);
        let dates = new Date();
        if (!isDateFormat) {
          dates = this.formatDateToYYYYMMDD(this.selectDate);
        } else {
          dates = new Date(this.selectDate);
        }
        if (dates < checkDate) {
          console.log('Not able to Select becuase it is a 48 hours.');
          return;
        }
      }

      let isMeals = false;
      let isSnacks = false;

      if (this.finalArrayFood.length > 0) {
        // For the Meals Condition Check
        let count: any = this.finalArrayFood.filter(
          (x) =>
            x.selectedDate == this.selectDate &&
            this.mealsMaterMenu.includes(x.master_menu_id)
        );
        if (count.length >= this.numberOfMeals) {
          isMeals = true;
        }
        // For the Snacks Condition Check
        let snacksCount: any = this.finalArrayFood.filter(
          (x) =>
            x.selectedDate == this.selectDate &&
            this.snacksMasterMenu.includes(x.master_menu_id)
        );
        if (snacksCount.length >= this.numberOfSnacks) {
          isSnacks = true;
        }
      }

      let mealsitem = this.finalArrayFood.filter(
        (x) =>
          x.selectedDate == this.selectDate &&
          x.is_selected &&
          x.item_id == data.item_id &&
          this.mealsMaterMenu.includes(data.master_menu_id)
      );

      let snacksitem = this.finalArrayFood.filter(
        (x) =>
          x.selectedDate == this.selectDate &&
          x.is_selected &&
          x.item_id == data.item_id &&
          this.snacksMasterMenu.includes(data.master_menu_id)
      );

      // For the Same Master Menu Selected Another Item Condition
      let sameMealsItem = this.finalArrayFood.filter(
        (x) =>
          x.selectedDate == this.selectDate &&
          x.master_menu_id == data.master_menu_id
      );

      let sameSnakcsItem = this.finalArrayFood.filter(
        (x) =>
          x.selectedDate == this.selectDate &&
          x.master_menu_id == data.master_menu_id
      );

      if (isMeals || isSnacks) {
        if (
          isMeals &&
          this.mealsMaterMenu.includes(data.master_menu_id) &&
          mealsitem.length == 0 &&
          sameMealsItem.length != 1
        ) {
          this.presentToast(`Please select ${this.numberOfMeals} Meals Only`);
          return;
        }
        if (
          isSnacks &&
          this.snacksMasterMenu.includes(data.master_menu_id) &&
          snacksitem.length == 0 &&
          sameSnakcsItem.length != 1
        ) {
          this.presentToast(`Please select ${this.numberOfSnacks} Snacks Only`);
          return;
        }
      }

      let cal = this.calPerDay;
      let week_duration_detail_menu_list = [];
      let res = this.weekDietDetail.map((week: any) => {
        if (week.week_id === this.week) {
          return {
            ...week,
            duration_detail_menu_list: week.duration_detail_menu_list.map(
              (menu: any) => {
                if (menu.id === data.master_menu_id) {
                  return {
                    ...menu,
                    item_list: menu.item_list.map((item: any) => {
                      if (item.item_id === data.item_id) {
                        // if (Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0) {
                        //   for (let index = 0; index < this.finalArrayFood.length; index++) {
                        //     if (this.finalArrayFood[index].item_id == data.item_id && this.finalArrayFood[index].selectedDate == this.selectDate) {
                        //       this.finalArrayFood[index].is_selected = false;
                        //     }
                        //   }
                        // }
                        // Clone the item and update its is_selected property
                        if (!item.is_selected) {
                          cal = cal + parseInt(item.item_calories);
                          console.log('testing', cal);
                        } else {
                          cal = cal - parseInt(item.item_calories);
                          console.log('testing1222332', cal);
                        }
                        return { ...item, is_selected: !item.is_selected };
                      }
                      return item;
                    }),
                  };
                }
                return menu;
              }
            ),
          };
        }
        return week;
      });

      if (Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0) {
        if (this.finalArrayFood.length > 0) {
          var foodItemsSelect;
          let isDateValid = this.isValidDateFormat(this.selectDate);
          if (isDateValid) {
            foodItemsSelect = this.finalArrayFood.filter(
              (x) =>
                x.master_menu_id == data.master_menu_id &&
                (x.selectedDate ==
                  this.selectDate.split('-').reverse().join('-') ||
                  x.selectedDate == this.selectDate)
            );
          } else {
            foodItemsSelect = this.finalArrayFood.filter(
              (x) =>
                x.master_menu_id == data.master_menu_id &&
                x.selectedDate == this.selectDate
            );
          }

          if (foodItemsSelect.length >= 1) {
            for (let index = 0; index < this.finalArrayFood.length; index++) {
              if (
                this.finalArrayFood[index].master_menu_id ==
                data.master_menu_id &&
                this.finalArrayFood[index].selectedDate ==
                foodItemsSelect[0].selectedDate
              ) {
                this.finalArrayFood[index].is_selected = false;
                for (let k = 0; k < this.weekDietDetail.length; k++) {
                  if (this.weekDietDetail[k].week_id === this.week) {
                    for (
                      let h = 0;
                      h <
                      this.weekDietDetail[k].duration_detail_menu_list.length;
                      h++
                    ) {
                      const element =
                        this.weekDietDetail[k].duration_detail_menu_list[h];
                      if (element != undefined) {
                        for (let l = 0; l < element.item_list.length; l++) {
                          if (element.item_list[l] != undefined) {
                            if (
                              element.item_list[l].item_id != data.item_id &&
                              element.item_list[l].master_menu_id ==
                              data.master_menu_id
                            ) {
                              element.item_list[l].is_selected = false;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        if (this.finalArrayFood.length > 0) {
          foodItemsSelect = this.finalArrayFood.filter(
            (x) =>
              x.master_menu_id == data.master_menu_id &&
              x.selectedDate == this.selectDate
          );
          if (foodItemsSelect.length >= 1) {
            for (let index = 0; index < this.finalArrayFood.length; index++) {
              if (
                this.finalArrayFood[index].master_menu_id ==
                data.master_menu_id &&
                this.finalArrayFood[index].selectedDate == this.selectDate
              ) {
                this.finalArrayFood[index].is_selected = false;
                for (let k = 0; k < this.weekDietDetail.length; k++) {
                  if (this.weekDietDetail[k].week_id === this.week) {
                    for (
                      let h = 0;
                      h <
                      this.weekDietDetail[k].duration_detail_menu_list.length;
                      h++
                    ) {
                      const element =
                        this.weekDietDetail[k].duration_detail_menu_list[h];
                      if (element != undefined) {
                        for (let l = 0; l < element.item_list.length; l++) {
                          if (element.item_list[l] != undefined) {
                            if (
                              element.item_list[l].item_id != data.item_id &&
                              element.item_list[l].master_menu_id ==
                              data.master_menu_id
                            ) {
                              element.item_list[l].is_selected = false;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0) {
        this.finalArrayFood = this.finalArrayFood.filter(
          (x) => x.is_selected == true
        );
      }
      this.weekDietDetail = res;
      let filter_data = res.filter((obj) => {
        return obj.week_id == this.week;
      });
      this.week_duration_detail_menu_list =
        filter_data.length > 0
          ? filter_data[0]['duration_detail_menu_list']
          : [];
      for (
        let index = 0;
        index <= filter_data[0]['duration_detail_menu_list'].length;
        index++
      ) {
        let length = filter_data[0]['duration_detail_menu_list'];
        for (let y = 0; y <= length.length; y++) {
          let len = length[y];
          if (len != undefined) {
            for (let i = 0; i <= len.item_list.length; i++) {
              if (
                len.item_list[i] != undefined &&
                len.item_list[i].is_selected
              ) {
                len.item_list[i].selectedDate = this.selectDate;
                for (let k = 0; k < filter_data.length; k++) {
                  let date_arr = filter_data[k].date_arr;
                  for (let p = 0; p <= date_arr.length; p++) {
                    if (
                      date_arr[p] != undefined &&
                      date_arr[p].date == this.selectDate
                    ) {
                      len.item_list[i].week_id = filter_data[k].week_id;
                      len.item_list[i].week_name = filter_data[k].week_name;
                      len.item_list[i].day_name = date_arr[p].day_txt;
                      len.item_list[i].day_id = date_arr[p].day_id;
                    }
                  }
                }
                let item_id = len.item_list[i].item_id;
                const exists = this.finalArrayFood.some(
                  (obj) =>
                    obj.item_id == item_id &&
                    len.item_list[i].selectedDate == this.selectDate &&
                    obj.week_id == len.item_list[i].week_id &&
                    obj.day_name == len.item_list[i].day_name &&
                    obj.day_id == len.item_list[i].day_id
                );
                if (!exists) {
                  len.item_list[i].isWeekRepeat = false;
                  this.finalArrayFood.push(len.item_list[i]);
                }
              } else {
                for (let g = 0; g < this.finalArrayFood.length; g++) {
                  if (
                    len.item_list[i] != undefined &&
                    len.item_list[i].day_name != undefined &&
                    len.item_list[i].day_name ==
                    this.finalArrayFood[g].day_name &&
                    len.item_list[i].week_id ==
                    this.finalArrayFood[g].week_id &&
                    len.item_list[i].week_name ==
                    this.finalArrayFood[g].week_name &&
                    len.item_list[i].is_selected == false &&
                    len.item_list[i].item_id == this.finalArrayFood[g].item_id
                  ) {
                    this.finalArrayFood[g].is_selected = false;
                  }
                }
              }
            }
          }
        }
      }
      if (Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0) {
        console.log('For Save & Select Later');
      } else {
        this.finalArrayFood = this.finalArrayFood.filter(
          (obj) => obj.is_selected == true
        );
      }
      //  Calories Count/Day Per Day Based Object Calculates
      var calDay = 0;
      var selecteddate = this.changeDateFormat(this.selectDate);

      for (let index = 0; index < this.finalArrayFood.length; index++) {
        if (
          (this.finalArrayFood[index].selectedDate == selecteddate || this.finalArrayFood[index].selectedDate == this.selectDate) &&
          this.finalArrayFood[index].is_selected == true
        ) {
          calDay = calDay + Number(this.finalArrayFood[index].item_calories);
        }
      }
      this.calPerDay = calDay;

    }
  }

  isCheatDay(date) {
    let Days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let Daysinarabic = [
      'الأحد',
      'الاثنين',
      'الثلاثاء',
      'الأربعاء',
      'الخميس',
      'الجمعة',
      'السبت',
    ];
    let day = date.getDay();
    let dayName = Days[day];
    let dayNameinarabic = Daysinarabic[day];
    return this.cheat_days.some(
      (x) => x.value == dayName || x.value == dayNameinarabic
    );
  }
  changeDateFormat(dateString) {
    const parts = dateString.split('-');
    const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
    return formattedDate;
  }
  async onTouchMove(event: TouchEvent) {
    this.isScrolling = true;
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.isLongPress = false;
    }
  }

  calculdate72HoursFromCurrentDate(): any {
    let currentDate = new Date();
    let hoursToAdd = 48;
    let millisecondsToAdd = hoursToAdd * 60 * 60 * 1000;
    let futureDate = new Date(currentDate.getTime() + millisecondsToAdd);
    return futureDate;
  }
  calculdate48HoursFromCurrentDate(): any {
    ;
    if (new Date() < new Date(this.twodaysbefore)) {
      let currentDate = new Date(this.twodaysbefore);
      let hoursToAdd = 48;
      let millisecondsToAdd = hoursToAdd * 60 * 60 * 1000;
      let futureDate = new Date(currentDate.getTime() + millisecondsToAdd);
      return futureDate;
    } else {
      let currentDate = new Date();
      let hoursToAdd = 48;
      let millisecondsToAdd = hoursToAdd * 60 * 60 * 1000;
      let futureDate = new Date(currentDate.getTime() + millisecondsToAdd);
      return futureDate;
    }
  }
  getDateWithoutTime(date: Date): Date {
    const dateWithoutTime = new Date(date);
    dateWithoutTime.setHours(0, 0, 0, 0);
    return dateWithoutTime;
  }

  formatDateToYYYYMMDD(date): any {
    let dateParts = date.split('-');
    let day = dateParts[0];
    let month = dateParts[1];
    let year = dateParts[2];
    let dateObject = new Date(year, month - 1, day);
    let yyyy = dateObject.getFullYear();
    let mm = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    let dd = String(dateObject.getDate()).padStart(2, '0');
    let dateFormatString = `${yyyy}-${mm}-${dd}`;
    let dates = new Date(dateFormatString);
    return dates;
  }

  //old repeatMenu
  repeatMenu(event: any) {
    console.log('event', event);
    console.log('ngmodel', this.wekitem);
    let spl = this.wekitem.split(' ')[1];
    let splin = Number(spl) - 1;
    console.log('this.wekitem', splin);
  }
  repeat(item) {
    console.log('item', item);
  }

  selectDate: any;

  selectDay(value, index, type) {
    ;
    if (value != undefined) {
      this.type = type;
      this.day = value.day;
      this.calPerDay = 0;
      this.selectDate = value.date;
      this.swipe1 = !this.swipe1;
      this.storeDaysIndex = index;
      this.loadCalorgiesBasedOnDates();
      this.loadMenuItemList = [];
      this.loadDataForParticularDates();
      this.LoadInitialItemLoad(value.date, type);
      this.pushDietPerDay();
    }
  }

  loadCalorgiesBasedOnDates() {
    let calDay = 0;
    for (let index = 0; index < this.finalArrayFood.length; index++) {
      let validDate = this.isValidDateFormat(this.selectDate);
      if (
        validDate &&
        Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0
      ) {
        if (
          this.finalArrayFood[index].selectedDate == this.selectDate &&
          this.finalArrayFood[index].is_selected
        ) {
          calDay = calDay + Number(this.finalArrayFood[index].item_calories);
        } else {
          if (
            this.finalArrayFood[index].selectedDate ==
            this.selectDate.split('-').reverse().join('-') &&
            this.finalArrayFood[index].is_selected
          ) {
            calDay = calDay + Number(this.finalArrayFood[index].item_calories);
          }
        }
      } else if (validDate) {

        let isDateFormat = this.isValidDateFormat(this.finalArrayFood[index].selectedDate);
        if (!isDateFormat) {
          this.finalArrayFood[index].selectedDate = this.finalArrayFood[index].selectedDate.split('-').reverse().join('-');
        }
        if (
          this.finalArrayFood[index].selectedDate == this.selectDate &&
          this.finalArrayFood[index].is_selected
        ) {
          calDay = calDay + Number(this.finalArrayFood[index].item_calories);
        }
      } else {
        if (
          this.finalArrayFood[index].selectedDate == this.selectDate &&
          this.finalArrayFood[index].is_selected
        ) {
          calDay = calDay + Number(this.finalArrayFood[index].item_calories);
        }
      }
    }
    this.calPerDay = calDay;
  }

  loadDataForParticularDates() {
    ;

    for (let index = 0; index <= this.finalArrayFood.length; index++) {
      for (let i = 0; i <= this.week_duration_detail_menu_list.length; i++) {
        if (this.week_duration_detail_menu_list[i] != undefined) {
          let len = this.week_duration_detail_menu_list[i].item_list;
          for (let k = 0; k <= len.length; k++) {
            if (
              this.finalArrayFood[index] != undefined &&
              len[k] != undefined &&
              this.finalArrayFood[index].selectedDate != undefined &&
              this.finalArrayFood[index].item_id == len[k].item_id &&
              this.finalArrayFood[index].is_selected == true &&
              this.finalArrayFood[index].selectedDate.includes(this.selectDate)
            ) {
              if (len[k] != undefined) {
                len[k].is_selected = true;
              } else {
                len[k].is_selected = false;
              }
            }
          }
        }
      }
    }
    // }
  }

  // Assign To FinalFood Array In Save And Select Later
  setValueToFinalArrayFood() {
    //

    let week_arr: any[] = [];

    for (let k = 0; k < this.weekDietDetail.length; k++) {
      if (this.weekDietDetail[k].date_arr != undefined) {
        for (let t = 0; t < this.weekDietDetail[k].date_arr.length; t++) {
          this.weekDietDetail[k].date_arr[t].week_id =
            this.weekDietDetail[k].week_id;
          this.weekDietDetail[k].date_arr[t].week_name =
            this.weekDietDetail[k].week_name;
          week_arr.push(this.weekDietDetail[k].date_arr[t]);
        }
      }
    }
    for (let index = 0; index <= this.edited_diet_menu.length; index++) {
      if (this.edited_diet_menu[index] != undefined) {
        for (let i = 0; i <= this.duration_detail_menu_list.length; i++) {
          if (this.duration_detail_menu_list[i] != undefined) {
            for (
              let k = 0;
              k <= this.duration_detail_menu_list[i].item_list.length;
              k++
            ) {
              let item_list = this.duration_detail_menu_list[i].item_list;
              if (item_list[k] != undefined) {
                if (
                  item_list[k].master_menu_id ==
                  this.edited_diet_menu[index].diet_menu_id &&
                  item_list[k].item_id ==
                  this.edited_diet_menu[index].diet_menu_item_id
                ) {
                  let day = week_arr.filter(
                    (x) =>
                      x.date ==
                      this.edited_diet_menu[index].date
                        .split('-')
                        .reverse()
                        .join('-')
                  );
                  let data = {
                    item_id: item_list[k].item_id,
                    master_menu_id: item_list[k].master_menu_id,
                    item_name: item_list[k].item_name,
                    item_calories: item_list[k].item_calories,
                    item_protein: item_list[k].item_protein,
                    item_crab: item_list[k].item_crab,
                    item_fiber: item_list[k].item_fiber,
                    item_fat: item_list[k].item_fat,
                    available_date: item_list[k].available_date,
                    item_image_path: item_list[k].item_image_path,
                    is_active: 1,
                    created_at: item_list[k].created_at,
                    updated_at: item_list[k].updated_at,
                    is_selected: true,
                    selectedDate: this.edited_diet_menu[index].date,
                    week_id: this.edited_diet_menu[index].diet_week_id,
                    week_name: day[0].week_name,
                    day_name: day[0].day_txt,
                    is_savelater: true,
                    day_id: this.edited_diet_menu[index].diet_day_id,
                  };
                  this.finalArrayFood.push(data);
                }
              }
            }
          }
        }
      }
    }
    this.loadCalorgiesBasedOnDates();
  }

  swippeDiet() {
    setTimeout(() => {
      if (this.swipe1) {
        setTimeout(() => {
          this.swipe1 = false;
          this.swipe2 = true;
          if (this.swipe2) {
            setTimeout(() => {
              this.swipe2 = false;
              this.swipe3 = true;
              if (this.swipe3) {
                this.swipe1 = false;
                this.swipe2 = false;
                this.swipe3 = false;
              }
            }, 100);
          }
        }, 50);
      }
    }, 100);
  }

  // selectType(value) {
  //   this.heiweiType = value;
  //   this.calculateBMI();
  //   if (this.heiweiType == "cmsKgs") {
  //     this.height = "Cms";
  //     this.weight = "kgs";
  //   }
  //   if (this.heiweiType == "feetLbs") {
  //     this.height = "Fts";
  //     this.weight = "Lbs";
  //   }
  // }

  showfilterCat(index, detail) {
    console.log('indes');
    this.instruction = '';
    this.storeDietpackageDetails[index].filterCategory =
      !this.storeDietpackageDetails[index].filterCategory;
    this.fliterCat(index, detail.dietpackageId);
  }

  goalCalcToggel() {
    this.showWeightCalc = !this.showWeightCalc;
  }
  selectMember(data, frm) {
    if (frm == 1) {
      console.log(frm);
      console.log(data.patientId);

      this.slctdMemVal = data.name;
      this.currentMemberId = data.patientId;
    } else {
      this.slctdMemVal = data.name;
      this.currentMemberId = data.PatientMemberId;
      this.getHeight = data.height;
      this.getWeight = data.weight;
      this.Gender = data.gender;
      this.Age = Number(frm == 1 ? data.age : data.age.split(' ')[0]);
      if (frm == 1) {
        this.Email = data.email;
      }
      this.Phonno = data.phone_no;
      this.cccode = data.cc_code;
      console.log(this.slctdMemVal, this.currentMemberId);

      console.log('Age - ', this.Age);
      document.getElementById('nameInput').style.width =
        this.slctdMemVal.length + 2 + 'ch';
      document.getElementById('addresinput').style.width =
        this.DeliveryAddress.length + 1 + 'ch';
    }
  }
  getPatientNameLenth() {
    document.getElementById('nameInput').style.width =
      this.slctdMemVal.length + 2 + 'ch';
  }
  getPatientaddress() {
    if (this.DeliveryAddress != null && this.DeliveryAddress != undefined) {
      document.getElementById('addresinput').style.width =
        this.DeliveryAddress.length + 1 + 'ch';
    }
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return '';
    }

    let Value;
    switch (callFor) {
      case 'Time':
        if (dateTime.indexOf('T') > -1) {
          Value = dateTime.split('T')[1];
        } else if (dateTime.indexOf(' ') > -1) {
          Value = dateTime.split(' ')[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(':');
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = H < 12 || H === 24 ? 'AM' : 'PM';
        let timeString = h + String(Value).substr(hourEnd, 3) + ' ' + ampm;
        if (h < 10) {
          timeString = '0' + timeString;
        }
        console.log('timeString', timeString);

        return timeString;
      case 'Date':
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), 'dd-MMM-yy');
        } else {
          let dateCall = new Date(dateTime);
          let months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          var day = String(dateCall.getDate()).padStart(2, '0');
          var arDate =
            day +
            '-' +
            months[dateCall.getMonth()] +
            '-' +
            dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
      case 'DateTime':
        return this.datepipeTransform(new Date(dateTime), 'dd MMM yy h:mm a');
      case 'Date1':
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), 'dd-MMM-yy ');
        } else {
          let dateCall = new Date(dateTime);
          let months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate =
            day +
            '-' +
            months[dateCall.getMonth()] +
            '-' +
            dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  //-------------some Lagical Opration only------------------//

  getCurrentVideo(listIndex) {
    this.videoSlide.getActiveIndex().then((index: number) => {
      if (this.oldActiveVideoId) {
        this.playVid = document.getElementById(this.oldActiveVideoId);
        this.playVid.pause();
        this.getDietCompanyList[listIndex].dietmediaDetails[index].playMode =
          false;
      }
      if (
        this.getDietCompanyList[listIndex].dietmediaDetails[index].media_type ==
        'Video' ||
        this.getDietCompanyList[listIndex].dietmediaDetails[index].media_type ==
        'video'
      ) {
        this.activeVideoId =
          this.getDietCompanyList[listIndex].dietmediaDetails[index].mediaId;
        if (this.activeVideoId) {
          this.playVid = document.getElementById(this.activeVideoId);
          this.playVid.play();
          this.getDietCompanyList[listIndex].dietmediaDetails[index].playMode =
            true;
        }

        this.oldActiveVideoId = this.activeVideoId;
      }
    });
  }

  profileSlideVideo() {
    this.videoSlide.getActiveIndex().then((index: number) => {
      if (this.oldActiveVideoId) {
        this.playVid = document.getElementById(this.oldActiveVideoId);
        this.playVid.pause();
        this.playMode = false;
      }
      if (
        this.storDietCmpnyProDetls.dietmediaDetails[index].media_type ==
        'Video' ||
        this.storDietCmpnyProDetls.dietmediaDetails[index].media_type == 'video'
      ) {
        this.activeVideoId =
          this.storDietCmpnyProDetls.dietmediaDetails[index].mediaId;
        if (this.activeVideoId) {
          this.playVid = document.getElementById(this.activeVideoId);
          this.playVid.play();
          this.playMode = true;
        }

        this.oldActiveVideoId = this.activeVideoId;
      }
    });
  }

  calculateBMI() {
    this.goalWei();
    if (!this.getHeight) {
      this.BMICategory = 'Please enter height';
      this.weightCalc = '';
      this.BMIvalue = 0.0;
    } else if (!this.getWeight) {
      this.BMICategory = 'Please enter weight';
      this.weightCalc = '';
      this.BMIvalue = 0.0;
    } else {
      this.heiweiType = 'cmsKgs';

      this.BMIvalue =
        (Number(this.getWeight) /
          Number(this.getHeight) /
          Number(this.getHeight)) *
        10000;
      console.log('BMI - ', this.BMIvalue);
      this.BMIvalue = this.BMIvalue.toFixed(2);
      if (this.BMIvalue <= 15) {
        this.BMICategory = 'Very severely underweight';
        this.weightCalc = (18.5 - this.BMIvalue).toFixed(2) + ' kg below BMI';
      } else if (this.BMIvalue >= 15 && this.BMIvalue <= 16) {
        this.BMICategory = 'Severely underweight';
        this.weightCalc = (18.5 - this.BMIvalue).toFixed(2) + ' kg below BMI';
      } else if (this.BMIvalue >= 16 && this.BMIvalue <= 18.5) {
        this.BMICategory = 'Underweight';
        this.weightCalc = (18.5 - this.BMIvalue).toFixed(2) + ' kg below BMI';
      } else if (this.BMIvalue >= 18.5 && this.BMIvalue <= 25) {
        this.BMICategory = 'Normal (healthy weight)';
        this.weightCalc = '';
      } else if (this.BMIvalue >= 25 && this.BMIvalue <= 30) {
        this.BMICategory = 'Overweight';
        this.weightCalc = (this.BMIvalue - 25).toFixed(2) + ' kg above BMI';
      } else if (this.BMIvalue >= 30 && this.BMIvalue <= 35) {
        this.BMICategory = 'Moderately obese';
        this.weightCalc = (this.BMIvalue - 25).toFixed(2) + ' kg above BMI';
      } else if (this.BMIvalue >= 35 && this.BMIvalue <= 40) {
        this.BMICategory = 'Severely obese';
        this.weightCalc = (this.BMIvalue - 25).toFixed(2) + ' kg above BMI';
      } else {
        this.BMICategory = 'Very severely obese';
        this.weightCalc = (this.BMIvalue - 25).toFixed(2) + ' kg above BMI';
      }
      this.validation();
    }
  }

  goalWei() {
    if (this.getGoalWeight && String(this.getGoalWeight).length > 1) {
      if (
        (this.getGoalWeight >= this.getWeight + 4 ||
          this.getGoalWeight <= this.getWeight - 4) &&
        this.heiweiType == 'cmsKgs'
      ) {
        if (this.getGoalWeight >= this.getWeight + 4) {
          this.presentToast('Cannot gain more than 4 kg');
        }
        if (this.getGoalWeight <= this.getWeight - 4) {
          this.presentToast('Cannot loss more than 4 kg');
        }
      }
      if (
        (this.getGoalWeight >= this.getWeight + 8.82 ||
          this.getGoalWeight <= this.getWeight - 8.82) &&
        this.heiweiType == 'feetLbs'
      ) {
        if (this.getGoalWeight >= this.getWeight + 8.82) {
          this.presentToast('Cannot gain more than 8.82 Pounds');
        }
        if (this.getGoalWeight <= this.getWeight - 8.82) {
          this.presentToast('Cannot lose more than 8.82 Pounds');
        }
      }
      this.validation();
    }
  }

  setDayOrder() {
    let Days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let Daysinarabic = [
      'الأحد',
      'الاثنين',
      'الثلاثاء',
      'الأربعاء',
      'الخميس',
      'الجمعة',
      'السبت',
    ];
    let dayList = [];
    let i = this.getDayId;
    for (let item of Days) {
      dayList.push(Days[i - 1]);
      if (i == 7) {
        i = 0;
      }
      i++;
    }
    for (let items of Daysinarabic) {
      dayList.push(Days[i - 1]);
      if (i == 7) {
        i = 0;
      }
      i++;
    }
    this.day = dayList[0];
    this.storeWeekDays = dayList;
  }

  // -------/\------SOME SPECIAL FUNCTION------/\---------//


  async showaddress(address, myEvent) {
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        address: address,
        from: 'doctorBKFC',
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss();
    return await popover.present();
  }


  async showListDietPage() {
    this.loaddata = false;
    if (this.cmpnyListReq) {
      this.cmpnyListReq.unsubscribe();
    }
    if (this.pageNo == 1) {
      this.getDietCompanyList = [];
    }
    this.nextCount = [];
    this.hitApi = [];
    this.cardNum = 5;

    this.presentView = 'listDietPage';
    this.backValue = 'goHome';
    this.headerValue = null; //"List Deit Meal";
    this.EmptyData = null;
    let getDate = new Date();
    let currentDate =
      getDate.getFullYear() +
      '-' +
      ('0' + (getDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + getDate.getDate()).slice(-2);
    let apiData = JSON.stringify({
      Searchcontent: this.search,
      dietcompanyName: this.searchValue,
      currentDate: currentDate,
      offerBasedSorting: this.offerSoring,
      offerBasedSortingOrder: this.offrSortOrder,
      ratingBasedSorting: this.rateSoring,
      ratingBasedSortingOrder: this.rateSortOrder,
      limit: this.cardNum,
      pageno: this.pageNo,
      patientId: localStorage.getItem('patient_id'),
      lattidue: this.latitude,
      langtitude: this.longitude
    });
    this.cmpnyListReq = this.services
      .postRequest('getdietcompanylist', apiData)
      .subscribe((res) => {
        console.log(res);
        this.loaddata = true;
        let _obj = this;
        let frmAd = this.activeRoute.snapshot.paramMap.get('frmAd');
        if (frmAd == '1') {
          console.log('chck frm ad');
          let vendorid = this.activeRoute.snapshot.paramMap.get('vendorId');
          this.selectProfile(vendorid);
        }
        console.log('Video');
        if (this.refEvent) {
          this.refEvent.target.complete();
        }
        if (res.status == 1) {

          if (this.cardNum == res.data[0].details.length) {
            this.EmptyData = 1;
          }
          else {
            this.EmptyData = 0;
          }
        }
        else {
          this.EmptyData = 0;
        }
        // this.EmptyData = res.status;
        res.data.length > 0
          ? this.nextCount.push(res.data[0].nextCount)
          : (this.nextCount = []);
        var NextCount = 0;

        if (res.status == 1) {
          for (let item of res.data[0].details) {
            this.getDietCompanyList.push(item);
          }
        }
        if (res.status == 1) {
          NextCount = res.data[0].nextCount;
          if (this.pageNo != 1 && !this.search) {
            for (let item of res.data[0].details) {
              for (let item2 of item.dietmediaDetails) {
                item2['playMode'] = false;
              }
              this.getDietCompanyList.push(item);
            }
            let uniqueObject = {};
            let uniqueArray = [];
            this.getDietCompanyList.forEach((item) => {
              if (!uniqueObject[item['dietvendorId']]) {
                uniqueObject[item['dietvendorId']] = true;
                uniqueArray.push(item);
              }
            });
            this.getDietCompanyList = [];
            this.getDietCompanyList = uniqueArray;
          } else {
            this.getDietCompanyList = [];
            for (let item of res.data[0].details) {
              for (let item2 of item.dietmediaDetails) {
                item2['playMode'] = false;
              }
              this.getDietCompanyList.push(item);
            }
            let convert = JSON.stringify(this.getDietCompanyList);
            this.getDietCompanyList = JSON.parse(convert);
          }
        }
        setTimeout(() => {
          _obj.currentPlaying = null;
          if (_obj.vdoPlayer) {
            this.didScrollEvent(event);
          }
        }, 1000);
      });
    this.search = false;
    this.searchValue = null;
  }

  serachDietCompany() {
    this.search = true;
    this.pageNo = 1;
    this.getDietCompanyList = null;
    this.showListDietPage();
  }
  sltProfile: any;
  selectProfile(vendorId) {
    this.selected_pack = [];
    this.programname = null;
    console.log(vendorId, 'vendorid');
    this.getMedia(vendorId);
    this.viwemorcl = true;
    if (this.partCompDietPlanReq) {
      this.partCompDietPlanReq.unsubscribe();
    }
    this.storDietCmpnyProDetls = null;
    this.storeDietVendorId = vendorId;
    this.backValue = 'goList';
    this.oldActiveVideoId = null;
    this.isData = null;
    this.presentView = 'bookDietMealPage';
    if (this.detailId == true) {
      this.select_program();
    }
    let getDate = new Date();
    let currentDate =
      getDate.getFullYear() +
      '-' +
      ('0' + (getDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + getDate.getDate()).slice(-2);
    let apiData = JSON.stringify({
      dietvendorId: vendorId,
      currentDate: currentDate,
      patientId: localStorage.getItem('patient_id'),
    });
    this.partCompDietPlanReq = this.services
      .postRequest('getParticularCompanydietplan', apiData)
      .subscribe((res) => {
        console.log('profile data=>', res);
        if (this.refEvent) {
          this.refEvent.target.complete();
        }
        if (res.status == 1) {
          this.storDietCmpnyProDetls = res.data[0].details[0];
          console.log(this.storDietCmpnyProDetls);
          this.sltProfile = this.storDietCmpnyProDetls.vendor_profile_path;

          this.revArr = JSON.parse(this.storDietCmpnyProDetls.review_comment);
          console.log(this.revArr);

          for (let item of this.storDietCmpnyProDetls.dietmediaDetails) {
            item['playMode'] = false;
          }
          if (this.storDietCmpnyProDetls.dietpackageDetails.length >= 1) {
            for (let item of this.storDietCmpnyProDetls.dietpackageDetails) {
              let wek1 = item.diet_duration / 7;
              this.wek = Math.floor(wek1);
              this.dayk = item.diet_duration % 7;
              let des_length = +item.diet_description?.length;
              console.log('description length', des_length);
              if (des_length > 118) {
                this.viewmore = true;
              } else {
                this.viewmore = false;
              }
              this.storeDietpackageDetails.push({
                deal_amount: item.deal_amount,
                deal_id: item.deal_id,
                deal_options: item.deal_options,
                deal_title: item.deal_title,
                diet_active_flag: item.diet_active_flag,
                diet_description: item.diet_description,
                diet_duration: item.diet_duration,
                diet_package_name: item.diet_package_name,
                diet_price: item.diet_price,
                dietpackageId: item.dietpackageId,
                viewmore: this.viewmore,
                filterCategory: false,
                week: this.wek,
                days: this.dayk,
                filterCatList: [],
                intructions: [],
                packimg: item.file_path,
              });
            }
          }

          console.log('DietPkgDetails=>', this.storeDietpackageDetails);
          this.headerValue = this.storDietCmpnyProDetls.dietcompanyname; // + " Profile";
          console.log(
            this.headerValue,
            '================chewck header value',
            this.deal_dealid
          );

          if (this.deal_dealid) {
            const first = this.storeDietpackageDetails.find((obj) => {
              return obj.deal_id == this.deal_dealid;
            });
            let pack_index = this.storeDietpackageDetails.findIndex(
              (x) => x.deal_id == this.deal_dealid
            );
            console.log(first, '=========selected deal details');
            this.selected_packagedetails(first, pack_index);
          }
        }
      });

    this.getMasterMenuList();
  }

  showHide() {
    console.log("checked arrow")
    this.isShow = !this.isShow;
  }

  fliterCat(index, dietpackageId) {
    if (this.getCatMealPlanReq) {
      this.getCatMealPlanReq.unsubscribe();
    }
    if (this.dietInstReq) {
      this.dietInstReq.unsubscribe();
    }
    this.storeFilterCategry = [];
    this.storeIntruction = [];
    let apidata = JSON.stringify({
      dietpackageId: dietpackageId,
    });
    this.getCatMealPlanReq = this.services
      .postRequest('getcategorymealplan', apidata)
      .subscribe((res) => {
        console.log(res);
        if (res.status == 1) {
          for (let item of res.data) {
            this.storeFilterCategry.push({
              dietfiltercategoryId: item.dietfiltercategoryId,
              filter_category: item.filter_category,
              choose: false,
            });
          }
          this.storeDietpackageDetails[index].filterCatList = JSON.parse(
            JSON.stringify(this.storeFilterCategry)
          );
          this.selected_pack.filterCatList = JSON.parse(
            JSON.stringify(this.storeFilterCategry)
          );
        } else {
          this.storeDietpackageDetails[index].filterCatList = [];
          this.selected_pack.filterCatList = [];
        }

        let apidata = JSON.stringify({
          dietpackageId: dietpackageId,
        });
        this.dietInstReq = this.services
          .postRequest('getdietinstructions', apidata)
          .subscribe((res) => {
            console.log('instrection=>', res);
            if (res.status == 1) {
              for (let item of res.data)
                this.storeIntruction.push({
                  inst_category: item.inst_category,
                  inst_categoryId: item.inst_categoryId,
                  instruction: item.instruction,
                  choose: false,
                });

              this.storeDietpackageDetails[index].intructions = JSON.parse(
                JSON.stringify(this.storeIntruction)
              );
              this.selected_pack.intructions = JSON.parse(
                JSON.stringify(this.storeIntruction)
              );
              console.log('list instrection', this.storeIntruction);

              console.log('te array', this.storeDietpackageDetails);
              console.log(this.selected_pack);

              this.isData = this.storeDietpackageDetails.length != 0 ? 1 : 0;
              console.log('isData checking', this.isData);
            } else {
              this.storeDietpackageDetails[index].intructions = [];
              this.selected_pack.intructions = [];
            }
          });
      });
  }

  calcDietDate() {
    let date = null;
    date = new Date(this.Date);
    date.setDate(date.getDate() + (this.durationDays - 1));
    this.Date = date;
    this.dietToDate =
      this.Date.getFullYear() +
      '-' +
      ('0' + (this.Date.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + this.Date.getDate()).slice(-2);
  }

  helthyEatspage(value: any, index: any) {
    this.start_cheatday = false;
    this.storeValue = value;
    this.storeDietPkgListIndex = index;
    this.storeFilterCatId = [];
    this.storeSessionList = [];
    this.durationDetailMenuList = [];
    this.particulrSessionList = [];
    this.RepeatWeek = null;
    if (Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0) {
    } else {
      this.InitialValueBinding();
    }

    if (value == 'MealPlan') {
      let detail_data = this.dution_detail_data.filter((obj: any) => {
        return obj.detail_id == this.duration_detail_id;
      });
      let Otp = detail_data[0]['deal_option']
        ? detail_data[0]['deal_option']
        : '';
      let Amt = detail_data[0]['deal_amount']
        ? detail_data[0]['deal_amount']
        : 0;
      this.totalPrice = detail_data[0]['price'];

      console.log('Deal Option - ', Otp, '--- Index - ', index);
      console.log('Deal Price - ', Amt, '--- Index - ', index);
      console.log(
        'Deal Total AMount - ',
        this.totalPrice,
        '--- Index - ',
        index
      );

      if (Otp && Amt) {
        console.log('IF-------');
        this.dealAmt = Amt;

        if (Otp == 'Percentage') {
          this.dealOtp = 'KWD';
          this.dealOtp1 = 'Percentage';
          this.finalAmt =
            Number(this.totalPrice) -
            (Number(this.totalPrice) * Number(Amt)) / 100;
        } else if (Otp == 'Amount') {
          this.dealOtp = 'KWD';
          this.dealOtp1 = 'Amount';
          this.finalAmt = Number(this.totalPrice) - Number(Amt);
        }
      } else {
        console.log('Else-----');
        this.dealOtp1 = 'Nodeal';
        this.dealAmt = 0;
        this.finalAmt = this.totalPrice;
      }
      console.log('Deal Amount = ', this.dealAmt);
      this.storeDietPkgId = this.package_id;
      this.presentView = 'HealthyEatsPage';
      this.backValue = 'packageSelect';
      if (this.booking_id == 0) {
        this.calPerDay = 0;
      }
    } else if (this.storeValue == 'Repeat') {
      this.presentView = 'HealthyEatsPage';
      this.backValue = 'goCanBookingList';
      this.headerValue = 'Diet Meal';
    }
  }

  initalValueDisabled: any;
  InitialValueBinding() {
    ;
    this.start_cheatday = false;
    if (this.cheat_days.length > 0) {
      let storeDietdate = new Date();
      let availabledate = new Date(
        storeDietdate.setDate(storeDietdate.getDate() + (this.datevalue + 1))
      );
      this.initalValueDisabled = availabledate;
      this.Date = availabledate;
      let getDay = new Date(this.Date);
      this.getDayId = getDay.getDay() + 1;

      this.storeDietFromDate = this.getFormattedDateTime(this.Date, 'Date1');
      this.dietFromDate =
        this.Date.getFullYear() +
        '-' +
        ('0' + (this.Date.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + this.Date.getDate()).slice(-2);
      let date = new Date(this.dietFromDate);
      let disabled = new Date(this.dietFromDate);
      let cheatDay = true;
      while (cheatDay) {
        let Days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        let Daysinarabic = [
          'الأحد',
          'الاثنين',
          'الثلاثاء',
          'الأربعاء',
          'الخميس',
          'الجمعة',
          'السبت',
        ];
        let day = date.getDay();
        let dayName = Days[day];
        let dayNameinarabic = Daysinarabic[day];
        let contains = this.cheat_days.filter(
          (x) => x.value == dayName || x.value == dayNameinarabic
        );
        if (contains.length > 0) {
          if (!this.start_cheatday) {
            if (this.addCall.selectedLanguage === 'ea') {
              this.openStartDateModel('.تاريخ البدء هو يوم الغش');
            } else {
              this.openStartDateModel('Start date is a cheat day.');
            }
            this.start_cheatday = true;
          }
          date.setDate(date.getDate() + 1);
          disabled.setDate(disabled.getDate() + 1);
        } else {
          this.storeDietFromDate = this.getFormattedDateTime(date, 'Date1');
          this.dietFromDate =
            date.getFullYear() +
            '-' +
            ('0' + (date.getMonth() + 1)).slice(-2) +
            '-' +
            ('0' + date.getDate()).slice(-2);
          this.initalValueDisabled = disabled;
          let toDate = date;
          toDate.setDate(toDate.getDate() + (this.durationDays - 1));
          this.Date = toDate;
          this.dietToDate =
            toDate.getFullYear() +
            '-' +
            ('0' + (toDate.getMonth() + 1)).slice(-2) +
            '-' +
            ('0' + toDate.getDate()).slice(-2);
          cheatDay = false;
        }
      }
    } else {
      let storeDietdate = new Date();
      let availabledate = new Date(
        storeDietdate.setDate(storeDietdate.getDate() + (this.datevalue + 1))
      );
      this.initalValueDisabled = availabledate;
      this.Date = availabledate;
      let getDay = new Date(this.Date);
      this.getDayId = getDay.getDay() + 1;

      this.storeDietFromDate = this.getFormattedDateTime(this.Date, 'Date1');
      this.dietFromDate =
        this.Date.getFullYear() +
        '-' +
        ('0' + (this.Date.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + this.Date.getDate()).slice(-2);
      getDay.setDate(getDay.getDate() + (this.durationDays - 1));
      this.Date = getDay;
      this.dietToDate =
        this.Date.getFullYear() +
        '-' +
        ('0' + (this.Date.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + this.Date.getDate()).slice(-2);
    }
    this.generateWeekArray();
    this.setDayOrder();
    this.loadDataForParticularDates();
    this.pushDietPerDay();
  }
  repeatcheck(bookingId, dietVenderId, bookingData, dietpackageid, details) {
    let requestdate = JSON.stringify({
      dietpackageid: dietpackageid,
    });

    this.services
      .postRequest('repeatcheckdiet', requestdate)
      .subscribe((Response) => {
        console.log(Response, '=========check response');
        console.log(Response.data[0].package_status);
        let checkrepeatdiet = Response.data[0].package_status;
        console.log(details.dietvendorId);
        if (checkrepeatdiet == 0) {
          this.checkrepeat(details.dietvendorId);
        } else {
          this.repeatFlow(bookingId, dietVenderId, bookingData);
        }
      });
  }

  repeatFlow(bookingId, dietVenderId, bookingData) {
    if (this.repMenuReq) {
      this.repMenuReq.unsubscribe();
    }
    this.repeatDietData = {
      bkgId: bookingId,
      venId: dietVenderId,
      bkgDate: bookingData,
    };
    this.storeDietVendorId = dietVenderId;
    this.helthyEatspage('Repeat', 0);
    let apiData = JSON.stringify({
      dietbookingid: bookingId,
      dietvendorId: dietVenderId,
      date: bookingData.split('T')[0],
    });
    this.repMenuReq = this.services
      .postRequest('getdietrepeatmenu', apiData)
      .subscribe((res) => {
        console.log('diet repeat=>', res);
        this.totalPrice = res.data[0].diet_price;

        if (res.status == 1) {
          this.prtclrDietPkgInfo = res.data[0];
          this.storeDietPkgId = this.prtclrDietPkgInfo.dietpackageId;
          this.dietCompanyName = this.prtclrDietPkgInfo.dietcompanyname;
          this.storeDietDuration = this.prtclrDietPkgInfo.diet_duration;
          for (let item of this.prtclrDietPkgInfo.SessionList) {
            this.storeSessionList.push({
              diet_sessions: item.diet_sessions,
              dietsessionId: item.dietsessionId,
              foodSession: item.foodSession,
              selectedFoodId: null,
            });
          }
          let getDate = new Date();
          this.Date = getDate;
          this.calcDietDate();

          this.storeDietFromDate = this.getFormattedDateTime(getDate, 'Date1');
          this.dietFromDate =
            getDate.getFullYear() +
            '-' +
            ('0' + (getDate.getMonth() + 1)).slice(-2) +
            '-' +
            ('0' + getDate.getDate()).slice(-2);
          this.getDayId = getDate.getDay() + 1;
          this.setDayOrder();
          this.pushDietPerDay();
        }
      });
  }

  repeatBookingData() {
    let repeatData = this.prtclrDietPkgInfo.SessionList; //[0].Bookeddata
    console.log('Repeat data - ', repeatData);
    for (let item of repeatData) {
      if (item.Bookeddata) {
        console.log('Entered');
        for (let weekId of item.Bookeddata) {
          let getWeekId = weekId?.diet_week_id;
          let getdayId = weekId?.diet_day_id;
          let getSesId = weekId?.diet_session_id;
          this.storeWeekDiet[getWeekId][getdayId][getSesId].selectedFoodId =
            weekId?.diet_menu_item_id;
        }
      }
    }
  }

  selectedInstrection(index) {
    this.storeFilterInstId = [];
    for (let item of this.storeDietpackageDetails[index].intructions) {
      if (item.choose == true) {
        this.storeFilterInstId.push(item.inst_categoryId);
      }
    }
  }
  type: any;
  pushDietPerDay() {
    let data = this.weekDietDetail;
    data = data.map((obj) => {
      if (this.type == 'save_later') {
        const clonedDurationDetailMenuList = JSON.parse(
          JSON.stringify(this.loadMenuItemList)
        );
        this.edited_diet_menu
          .filter((edit_menu_obj) => edit_menu_obj.diet_week_id === obj.week_id)
          .forEach((edit_menu_obj) => {
            clonedDurationDetailMenuList.forEach((duration_detail_menu_obj) => {
              duration_detail_menu_obj.item_list.forEach((item_obj) => {
                if (
                  edit_menu_obj.diet_menu_item_id === item_obj.item_id &&
                  edit_menu_obj.date === this.selectDate
                ) {
                  item_obj.is_selected = true;
                  item_obj.isLater = true;
                }
              });
            });
          });
        obj.duration_detail_menu_list = clonedDurationDetailMenuList;
        return obj;
      } else {
        const clonedDurationDetailMenuList = JSON.parse(
          JSON.stringify(this.loadMenuItemList)
        );
        let weekId = this.finalArrayFood.filter(
          (edit_menu_obj) => edit_menu_obj.week_id === obj.week_id
        );
        if (weekId) {
          for (let i = 0; i <= this.finalArrayFood.length; i++) {
            for (let k = 0; k <= clonedDurationDetailMenuList.length; k++) {
              if (
                clonedDurationDetailMenuList[k] != undefined &&
                clonedDurationDetailMenuList[k].item_list != undefined
              ) {
                for (
                  let j = 0;
                  j <= clonedDurationDetailMenuList[k].item_list.length;
                  j++
                ) {
                  if (
                    this.finalArrayFood[i] != undefined &&
                    this.finalArrayFood[i].selectedDate != undefined
                  ) {
                    var valid = this.isValidDateFormat(
                      this.finalArrayFood[i].selectedDate
                    );
                    if (valid) {
                      if (
                        this.finalArrayFood[i] != undefined &&
                        this.finalArrayFood[i].item_id != undefined &&
                        clonedDurationDetailMenuList[k].item_list[j] !=
                        undefined &&
                        clonedDurationDetailMenuList[k].item_list[j].item_id !=
                        undefined &&
                        this.finalArrayFood[i].item_id ===
                        clonedDurationDetailMenuList[k].item_list[j]
                          .item_id &&
                        this.finalArrayFood[i].selectedDate === this.selectDate
                      ) {
                        clonedDurationDetailMenuList[k].item_list[
                          j
                        ].is_selected = true;
                      }
                    } else {
                      if (
                        this.finalArrayFood[i] != undefined &&
                        this.finalArrayFood[i].item_id != undefined &&
                        clonedDurationDetailMenuList[k].item_list[j] !=
                        undefined &&
                        clonedDurationDetailMenuList[k].item_list[j].item_id !=
                        undefined &&
                        this.finalArrayFood[i].item_id ===
                        clonedDurationDetailMenuList[k].item_list[j]
                          .item_id &&
                        this.finalArrayFood[i].selectedDate ===
                        this.selectDate.split('-').reverse().join('-')
                      ) {
                        clonedDurationDetailMenuList[k].item_list[
                          j
                        ].is_selected = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        obj.duration_detail_menu_list = clonedDurationDetailMenuList;
        return obj;
      }
    });
    if (Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0) {
      var weeks = data.filter((obj) => obj.week_name == this.week);
    } else {
      var weeks = data.filter((obj) => obj.week_id == this.week);
    }
    var weeks = data.filter((obj) => obj.week_id == this.week);
    this.week = weeks.length == 0 ? data[0]?.week_id : weeks[0]?.week_id;
    this.week_name =
      weeks.length == 0 ? data[0]?.week_name : weeks[0]?.week_name;
    this.month = data[0]?.month_name;
    this.weekdayarray =
      weeks.length == 0 ? data[0]?.date_arr : weeks[0]?.date_arr;
    if (this.type == 'save_later') {
      if (Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0) {
        let format = this.isValidDateFormat(this.selectDate);
        if (format) {
          let day = this.weekdayarray.find((x) => x.date == this.selectDate);
          this.day = day.day;
        } else {
          let day = this.weekdayarray.find(
            (x) => x.date == this.selectDate.split('-').reverse().join('-')
          );
          if (day != undefined) {

            this.day = day.day;
          }
        }
      }
    } else {
      let day = this.weekdayarray.find((x) => x.date == this.selectDate);
      this.day = day.day;
    }
    let week = data.filter((x) => x.week_name == this.week_name);
    this.week_duration_detail_menu_list = week[0]?.duration_detail_menu_list;
    console.log('value checked', this.week_duration_detail_menu_list);
    this.weekDietDetail = this.filterData(data);
    if (
      Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0 &&
      this.type == 'save_later' &&
      this.finalArrayFood.length == 0
    ) {
      this.setValueToFinalArrayFood();
    }
  }
  filterData = (data) => {
    return data.filter((item) => {
      // Check if any date_arr entry has both conditions as false
      const hasValidDate = item.date_arr.some(
        (date) => !date.is_cheat_day_available && !date.is_availdisabled
      );

      // Return only those items that have at least one valid date
      return hasValidDate;
    });
  };

  isEmpty(obj: object): boolean {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false; // If the object has any key, it's not empty
      }
    }
    return true; // If no key is found, the object is empty
  }
  returnFunc(day) {
    let week = day / 7;
    return Math.floor(week);
  }
  retday(day) {
    let wekdy = day % 7;
    this.wekday = wekdy;
    return wekdy;
  }

  changeDays() {
    this.validation();
  }
  validation() {
    let goalWt = 0;
    if (Number(this.getGoalWeight) > Number(this.getWeight)) {
      goalWt = Number(this.getGoalWeight) - Number(this.getWeight);
    } else if (Number(this.getGoalWeight) < Number(this.getWeight)) {
      goalWt = Number(this.getWeight) - Number(this.getGoalWeight);
    } else {
      this.inTakeClsPerDay = 0;
    }
  }

  selectedDietSubPackage: any[] = [];
  selectedSubPackageId: any[] = [];
  async selectedDietFood() {
    this.no_repeat = false;
    this.storeSelectedDiet = [];
    let selected_diet_menu = [];

    if (this.finalArrayFood.length > 0) {
      this.finalArrayFood.map((obj: any) => {
        if (obj.is_selected == true) {
          let final_obj = {
            diet_menu_item_id: obj['item_id'],
            diet_menu_id: obj['master_menu_id'],
            diet_day_id: obj['day_id'],
            diet_week_id: obj['week_id'],
            dates: obj['selectedDate'].split('-').reverse().join('-'),
            is_active: '1',
          };
          selected_diet_menu.push(final_obj);
        }
      });
    }
    this.storeSelectedDiet = selected_diet_menu;
    let checkSelectedCount = this.storeSelectedDiet;
    let uniqueObject = {};
    let uniqueArray = [];
    checkSelectedCount.forEach((item) => {
      if (!uniqueObject[item['dates']]) {
        uniqueObject[item['dates']] = true;
        uniqueArray.push(item);
      }
    });
    this.averageCalPerDay(uniqueArray);
    this.storeSelectedDiet = selected_diet_menu;
    if (selected_diet_menu.length != 0) {
      this.isMealSeld = true;
    } else {
      this.isMealSeld = false;
    }
    if (this.storeDietFromDate != null && this.storeDietFromDate != '') {
      if (this.delivery_time_id != 0) {
        if (this.isMealSeld) {
          this.presentView = 'bookingConfirmPage';
          this.backValue = 'goWeekSelectPage';
          if (this.booking_id == 0) {
            this.delivery_instruction = "";
          }
          var selectedDateCount = this.storeSelectedDiet;
          let uniqueObject = {};
          let uniqueArray = [];

          selectedDateCount.forEach((item) => {
            if (!uniqueObject[item['dates']]) {
              uniqueObject[item['dates']] = true;
              uniqueArray.push(item);
            }
          });
          this.selDays = uniqueArray.length;
          this.dayOff.toString();
          this.selectedDietSubPackage = this.dution_detail_data.filter(
            (x) => x.detail_id == this.selectedSubPackageId
          );
          this.headerValue = this.addCall.title40;
          await this.getPatientBasicDetails();
        } else {
          this.presentToast(this.addCall.title661);
        }
      } else {
        this.deliver_error = true;
      }
    } else {
      this.deliver_error = true;
    }
  }

  dayOff: any[] = [];
  dayOffdeatail: any[] = [];

  findLastEligibleDate(dateArr) {
    // Loop through the array in reverse
    for (let i = dateArr.length - 1; i >= 0; i--) {
      const dateObj = dateArr[i];
      // Check if both is_cheat_day_available and is_availdisabled are false
      if (!dateObj.is_cheat_day_available && !dateObj.is_availdisabled) {
        return dateObj.date;
      }
    }
    return null; // Return null if no eligible date is found
  }


  confirmBook() {
    let totalweek = (this.weekDietDetail.length) - 1;

    this.dietToDate = this.findLastEligibleDate(this.weekDietDetail[totalweek].date_arr);
    // this.dietToDate = this.weekDietDetail[totalweek].date_arr[6].date
    if (!this.allDatesFound) {
      this.dayOff = [];
      this.dayOffdeatail = [];
      var selected_diet_menu = [];
      if (this.finalArrayFood.length > 0) {
        this.finalArrayFood.map((obj: any) => {
          if (obj.is_selected) {
            let isDateFormat = this.isValidDateFormat(obj['selectedDate']);

            if (isDateFormat) {
              obj['selectedDate'] = this.changeDateFormat(obj['selectedDate']);
            } else {
              obj['selectedDate'] = (obj['selectedDate']);
            }
            let final_obj = {
              diet_menu_item_id: obj['item_id'],
              diet_menu_id: obj['master_menu_id'],
              diet_day_id: obj['day_id'],
              diet_week_id: obj['week_id'],
              dates: obj['selectedDate'].split('-').reverse().join('-'),
              is_active: '1',
            };
            selected_diet_menu.push(final_obj);
          }
        });
      }

      if (this.cheat_days.length > 0) {
        debugger
        this.cheat_days.forEach((item) => {
          this.dayOffdeatail.push(item.value);
        });
        this.dayOff.push(this.dayOffdeatail.join(", "))
      }

      this.storeSelectedDiet = selected_diet_menu;
      var checkSelectedCount = this.storeSelectedDiet;
      let uniqueObject = {};
      let uniqueArray = [];
      checkSelectedCount.forEach((item) => {
        if (!uniqueObject[item['dates']]) {
          uniqueObject[item['dates']] = true;
          uniqueArray.push(item);
        }
      });

      if (this.durationDays != undefined) {
        if (
          uniqueArray.length < Number(this.durationDays) &&
          this.menuLevel != 'Yes' &&
          !this.is_save_later &&
          this.storeDietFromDate != '' &&
          this.storeDietFromDate != undefined &&
          this.delivery_time_id != 0 &&
          selected_diet_menu.length != 0
        ) {
          this.isUpdateBtn = false;
          this.openSaveAndSelectLater();
        } else if (
          Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0
        ) {
          var filter = this.finalArrayFood.filter(
            (x) => x.is_savelater != true && x.is_selected == true
          );
          let uniqueObject = {};
          let uniqueArray = [];
          filter.forEach((item) => {
            if (!uniqueObject[item['selectedDate']]) {
              uniqueObject[item['selectedDate']] = true;
              uniqueArray.push(item);
            }
          });
          this.selDays = uniqueArray.length;
          let remaining =
            this.durationDays - (Number(this.selected_daysSave) + this.selDays);
          if (remaining < Number(this.durationDays)) {
            this.selectedDietFood();
          }
        } else {
          this.selectedDietFood();
        }
      } else {
        if (this.is_save_later && this.booking_id > 0) {
          this.getPakcageDetailsByPackageId();
          this.selectedDietFood();
        }
      }
    }
  }

  averageCalPerDay(uniqueArray) {

    var calDay = 0;
    for (let index = 0; index < this.finalArrayFood.length; index++) {
      if (this.finalArrayFood[index].item_calories != '') {
        calDay = calDay + Number(this.finalArrayFood[index].item_calories);
      }
    }
    let calculate = calDay / uniqueArray.length;
    var calDay = Math.round(calculate);
    this.calPerDay = calDay;
  }

  averageCalPerDayBooking(calPerDay, dayCount): any {
    let calDay: any;
    let calculate = calPerDay / dayCount;
    let numberIntorFloat = Number.isInteger(calculate);
    return (calDay = numberIntorFloat
      ? calculate
      : Number(calculate).toFixed(3));
  }

  getPakcageDetailsByPackageId() {
    let apiData = JSON.stringify({
      package_id: this.package_id,
    });
    this.services
      .dietRequest('getPackageDetailsByPackageId', apiData)
      .subscribe((res) => {
        console.log(res);
        if (res.data.length > 0) {
          let packages = res.data.filter(
            (x) => x.duration_id == this.duration_id
          );
          this.diet_package_name = packages[0].package_name;
          this.durationDays = packages[0].duration_days;
        }
      });
  }
 async getPatientBasicDetails() {
  debugger;
    this.showcoment = true;
    if (this.patProReq) {
      this.patProReq.unsubscribe();
    }
    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      currentDate: new Date().toISOString().split('T')[0],
      currentTime: new Date().toTimeString().split(' ')[0],
    });
    this.patProReq = this.services
      .postRequest('getPatientProfile', apiData)
      .subscribe((res) => {
        console.log(res);
        console.log("res.status ",res.status )
        if (res.status == 1) {
          console.log("res.data.length",res.data.length)
          if(res.data.length > 0){
            this.Gender = res.data[0].gender;
            this.Age = res.data[0].age;
            this.patientBasicDetails = res.data[0];
            console.log('New checking', this.patientBasicDetails);
            this.slctdMemVal = this.patientBasicDetails.name;
            if (this.booking_id == 0) {
              this.DeliveryAddress = this.patientBasicDetails.address;
            }
            this.Phonno = this.patientBasicDetails.phone_no;
            this.cccode = this.patientBasicDetails.cc_code;
            this.getHeight = this.patientBasicDetails.height;
            this.getWeight = this.patientBasicDetails.weight;
            this.Email = this.patientBasicDetails.email;
            this.currentMemberId = localStorage.getItem('patient_id');
            // document.getElementById('nameInput').style.width = this.slctdMemVal.length + 2 + 'ch';
            this.calculateBMI();
          }else {
            this.Gender = "";
            this.Age = "";
            this.patientBasicDetails = [];
            this.slctdMemVal = localStorage.getItem("name_temp_member");
            // this.tempMemberName;
            // if (this.booking_id == 0) {
            //   this.DeliveryAddress = null;
            // }
            this.DeliveryAddress = null;
            this.Phonno = this.Phoneno;
            this.cccode = ""
            this.getHeight ="";
            this.getWeight = "";
            this.Email = this.Email_w
            this.currentMemberId = this.patient_id_walk,
            // document.getElementById('nameInput').style.width =this.slctdMemVal.length + 2 + 'ch';
            this.calculateBMI();
            
          }
     
        }
      });
  }

  Chdate: String;

  bookingListPage() {
    this.pageNo = 1;
    this.EmptyData = null;
    this.storeBookingList = [];
    this.Chdate = String(new Date().toISOString().split('T')[0]);
    console.log(this.Chdate, '==================');
    this.ChangeEventDiet.emit('isDietBackHistory');
    this.bookingList();
  }

  canBookingListPage() {
    this.pageNo = 1;
    this.EmptyData = null;
    this.storeBookingHisList = [];
    this.canBookingList();
  }

  bookingList() {
    if (this.bookListReq) {
      this.bookListReq.unsubscribe();
    }
    this.presentView = 'historyPage';
    this.MealbookingList = true;
    this.MealbookingInfo = false;
    this.CanMealbookingList = false;
    this.backValue = 'goList';
    this.headerValue = this.addCall.title686;
    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      limit: '10',
      pageno: this.pageNo,
      filter: false,
      modeId: 0,
    });
    this.bookListReq = this.services
      .postRequest('getdietbookinglist', apiData)
      .subscribe((res) => {
        console.log(res);
        if (this.refEvent) {
          this.refEvent.target.complete();
        }
        if (this.pageNo == 1) {
          this.EmptyData = res.status;
        }
        let nextCount = res.status == 1 ? res.data[0].nextCount : 0;
        if (this.scrollEvent) {
          console.log('Scroll Entered');
          this.scrollEvent.target.complete();
          this.scrollEvent.target.disabled = nextCount == 0 ? true : false;
        }
        if (res.status == 1) {
          if (this.pageNo != 1 && !this.search) {
            ;
            for (let item of res.data[0].details) {
              let just = JSON.parse(item.DietBookedData);
              item.DietBookedData = just;
              this.storeBookingList.push(item);
            }
          } else {
            for (let item of res.data[0].details) {
              var just = JSON.parse(item.DietBookedData);
              item.DietBookedData = just;
            }
            this.storeBookingList = res.data[0].details;
            if (localStorage.getItem('bookview') != "" && localStorage.getItem('bookview') != "null" && res.data[0].details) {

              this.viewBookingDetail(localStorage.getItem('bookview'), localStorage.getItem('bookviewindex'), localStorage.getItem('bookviewdays'));
            }
          }
        }
      });
  }

  menuItemBookingDate: any[] = [];
  viewBookingDetail(value, index, selectdays) {
    localStorage.setItem('bookview', value);
    localStorage.setItem('bookviewindex', index);
    localStorage.setItem('bookviewdays', selectdays);
    console.log('My view');
    console.log('my booking details');
    console.log('view de', selectdays);
    this.selected_days = selectdays;
    this.presentView = 'historyPage';
    this.MealbookingInfo = true;
    this.MealbookingList = false;
    this.dietFromDate = "";
    this.dietToDate = "";
    this.dayOff = [];

    if (value == 'bookView') {
      this.showcoment = true;
      this.CanMealbookingList = false;
      this.ChangeEventDiet.emit('profile');
      this.isShowHeaderValue = true;
      this.backValue = 'goBookingList';
      this.headerValue = this.addCall.title133;
      var value = this.storeBookingList[index];
      var value = value.intake_cals_day;
      let fromDate = new Date(this.storeBookingList[index].from_date); // Convert string to Date object

      fromDate.setDate(fromDate.getDate() - 2); // Subtract two days
      this.dietFromDate = this.storeBookingList[index].from_date;
      this.dietToDate = this.storeBookingList[index].to_date;
      this.dayOff = this.storeBookingList[index].cheat_day;
      this.twodaysbefore = fromDate.toISOString().split('T')[0];

      let after48hours = this.calculdate48HoursFromCurrentDate();
      let dateAfter48Hours = new Date(after48hours);
      let todiffDate = new Date(this.storeBookingList[index].to_date);
      dateAfter48Hours.setHours(0, 0, 0, 0);
      todiffDate.setHours(0, 0, 0, 0);
      const dayNameToId = {
        Sun: 0,
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6,
      };
      const dayNameToIdarabic = {
        'الأحد': 0,   // Sunday
        "الاثنين": 1, // Monday
        'الثلاثاء': 2, // Tuesday
        'الأربعاء': 3, // Wednesday
        'الخميس': 4,  // Thursday
        'الجمعة': 5,  // Friday
        'السبت': 6    // Saturday
      };

      let cheatDayIds = this.storeBookingList[index].cheat_day
        .split(',')
        .map((day) => dayNameToId[day] || dayNameToIdarabic[day]);
      let includedDates = [];
      for (
        let d = new Date(dateAfter48Hours);
        d <= todiffDate;
        d.setDate(d.getDate() + 1)
      ) {
        if (!cheatDayIds.includes(d.getDay())) {
          let formattedDate = `${d.getDate().toString().padStart(2, '0')}-${(
            d.getMonth() + 1
          )
            .toString()
            .padStart(2, '0')}-${d.getFullYear()}`;
          includedDates.push(formattedDate);
        }
      }

      this.storeParticularData = this.storeBookingList[index];
      this.storeParticularData.intake_cals_day = value;
      let menu_items = JSON.parse(this.storeBookingList[index].menu_items);
      let menuDates = menu_items.map((item) => item.dates);
      this.allDatesFound = true;
      for (let date of includedDates) {
        if (!menuDates.includes(date)) {
          this.allDatesFound = false;
          break;
        }
      }
      let uniqueObject = {};
      let uniqueArray = [];
      this.commonheadervalue = 'Dietheader';
      if (menu_items != null && menu_items != undefined) {
        menu_items.forEach((item) => {
          this.menuItemBookingDate.push(item.dates);
        });
        var selectedDateCount = menu_items;
        selectedDateCount.forEach((item) => {
          if (!uniqueObject[item['dates']]) {
            uniqueObject[item['dates']] = true;
            uniqueArray.push(item);
          }
        });
        this.menuItemBookingDate = uniqueArray;
      }
      this.dietBookingInfo = this.storeBookingList[index].DietBookedData[0];
    }
    if (value == 'bookingViewHis') {
      this.showcoment = true;
      this.backValue = 'goCanBookingList';
      this.CanMealbookingList = false;
      this.headerValue = this.addCall.title134;
      let value = this.storeBookingHisList[index];
      this.ChangeEventDiet.emit('profile');
      this.isShowHeaderValue = true;
      this.storeParticularData = this.storeBookingHisList[index];
      this.dietFromDate = this.storeBookingHisList[index].from_date;
      this.dietToDate = this.storeBookingHisList[index].to_date;
      this.dayOff = this.storeBookingHisList[index].cheat_day;
      this.storeParticularData.intake_cals_day = value.intake_cals_day;
      let menu_items = JSON.parse(this.storeBookingHisList[index].menu_items);
      let uniqueObject = {};
      this.commonheadervalue = 'Dietheader';
      let uniqueArray = [];
      menu_items.forEach((item) => {
        this.menuItemBookingDate.push(item.dates);
      });
      let selectedDateCount = menu_items;
      selectedDateCount.forEach((item) => {
        if (!uniqueObject[item['dates']]) {
          uniqueObject[item['dates']] = true;
          uniqueArray.push(item);
        }
      });
      this.menuItemBookingDate = uniqueArray;
      this.dietBookingInfo = this.storeBookingHisList[index].DiethistoryData[0];
      console.log('Patricular booking history - ', this.dietBookingInfo);
    }
  }
  canBookingList() {
    if (this.bookHisListReq) {
      this.bookHisListReq.unsubscribe();
    }
    this.presentView = 'historyPage';
    this.CanMealbookingList = true;
    this.MealbookingInfo = false;
    this.MealbookingList = false;
    this.backValue = 'goBookingList';
    this.headerValue = this.addCall.title134;
    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      limit: '10',
      pageno: this.pageNo,
      filter: false,
      modeId: 0,
    });
    this.bookHisListReq = this.services
      .postRequest('getdietbookinghistory', apiData)
      .subscribe((res) => {
        console.log(res);
        if (this.refEvent) {
          this.refEvent.target.complete();
        }
        if (this.pageNo == 1) {
          this.EmptyData = res.status;
        }
        let nextCount = res.status == 1 ? res.data[0].nextCount : 0;
        if (this.scrollEvent) {
          console.log('Scroll Entered');
          this.scrollEvent.target.complete();
          this.scrollEvent.target.disabled = nextCount == 0 ? true : false;
        }
        if (res.status == 1) {
          if (this.pageNo != 1 && this.search == false) {
            for (let item of res.data[0].details) {
              var just = JSON.parse(item.DiethistoryData);
              item.DiethistoryData = just;
              this.storeBookingHisList.push(item);
            }
          } else {
            for (let item of res.data[0].details) {
              var just = JSON.parse(item.DiethistoryData);
              item.DiethistoryData = just;
            }
            this.storeBookingHisList = res.data[0].details;
          }
        }
      });
  }

  gotopay() {
    console.log("Pay click")
    if (
      (this.DeliveryAddress || this.common.profileaddress) &&
      this.acceptTerms && this.DeliveryAddress != "null" && this.DeliveryAddress != "undefined" && this.DeliveryAddress != null
    ) {
      this.gopay();
    } else if (!this.acceptTerms) {
      // this.AlertInfo('Please accept terms amd condition.', 0);
      this.addCall.selectedLanguage == 'en' ? this.AlertInfo('Please accept terms amd condition.', 0) : this.AlertInfo('يرجى قبول الشروط والحالة.', 0);

    } else {

      this.addCall.selectedLanguage == 'en' ? this.AlertInfo(' Please enter the delivery address.', 0) : this.AlertInfo('الرجاء إدخال عنوان التوصيل', 0);
    }
  }

  async getbookingDates(frm: any, cname: any) {
    const loading = await this.loadingCtrl.create({
      message: 'Loading.....',
    });
    await loading.present();
    let apiData = JSON.stringify({
      dietBookingId: this.storeParticularData.dietbookingId,
    });
    this.services
      .postRequest('getDietBookingAllDatesById', apiData)
      .subscribe(async (res) => {
        let data = JSON.parse(res.data.result);
        this.bookedDates = [];
        for (let item of data) {
          this.bookedDates.push(item.date);
        }
        await loading.dismiss();
        this.viewMorebooking(frm, cname);
      });
  }

  async viewMorebooking(frm: any, cname: any) {
    const formattedBookedDates = this.bookedDates.map((dateString) => {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(
        date
      );
      const year = date.getFullYear().toString().slice(2);
      return `${day}-${month}-${year}`;
    });

    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        showselectdate: formattedBookedDates, //this.storesltdate,
      },
      cssClass: cname,
    });
    return await popover.present();
  }

  // async viewMoree(frm: any, cname: any) {

  //   this.cheat_days_dates = [];
  //   if (this.MealbookingInfo) {
  //     cname = 'bookingInfo';
  //     const tempStoreSelectedDiet = this.menuItemBookingDate;
  //     let newDateArray = [];
  //     tempStoreSelectedDiet.forEach((element) => {
  //       const resultDate = new Date(
  //         element.dates.split('-').reverse().join('-')
  //       );
  //       newDateArray.push(resultDate);
  //     });
  //     var newDateArrayFormatted = newDateArray.map((dates) => {
  //       let date = new Date(dates);
  //       const day = date.getDate().toString().padStart(2, '0');
  //       const month = new Intl.DateTimeFormat('en-US', {
  //         month: 'short',
  //       }).format(date);
  //       const year = date.getFullYear();
  //       return `${day}-${month}-${year}`;
  //     });
  //   } else {

  //     if (this.is_save_later && this.booking_id > 0) {
  //       let differnece = this.storeSelectedDiet.filter(
  //         (item) =>
  //           !this.edited_diet_menu.some(
  //             (otherItem) => otherItem.dates === item.dates
  //           )
  //       );
  //       const tempStoreSelectedDiet = differnece;
  //       const newStoreSelectedDiet = tempStoreSelectedDiet.filter(
  //         (diet, index, self) =>
  //           index ===
  //           self.findIndex(
  //             (item) =>
  //               item.diet_day_id === diet.diet_day_id &&
  //               item.diet_week_id === diet.diet_week_id
  //           )
  //       );
  //       let newDateArray = [];
  //       newStoreSelectedDiet.forEach((element) => {
  //         let formattedDate = element.dates;
  //         if (/^\d{4}-\d{2}-\d{2}$/.test(element.dates)) {
  //           const dateParts = element.dates.split('-');
  //           formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
  //         }
  //         const resultDate = new Date(
  //           formattedDate.split('-').reverse().join('-')
  //         );
  //         newDateArray.push(resultDate);
  //       });
  //       var newDateArrayFormatted = newDateArray.map((dates) => {
  //         let date = new Date(dates);
  //         const day = date.getDate().toString().padStart(2, '0');
  //         const month = new Intl.DateTimeFormat('en-US', {
  //           month: 'short',
  //         }).format(date);
  //         const year = date.getFullYear();
  //         return `${day}-${month}-${year}`;
  //       });
  //     } else {
  //       const tempStoreSelectedDiet = this.storeSelectedDiet;
  //       const newStoreSelectedDiet = tempStoreSelectedDiet.filter(
  //         (diet, index, self) =>
  //           index ===
  //           self.findIndex(
  //             (item) =>
  //               item.diet_day_id === diet.diet_day_id &&
  //               item.diet_week_id === diet.diet_week_id
  //           )
  //       );
  //       let newDateArray = [];
  //       newStoreSelectedDiet.forEach((element) => {
  //         // const resultDate =
  //         //   element.dates.split('-').reverse().join('-')
  //         // ;
  //         newDateArray.push(element.dates);
  //       });
  //       var newDateArrayFormatted = newDateArray.map((dates) => {
  //         var date = new Date(dates);
  //         const day = date.getDate().toString().padStart(2, '0');
  //         const month = new Intl.DateTimeFormat('en-US', {
  //           month: 'short',
  //         }).format(date);
  //         const year = date.getFullYear();
  //         return `${day}-${month}-${year}`;
  //       });
  //     }
  //   }

  //   let allDates = await this.getAllDates(this.dietFromDate, this.dietToDate);
  //   let availabledates = allDates.map(date => this.formatDated(date));
  //   allDates = availabledates.filter(date => !newDateArrayFormatted.includes(date));
  //   allDates = allDates.filter(date => {
  //     const dayOfWeek = this.getDayOfWeek(date);
  //     if ((this.dayOff.includes(dayOfWeek.english) || this.dayOff.includes(dayOfWeek.arabic))) {
  //       this.cheat_days_dates.push(date);
  //       return false;
  //     }
  //     return true;
  //   });
  //   // allDates = allDates.filter(date => !this.dayOff.includes(this.getDayOfWeek(date)));
  //   allDates = allDates.filter(date => {
  //     const dayOfWeek = this.getDayOfWeek(date);
  //     return !this.dayOff.includes(dayOfWeek.english) && !this.dayOff.includes(dayOfWeek.arabic);
  //   });


  //   let popover = await this.modalCtrl.create({
  //     component: ViewmodelPage,
  //     componentProps: {
  //       From: frm,
  //       startdate_month: this.dietFromDate,
  //       showselectdate: newDateArrayFormatted,
  //       diet_fromdate: allDates,
  //       diet_cheatdays: this.cheat_days_dates,
  //       vendor: 'Diet',
  //     },
  //     cssClass: cname,
  //   });
  //   return await popover.present();
  // }
  async viewMoree(frm: any, cname: any) {
    this.cheat_days_dates = [];
    if (this.MealbookingInfo) {
      cname = 'bookingInfo';
      const tempStoreSelectedDiet = this.menuItemBookingDate;
      let newDateArray = [];
      tempStoreSelectedDiet.forEach((element) => {
        const resultDate = new Date(
          element.dates.split('-').reverse().join('-')
        );
        newDateArray.push(resultDate);
      });
      var newDateArrayFormatted = newDateArray.map((dates) => {
        let date = new Date(dates);
        const day = date.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', {
          month: 'short',
        }).format(date);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      });
    } else {

      if (this.is_save_later && this.booking_id > 0) {
        let differnece = this.storeSelectedDiet.filter(
          (item) =>
            !this.edited_diet_menu.some(
              (otherItem) => otherItem.dates === item.dates
            )
        );
        const tempStoreSelectedDiet = differnece;
        const newStoreSelectedDiet = tempStoreSelectedDiet.filter(
          (diet, index, self) =>
            index ===
            self.findIndex(
              (item) =>
                item.diet_day_id === diet.diet_day_id &&
                item.diet_week_id === diet.diet_week_id
            )
        );
        let newDateArray = [];
        newStoreSelectedDiet.forEach((element) => {
          let formattedDate = element.dates;
          if (/^\d{4}-\d{2}-\d{2}$/.test(element.dates)) {
            const dateParts = element.dates.split('-');
            formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
          }
          const resultDate = new Date(
            formattedDate.split('-').reverse().join('-')
          );
          newDateArray.push(resultDate);
        });
        var newDateArrayFormatted = newDateArray.map((dates) => {
          let date = new Date(dates);
          const day = date.getDate().toString().padStart(2, '0');
          const month = new Intl.DateTimeFormat('en-US', {
            month: 'short',
          }).format(date);
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        });
      } else {
        const tempStoreSelectedDiet = this.storeSelectedDiet;
        const newStoreSelectedDiet = tempStoreSelectedDiet.filter(
          (diet, index, self) =>
            index ===
            self.findIndex(
              (item) =>
                item.diet_day_id === diet.diet_day_id &&
                item.diet_week_id === diet.diet_week_id
            )
        );
        let newDateArray = [];
        newStoreSelectedDiet.forEach((element) => {
          // const resultDate =
          //   element.dates.split('-').reverse().join('-')
          // ;
          newDateArray.push(element.dates);
        });
        var newDateArrayFormatted = newDateArray.map((dates) => {
          var date = new Date(dates);
          const day = date.getDate().toString().padStart(2, '0');
          const month = new Intl.DateTimeFormat('en-US', {
            month: 'short',
          }).format(date);
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        });
      }
    }

    console.log('this.dietFromDate, this.dietToDate',this.dietFromDate, this.dietToDate)
    let allDates = await this.getAllDates(this.dietFromDate, this.dietToDate);
    let availabledates = allDates.map(date => this.formatDated(date));
    allDates = availabledates.filter(date => !newDateArrayFormatted.includes(date));
    console.log("allDates 2",allDates)
    allDates = allDates.filter(date => {
          const dayOfWeek = this.getDayOfWeek(date);
          this.cheat_days_dates=this.dayOff;
          // this.cheat_days_dates = Array.isArray(this.cheat_days_dates) ? this.cheat_days_dates : [];
          // if ((this.dayOff.includes(dayOfWeek.english) || this.dayOff.includes(dayOfWeek.arabic))) {
          //   this.cheat_days_dates.push(date);
          //   return false;
          // }
          return true;
        }
      );
    // allDates = allDates.filter(date => !this.dayOff.includes(this.getDayOfWeek(date)));


    // allDates = allDates.filter(date => {
    //   const dayOfWeek = this.getDayOfWeek(date);
    //   return !this.dayOff.includes(dayOfWeek.english) && !this.dayOff.includes(dayOfWeek.arabic);
    // });
    // console.log("allDates 4",allDates)
    
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        startdate_month: this.dietFromDate,
        showselectdate: newDateArrayFormatted,
        diet_fromdate: allDates,
        diet_cheatdays: this.cheat_days_dates,
        vendor: 'Diet',
      },
      cssClass: cname,
    });
    return await popover.present();
  }
  async getAllDates(startDate, endDate) {
    let allDates = [];
    let currentDate = new Date(startDate);
    let stopDate = new Date(endDate);

    while (currentDate <= stopDate) {
      allDates.push(currentDate.toISOString().split('T')[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return allDates;
  }
  getDayOfWeek(dateStr) {
    const date = new Date(dateStr);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const daysAr = [
      "الأحد",
      "الاثنين",
      "الثلاثاء",
      "الأربعاء",
      "الخميس",
      "الجمعة",
      "السبت"
    ];
    const dayIndex = date.getDay();
    return {
      english: days[dayIndex],
      arabic: daysAr[dayIndex]
    };
    // return days[date.getDay()];
  }
  formatDated(dateString: string): string {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    };

    let formattedDate = date.toLocaleDateString('en-GB', options);

    // Replace spaces with hyphens and capitalize month abbreviation
    formattedDate = formattedDate
      .replace(/ /g, '-')      // Replace spaces with hyphens
      .replace(/-([a-z])/g, (match, p1) => `-${p1.toUpperCase()}`); // Capitalize month abbreviation

    return formattedDate;

  }

  async viewMorebeforebooking(frm: any, cname: any) {
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        showselectdate: this.storeSelectedDiet, //this.storesltdate,
      },
      cssClass: cname,
    });
    return await popover.present();
  }

  async gopay() {
    console.log("Go pay function")
    await this.presentModal1();
  }

  async insertBooking(response: any) {
    if (this.insertDietBookReq) {
      this.insertDietBookReq.unsubscribe();
    }
    const loading = await this.loadingCtrl.create({
      message: 'Processing Your Payment Status',
    });
    // let cheat_day = [];
    // if (this.is_cheat_day_available) {
    //   if (this.cheat_days.length > 0) {
    //     this.cheat_days.forEach((item) => {
    //       cheat_day.push(item.value);
    //     });
    //   }
    // }
    // if (!this.DeliveryAddress && (this.DeliveryAddress != null && this.DeliveryAddress != undefined && this.DeliveryAddress != "")) {
    // }
    await loading.present();
    // this.currentDate =
    //   new Date().getFullYear() +
    //   '-' +
    //   (new Date().getUTCMonth() + 1) +
    //   '-' +
    //   new Date().getDate() +
    //   ' ' +
    //   new Date().getHours() +
    //   ':' +
    //   new Date().getMinutes() +
    //   ':' +
    //   new Date().getSeconds();

    // let apiData = JSON.stringify({
    //   heightcm: this.getHeight,
    //   height_unit: 'cm', //this.heightUnit
    //   weightkg: this.getWeight,
    //   weight_unit: 'kg', //this.weightUnit
    //   goal_weight: this.getGoalWeight,
    //   goal_weight_unit: 'kg', //this.weightUnit
    //   bmi: this.BMIvalue,
    //   intake_calsday: this.calPerDay,
    //   durationdays: this.durationDays,
    //   anymedication: this.getAnyMadication,
    //   anydisease: this.getAnyDisease,
    //   anysurgery: this.getAnySurgery,
    //   anygoals: 'no',
    //   patientId: this.patient_id_walk, //localStorage.getItem("patient_id"),
    //   diet_vendor_id: this.vendor_id_walk,
    //   diet_package_id: this.storeDietPkgId,
    //   from_date: this.dietFromDate,
    //   to_date: this.dietToDate,
    //   amount: this.finalAmt, //this.prtclrDietPkgInfo.diet_price,
    //   payment_status: '1',
    //   cancel_status: '0',
    //   delivery_address: this.DeliveryAddress,
    //   menuitem: this.storeSelectedDiet,
    //   selecteddays: this.selDays,
    //   billing_amount: this.totalPrice,
    //   deal_amount: this.dealAmt,
    //   deal_option: this.dealOtp1,
    //   bookedDate: this.currentDate,
    //   cheat_days: cheat_day.toString(),
    //   delivery_contact_no: this.delivery_contact_no != "" ? this.delivery_contact_no : this.Phonno,
    //   package_duration_id: this.duration_id,
    //   package_duration_detail_id: this.duration_detail_id,
    //   delivery_time_id: this.delivery_time_id,
    //   delivery_instruction: this.delivery_instruction,
    //   is_save_later: this.is_save_later ? 1 : 0,
    //   appointment_type:"walk",
    //   walkin_id :this.sendLinkid,
    //   // paymentid: this.paymentid,
    //   // referenceid: this.referenceid,
    //   // order_id: this.orderId,
    //   // paymentGateway: this.paymentGateway
    // });
    let data = JSON.stringify(this.payload)
    this.insertDietBookReq = this.services
      .postRequest('insertdietbookingWalkin', data)
      .subscribe(async (res) => {
        console.log('insertBooking=>', res);
        await loading.dismiss();
        this.resetVariablesCheatDays();
        if (res.status == 1 && localStorage.getItem('cardType') == 'Knet') {
          this.is_save_later = false;
          this.menuLevel = 'No';
          this.showKnetPaymentDetals(response, this.addCall.title620);
          setTimeout(() => {
            this.playSound();
          }, 1000);
           await this.localClear();
        } else if (localStorage.getItem('cardType') == 'MasterCard') {
          this.is_save_later = false;
          this.menuLevel = 'No';
          this.router.navigate(['/payment', { paymentstatus: 1 }]);
        } else {
          this.resetVariablesCheatDays();
          this.presentToast(res.msg);
        }
      });
  }

  resetVariablesCheatDays() {
    this.weekDietDetail = [];
    this.acceptTerms = false;
    this.is_save_later = false;
    this.totalArray = [];
    this.cheat_day = [];
    this.cheat_daydays = [];
    this.cheat_days = [];
    this.finalArrayFood = [];
    this.week = '1';
  }
  playSound() {
    let audio = new Audio();
    audio.src = '../assets/audio/tick.mp3';
    audio.load();
    audio.play();
  }

  async paymentGatewayFunction(res: any, paymentGateway: any) {
    console.log(res);
    if (res.status == '1') {
      let loaddatastring = localStorage.getItem("requestdata")
      let loaddataobject = JSON.parse(loaddatastring)
      loaddataobject.paymentid = res.paymentId;    
      loaddataobject.referenceid = res.sessionid;    
      loaddataobject.order_id = res.orderId;    
      loaddataobject.paymentGateway = res.paymentGatewayName;   
      loaddataobject.payment_status = localStorage.getItem("paymentstatus") == "completed" ? "1" : "0";
      loaddataobject.payment_gateway_id=res.paymentGatewayId
      this.payload = loaddataobject
      // this.patientRoomBooking(res);
      this.insertBooking(res);
      this.playSound();
      // this.paymentid = res.resultid;
      // this.referenceid = res.sessionid;
      // this.orderId = res.orderId;
      // this.paymentGateway = res.paymentGatewayName;
      // this.insertBooking(res);
    } else if (res.status == '2') {
      console.log('payment faild');
      // this.AlertInfo(this.addCall.title685, 0);
      this.AlertInfo("Payment Cancelled", 0)
    } else {
      console.log('payment faild');
      if (paymentGateway == 'Knet') {
        this.showKnetPaymentDetals(res, 'Payment Failure Details');
      } else {
        this.AlertInfo(this.addCall.title685, 0);
      }
    }
  }

  async cancelBkng(bookingId, bookingAmnt) {
    this.storeBookingId = bookingId;
    this.storeBookingAmnt = bookingAmnt;
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt,
      },
    });
    modal.onDidDismiss().then((data) => {
      const res = data;
      if (res.data != null) {
        this.cancelBooking();
      }
    });
    return await modal.present();
  }

  async cancelBooking() {
    const loading = await this.loadingCtrl.create({
      message: 'Loading.....',
    });
    await loading.present();
    let apiData = JSON.stringify({
      cancelstatus: '1',
      dietbookingId: this.storeBookingId,
      patientId: localStorage.getItem('patient_id'),
    });
    this.services
      .postRequest('Canceldietorder', apiData)
      .subscribe(async (res) => {
        console.log(res);
        await loading.dismiss();
        if (res.status == 1) {
          this.pageNo = 1;
          this.storeBookingList = [];
          if (res.data[0].msgcode == 1) {
            this.AlertInfo(this.addCall.title449, res.status);
          } else if (res.data[0].msgcode == 2) {
            this.AlertInfo(this.addCall.title450, res.status);
          } else if (res.data[0].msgcode == 3) {
            this.AlertInfo(this.addCall.title451, 0);
          }
          this.bookingList();
        } else {
          this.AlertInfo(res.msg, res.status);
        }
      });
  }

  //---------------BackFlow-----------------//
  goBack(value) {
    ;
    if (value == 'goList') {
      this.presentView = 'listDietPage';
      this.ionViewWillEnter();
      this.backValue = 'goHome';
      this.headerValue = null;
      this.showcoment = true;
    } else if (value == 'goSelectPage') {
      this.showcoment = true;
      this.viwemorcl = false;
      this.backValue = 'goList';
      this.headerValue = this.storDietCmpnyProDetls.dietcompanyname;
      this.presentView = 'bookDietMealPage';
    } else if (value == 'goPackageSelect') {
      ;
      this.showcoment = true;
      this.viwemorcl = false;
      this.backValue = 'goList';
      this.menuLevel = undefined;
      this.delivery_time_id = 0;
      this.package_general_detail_data = [];
      this.storeDietFromDate = '';
      this.is_save_later = false;
      this.presentView = 'bookDietMealPage';
    } else if (value == 'goWeekSelectPage') {
      if (this.storeValue == 'MealPlan') {
        this.presentView = 'HealthyEatsPage';
        this.backValue = 'packageSelect';
        this.menuLevel = undefined;
        this.loadCalorgiesBasedOnDates();
        this.headerValue = this.headerValueForMenuList;
      } else if (this.storeValue == 'Repeat') {
        this.presentView = 'HealthyEatsPage';
        this.backValue = 'goCanBookingList';
        this.headerValue = this.dietCompanyName;
      }
    } else if (value == 'goBookingConPage') {
      this.showcoment = true;
      this.presentView = 'bookingConfirmPage';
      this.MealbookingInfo = true;
      this.backValue = 'goWeekSelectPage';
      this.headerValue = this.addCall.title40;
    } else if (value == 'goBookingList') {
      this.pageNo = 1;
      // if (this.saveandselect == false) {
      //   this.router.navigate(['/tabs/appointments', { moduleType: 'diet' }]);
      // }
      localStorage.setItem('bookview', "");
      localStorage.setItem('bookviewindex', "");
      localStorage.setItem('bookviewdays', "");
      this.ChangeEventDiet.emit('isDietBackHistory');
      this.commonheadervalue = '';
      this.EmptyData = null;
      this.storeBookingList = [];
      this.bookingList();
    } else if (value == 'goCanBookingList') {
      this.showcoment = true;
      this.pageNo = 1;
      this.EmptyData = null;
      this.storeBookingHisList = [];
      this.ChangeEventDiet.emit('isDietBackHistory');
      this.commonheadervalue = '';
      this.canBookingList();
    } else if (value == 'goHome') {
      this.showcoment = true;
      this.pageNo = 1;
      this.backValue = null;
      this.router.navigate(['/tabs/home']);
    } else if (value == 'packageSelect') {
      ;
      if (this.saveandselect == true) {
        this.router.navigate(['/tabs/appointments', { moduleType: 'diet' }]);
      }
      else {
        this.wekary = [];
        this.getMasterMenuList();
        setTimeout(() => {
          this.getPackageDetailMenu()
        }, 500);

      }

      this.showcoment = true;
      this.presentView = 'packageSelect';
      this.menuLevel = undefined;
      this.headerValue = this.addCall.title59;
      this.is_save_later = false;
      this.weekDietDetail = [];
      this.totalArray = [];
      this.cheat_day = [];
      this.cheat_daydays = [];
      this.cheat_days = [];
      this.finalArrayFood = [];
      this.week = '1';
      this.backValue = 'goPackageSelect';
      this.selectedsdate = '';
    } else {
      this.weekdayarray = [];
      this.weekDietDetail = [];
      this.storeDietFromDate = '';
      this.week_duration_detail_menu_list = [];
      this.showListDietPage();
      this.finalArrayFood = [];
      this.loadMenuItemList = [];
      this.showcoment = true;
    }
    this.isMuteVideo = false;
    this.acceptTerms = false

  }

  resetDietVariabels() {
    this.rate = null;
    this.presentView = null;
    this.Hspice = null;
    this.week = 'Week 1';
    this.day = 'Sun';
    this.heiweiType = 'cmsKgs';
    this.showWeightCalc = false;
    this.MealbookingInfo = null;
    this.MealbookingList = null;
    this.CanMealbookingList = null;
    this.backValue = null;
    this.headerValue = null;
    this.selectedDish = null;
    this.readonly = true;
    this.EditOrSave = 'Edit';
    this.height = this.addCall.title195;
    this.weight = this.addCall.title73;
    this.getHeight = null;
    this.getWeight = null;
    this.spice = [];
    this.DeliveryAddress = 'No Address';
    this.showRefundPopUp = null;
    this.playVid = null;
    this.ProfileVideo = null;
    this.playMode = false;
    this.storeValue = null;
    this.slctdMemVal = 'Name';
    this.swipe1 = false;
    this.swipe2 = false;
    this.swipe3 = false;

    //API variabel only---------
    this.getDietCompanyList = [];
    this.search = false;
    this.searchValue = null;
    this.EmptyData = null;
    this.activeVideoId = null;
    this.oldActiveVideoId = null;
    this.storeDietVendorId = null;
    this.storDietCmpnyProDetls = null;
    this.storeDietpackageDetails = [];
    this.storeFilterCategry = [];
    this.storeIntruction = [];
    this.storeBookingList = [];
    this.storeParticularData = null;
    this.storeBookingHisList = [];
    this.dietBookingInfo = null;
    this.storeBookingId = null;
    this.storeDietFromDate = null;
    this.storeSessionList = [];
    this.durationDetailMenuList = [];
    this.storeDietMenuId = null;
    this.storeDietPkgId = null;
    this.storeFilterCatId = [];
    this.storeDietPkgListIndex = null;
    this.StoreWeekDaysDiet = [];
    this.storeWeekDiet = [];
    this.storeDietDuration = null;
    this.storeNmOfWeek = [];
    this.storeWeekDays = ['Fri', 'Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu'];
    this.particulrSessionList = [];
    this.storeWeekIndex = 0;
    this.storeDaysIndex = 0;
    this.BMIvalue = null;
    this.BMICategory = null;
    this.getGoalWeight = null;
    this.patientBasicDetails = [];
    this.prtclrDietPkgInfo = null;
    this.getAnyMadication = null;
    this.getAnyDisease = null;
    this.getAnySurgery = null;
    this.getAnyHabits = null;
    this.heightUnit = null;
    this.weightUnit = null;
    this.inTakeClsPerDay = null;
    this.durationDays = 0;
    this.pageNo = 1;
    this.showVideoOptins = true;
    this.selectedDate = null;
    this.Date = null;
    this.setDate = null;
    this.storeSelectedDiet = [];
    this.storeFilterInstId = [];
    this.dietToDate = null;
    this.dietFromDate = null;
    this.storeBookingAmnt = null;
    this.RepeatWeek = null;
    this.dietCompanyName = '';
    this.repeatDietData = { bkgId: null, venId: null, bkgDate: null };
    this.EmptyData = null;
  }

  itemHeightFn(item, index) {
    // better performance if setting item height
    return 500;
  }

  userTrackBy(index, user) {
    return user.doctorId;
  }

  scrollMethod(event) {
    let elmnt = document.getElementById('scrolldiv');
    if (
      this.getDietCompanyList &&
      this.getDietCompanyList.length >= this.cardNum
    ) {
      let myElement = document.getElementById('listdiv_' + this.cardNum);
      if (document.getElementById('listdiv_' + this.cardNum)) {
        let bounding = myElement.getBoundingClientRect();
        let position = bounding.top + window.scrollY;
        if (
          ((bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.right <= window.innerWidth &&
            bounding.bottom <= window.innerHeight) ||
            elmnt.scrollTop > position) &&
          this.nextCount.includes(0) != true &&
          this.hitApi.includes(this.cardNum) != true
        ) {
          this.loadData1('');
          this.hitApi.push(this.cardNum);
          this.cardNum += 10;
        }
      }
    }
  }

  goToNextSlide(event) {
    console.log(event);
  }

  async addMember() {
    const modal = await this.modalCtrl.create({
      component: AddmemPage,
      cssClass: 'Add-Member-Page',
      componentProps: {
        getMemName: '',
        getMemGender: '',
        getMemReletion: '',
        getMemHeight: '',
        getMemWeight: '',
        getMemMobileNo: '',
        membDOB: '',
        getMemDob: '',
        memProImg: '',
      },
    });
    modal.onDidDismiss().then(async (data) => {
      const res = data;
      console.log(res);
      if (res.data.from == 2) {
        await this.getPatientBasicDetails();
      }
    });
    return await modal.present();
  }

  addinst(instadd: any, value) {
    console.log(instadd, 'ins');
    this.instadd = instadd;
    if (
      this.instra1.includes(instadd) == false &&
      value == 1 &&
      instadd != null &&
      instadd.length > 0
    ) {
      this.instra1.push(instadd);
      console.log('check1');
      this.instadd = null;
    } else if (this.instra1.includes(instadd) == true && value == 2) {
      console.log(this.instra1.indexOf(instadd));
      console.log('check2');
      this.instra1.splice(this.instra1.indexOf(instadd), 1);
    }

    console.log(this.instra1, 'li');
  }

  async reviewPopup(id, proImg, name, reviewcount, dietbookingid) {
    if (reviewcount == 0) {
      const alert = await this.modalCtrl.create({
        component: ReviewPage,
        cssClass: 'review-class',
        componentProps: {
          Id: id,
          Img: proImg,
          Name: name,
          From: 'Diet',
          bookingId: dietbookingid,
        },
      });
      alert.onDidDismiss().then((data) => {
        console.log(data);

        if (data.data == 'dismiss') {
          this.pageNo = 1;
          this.EmptyData = null;
          this.storeBookingHisList = [];
          this.canBookingList();
        }
      });
      await alert.present();
    }
  }

  async viewMore(frm: any, cname: any, data: any) {
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        paragraph: data,
      },
      cssClass: cname,
    });
    return await popover.present();
  }

  isElementInViewPort(el) {
    const rect = el.getBoundingClientRect();
    // Round the coordinates to the nearest integer using Math.round()
    const top = Math.round(rect.top);
    const left = Math.round(rect.left);
    const bottom = Math.round(rect.bottom);
    const right = Math.round(rect.right);

    // Check if the rounded coordinates satisfy the viewport conditions
    return (
      top >= 0 &&
      left >= 0 &&
      bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  pausePlay(id, mid) {
    const uniqueVideoId = `VideoLab${id}${mid}`;
    if (this.currentPlaying?.id !== uniqueVideoId) {
      if (this.currentPlaying) this.currentPlaying.pause();
      this.currentPlaying = document.getElementById(uniqueVideoId);
    }
    if (this.currentPlaying) {
      this.currentPlaying.paused
        ? this.currentPlaying.play()
        : this.currentPlaying.pause();
    }
  }

  didScrollEvent(event) {
    try {
      if (this.Addcheckvarible) return;

      const inViewPort = this.vdoPlayer.find((player) =>
        this.isElementInViewPort(player.nativeElement)
      );

      if (inViewPort && this.currentPlaying !== inViewPort.nativeElement) {
        if (this.currentPlaying) this.currentPlaying.pause();
        this.currentPlaying = inViewPort.nativeElement;
        this.currentPlaying.paused
          ? this.currentPlaying.play()
          : this.currentPlaying.pause();
      } else if (!inViewPort && this.currentPlaying) {
        this.currentPlaying.pause();
        this.currentPlaying = null;
      }
    } catch (err) {
      console.error(err);
    }
  }

  async playMedia() {
    try {
      await this.currentPlaying?.play();
      console.log('Played');
    } catch (err) {
      await this.currentPlaying?.pause();
      console.log('Paused - ', err);
      this.didScrollEvent(event);
    }
  }
  profileMediaDetails: any;
  mediaReq: any;
  getMedia(tr_id) {
    let tempArr = [];
    if (this.mediaReq) {
      this.mediaReq.unsubscribe();
    }
    this.profileMediaDetails = [];
    let apiData2 = JSON.stringify({
      doctorId: tr_id,
      limit: 1000,
      pageno: 1,
    });
    this.mediaReq = this.services
      .postRequest('getMediaDetailsByDoctor', apiData2)
      .subscribe((res) => {
        console.log('mediaDetails=>', res);
        for (let item of res.data[0].details) {
          tempArr.push(item);
          if (tempArr.length == 3) {
            this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
            console.log(this.profileMediaDetails, 'chcek media');
            tempArr = [];
          }
        }
        if (tempArr.length > 0) {
          this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
        }
        console.log(this.profileMediaDetails, 'media details');
      });
  }

  async openNdPlay(type: any, path: any, mode: any, thumbnail: any) {
    if (this.storedPath === path) {
      this.showPopover(type, path, thumbnail);
    } else {
      this.storedPath = path;
      this.showPopover(type, path, thumbnail);
    }
  }

  private async showPopover(type: any, path: any, thumbnail: any) {
    const popover = await this.modalCtrl.create({
      component: MediapopupPage,
      componentProps: {
        Type: type,
        Path: path,
        ThumNail: thumbnail,
      },
      cssClass: 'media-popup',
    });
    await popover.present();
  }

  rateSort() {
    console.log('lo', this.rateSortOrder);
    this.rateSoring = true;
    this.offerSoring = false;
    if (this.rateSortOrder == 'DESC') {
      this.rateSortOrder = 'DESC';
    } else if ((this.rateSortOrder = 'ASC')) {
      this.rateSortOrder = 'ASC';
    }
    this.pageNo = 1;
    this.showListDietPage();
  }

  async opensortpage() {
    const alert = await this.modalCtrl.create({
      component: RatingSortpagePage,
      showBackdrop: true,
      cssClass: 'rating_sort_page',
      backdropDismiss: false,
      componentProps: {
        frm: 'Diet',
      },
    });
    alert.onDidDismiss().then((data) => {
      console.log(data);
      console.log(data.data.orderWise, 'and', data.data.orderby);
      if (data.data.orderWise != null) {
        this.pageNo = 1;
        this.rateSoring = true;
        this.offerSoring = false;
        if (data.data.orderby == 'Rating') {
          if (this.rateSortOrder == 'DESC') {
            this.rateSortOrder = 'ASC';
          } else if ((this.rateSortOrder = 'ASC')) {
            this.rateSortOrder = 'DESC';
          }
          this.rateSortOrder = data.data.orderWise;
          this.serachDietCompany();
          this.showListDietPage();
        } else if (data.data.orderby == 'Deal') {
        } else if (data.data.orderby == 'Distance') {
          if (this.rateSortOrder == 'DESC') {
            this.rateSortOrder = 'DESC';
          } else if ((this.rateSortOrder = 'ASC')) {
            this.rateSortOrder = 'ASC';
          }
          this.rateSortOrder = data.data.orderWise;
          this.serachDietCompany();
          this.showListDietPage();
        }
      }
    });

    await alert.present();
  }

  sorting() {
    console.log(this.offrSortOrder);

    this.offerSoring = true;
    this.rateSoring = false;
    if (this.offrSortOrder == 'ASC') {
      this.offrSortOrder = 'DESC';
    } else if ((this.offrSortOrder = 'DESC')) {
      this.offrSortOrder = 'ASC';
    }
    this.pageNo = 1;
    this.showListDietPage();
  }

  pariculardiet: any;

  checkrepeat(value) {
    this.pariculardiet = value;
    this.AlertInfo(this.addCall.title524, 5);
  }

  selected_pack: any = [];
  programname: any;
  packind: any;
  packageindex: any;

  async select_program() {
    this.durationidvalue = 0;
    this.package_list = [];
    this.dution_detail_data = [];
    this.package_general_detail_data = [];
    this.cheat_days = [];
    this.duration_id = '';
    this.is_save_later = false;
    this.presentView = 'packageSelect';
    this.backValue = 'goPackageSelect';
    let data = JSON.stringify({
      vendor_id: this.storeDietVendorId,
    });

    this.services.dietRequest('getDietManagePackageListMember', data).subscribe(
      (res) => {
        if (res.data.length > 0) {
          if (
            this.duration_id != '' &&
            this.duration_id != undefined &&
            this.duration_id != 0
          ) {
            this.durationidvalue = 1;
          } else {
            this.durationidvalue = 0;
          }
          const groupedData = {};
          res.data.forEach((item) => {
            if (!groupedData[item.package_id]) {
              groupedData[item.package_id] = {
                package_id: item.package_id,
                package_name: item.package_name,
                image_path: item.file_path,
                dution_data: [],
              };
            }
            groupedData[item.package_id].dution_data.push({
              duration_id: item.duration_id,
              duration_days: item.duration_days,
              package_image: item.file_path,
            });
          });

          // Convert object to array
          const transformedData = Object.values(groupedData);
          this.package_list = transformedData;
          console.log('testing', this.package_list);
        } else {
          this.package_list = [];
        }

        this.detailId == false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  showHidepackage() {
    if (!this.showcoment) {
      this.showcoment = true;
    } else if (this.showcoment) {
      this.showcoment = false;
    }
  }
  explainervideo() {
    if (!this.dietExplainervideo) {
      this.dietExplainervideo = true;
    } else {
      this.dietExplainervideo = false
    }
  }
  package_duration_deal(item) {
    this.package_id = item.package_id;
    this.diet_package_name = item.servicename;
    this.duration_id = item.durationId;
    this.durationDays = item.duration_days;
    this.package_image = item.image_path;
    this.diet_details_id = item.diet_detail_id;
    this.duration_detail_id = 0;
    this.getDurationDetail();
    this.getPackageGeneralDetail();
    this.durationidvalue = 1;
    this.checked = true;
  }
  package_duration_change(value, item) {
    this.checked = false;
    this.package_id = item.package_id;
    this.diet_package_name = item.package_name;
    this.duration_id = value;
    this.durationDays = item.dution_data.filter(
      (obj) => obj.duration_id === parseInt(value)
    )[0].duration_days;
    this.package_image = item.dution_data.filter(
      (obj) => obj.duration_id === parseInt(value)
    )[0].package_image;
    this.duration_detail_id = 0;

    this.getDurationDetail();
    this.getPackageGeneralDetail();
    this.durationidvalue = 1;
  }
  numberOfMeals: any;
  numberOfSnacks: any;
  getDurationDetail() {
    ;
    this.dietCheckboxBtn = true;
    this.dution_detail_data = [];
    let data = JSON.stringify({
      duration_id: this.duration_id,
      vendor_id: this.storeDietVendorId,
      from: "alldata"
    });

    this.services.dietRequest('getDietPackageDetailsList', data).subscribe(
      (res) => {
        ;
        if (res.data.length > 0) {
          this.dution_detail_data = res.data.map((obj) => {
            obj['selected'] =
              this.duration_detail_id == obj.detail_id ? true : false;
            return obj;
          });
        } else {
          this.dution_detail_data = [];
        }
        if (this.checked == true) {

          this.changePackageDetail(false, this.diet_details_id, '');
        }

        if (this.booking_id > 0) {
          this.helthyEatspage('MealPlan', this.packind);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  headerValueForMenuList: any;
  changePackageDetail(selected, detail_id, headervalue) {
    this.dietCheckboxBtn = selected;
    this.headerValue = headervalue;
    this.headerValueForMenuList = headervalue;
    let temp_data = this.dution_detail_data;
    this.dution_detail_data = [];
    this.duration_detail_id = selected == true ? 0 : detail_id;
    this.durationDetailMenuList = [];
    let data: any = temp_data.map((obj: any) => {
      if (obj['detail_id'] == this.duration_detail_id) {
        obj['selected'] = true;
        this.package_diet_detail_name =
          obj['no_of_meals'] +
          (obj['no_of_meals'] > 1 ? ' Meals' : ' Meal') +
          (obj['no_of_snacks'] > 0 ? '-' : '') +
          (obj['no_of_snacks'] > 0 ? obj['no_of_snacks'] : '') +
          (obj['no_of_snacks'] == 0
            ? ''
            : obj['no_of_snacks'] > 1
              ? ' Snacks'
              : ' Snack');

        this.getPackageDetailMenu();
      } else {
        obj['selected'] = false;
        this.package_diet_detail_name = '';
      }
      return obj;
    });
    this.dution_detail_data = data;
    this.numberOfMeals = this.dution_detail_data.find(
      (x) => x.detail_id == detail_id
    ).no_of_meals;
    this.numberOfSnacks = this.dution_detail_data.find(
      (x) => x.detail_id == detail_id
    ).no_of_snacks;
    this.cdr.detectChanges();
  }
  selected_packagedetails(details, index) {
    this.scroll();
    console.log(details, 'details');
    this.selected_pack = details;
    this.showfilterCat(index, this.selected_pack);
    this.packind = index;
    this.programname = this.selected_pack.diet_package_name;
    if (this.selected_pack.diet_description.length > 118) {
      this.viewmore = true;
    } else {
      this.viewmore = false;
    }

    if (this.selected_pack.deal_id != null) {
      if (this.selected_pack.deal_options == 'Percentage') {
        this.offerAmt =
          Number(this.selected_pack.diet_price) -
          (Number(this.selected_pack.deal_amount) *
            Number(this.selected_pack.diet_price)) /
          100;
      } else if (this.selected_pack.deal_options == 'Amount') {
        this.offerAmt =
          Number(this.selected_pack.diet_price) -
          Number(this.selected_pack.deal_amount);
      }
    }
  }


  scrollByPoint() {
    this.content.scrollByPoint(100, 100, 300);
  }

  scroll() {
    this.content.scrollToBottom(1000);
  }
  scrolltop() {
    this.content.scrollToTop(100);
  }

  deal_dealid: any;
  async offrDtils(myEvent, dealDet, i, dietvendorid, header, details) {
    console.log(dealDet, '============================<><><><>');

    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        from: 'diet',
        dealdetails: dealDet,
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss().then((data) => {
      console.log(data.data);
      if (data.data) {
        this.deal_dealid = data.data.datafortrainer.deal_id;
        this.detailId = true;
        this.selectProfile(dietvendorid);
        this.duration_id = data.data.datafortrainer.durationId;
        this.package_duration_deal(data.data.datafortrainer);
        this.getDurationDetail();
      }
    });

    return await popover.present();
  }

  getLoader() {
    return 'assets/TOM_Loader.gif';
  }

  count: number = 0;
  dblClikedIndex: any;
  likedPopUpStatus: boolean;

  lastTapTime: number = 0;
  delay: number = 300;
  doubleClick(count, index, dietvendorId, isLiked) {
    const currentTime = new Date().getTime();
    const elapsedTime = currentTime - this.lastTapTime;
    if (elapsedTime < this.delay) {
      let _obj = this;
      this.makeLikes(index, dietvendorId, 1, 2, isLiked);
      this.count += Number(count);
      this.dblClikedIndex = index;
      this.likedPopUpStatus = true;
      setTimeout(() => {
        _obj.likedPopUpStatus = false;
      }, 1000);
    }
    this.lastTapTime = currentTime;
  }

  makeLikes(i, dietId, isLyk, from, isLiked) {
    try {
      let data = JSON.stringify({
        vendor_id: dietId,
        like: isLyk,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Diet',
        isLiked: isLiked,
      });
      const UpdateVendorLikes = this.services
        .postRequestDoc('UpdateVendorLikes', data)
        .subscribe(
          (res) => {
            console.log(res);
            if (this.getDietCompanyList[i].isLiked != 'true') {
              this.getDietCompanyList[i].likes_count =
                Number(this.getDietCompanyList[i].likes_count) + 1;
            }
            this.getDietCompanyList[i].isLiked = 'true';
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  makeLike(i, Dietvendorid, like, from, isLiked) {
    console.log('isliked', like);
    console.log('training centre id', Dietvendorid);
    console.log('like', from);
    try {
      if (this.getDietCompanyList[i].isLiked == null) {
        this.getDietCompanyList[i].isLiked = 'true';
        this.getDietCompanyList[i].likes_count =
          Number(this.getDietCompanyList[i].likes_count) + 1;
      }
      if (from == 2) {
        if (this.getDietCompanyList[i].isLiked == 'false') {
          this.getDietCompanyList[i].isLiked = 'true';
          this.getDietCompanyList[i].likes_count =
            Number(this.getDietCompanyList[i].likes_count) + 1;
        } else if (this.getDietCompanyList[i].isLiked == 'true') {
          this.getDietCompanyList[i].isLiked = 'false';
          this.getDietCompanyList[i].likes_count =
            Number(this.getDietCompanyList[i].likes_count) - 1;
        }
        if (this.getDietCompanyList[i].isLiked == null) {
          this.getDietCompanyList[i].isLiked = 'true';
          this.getDietCompanyList[i].likes_count =
            Number(this.getDietCompanyList[i].likes_count) + 1;
        }
      } else if (from == 1) {
        if (this.getDietCompanyList[i].isLiked == 'false') {
          this.getDietCompanyList[i].isLiked = 'true';
          this.getDietCompanyList[i].likes_count =
            Number(this.getDietCompanyList[i].likes_count) + 1;
        } else if (this.getDietCompanyList[i].isLiked == 'true') {
          this.getDietCompanyList[i].isLiked = 'false';
          this.getDietCompanyList[i].likes_count =
            Number(this.getDietCompanyList[i].likes_count) - 1;
        }
        if (this.getDietCompanyList[i].isLiked == null) {
          this.getDietCompanyList[i].isLiked = 'true';
          this.getDietCompanyList[i].likes_count =
            Number(this.getDietCompanyList[i].likes_count) + 1;
        }
      }
      let data = JSON.stringify({
        vendor_id: Dietvendorid,
        like: like,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Diet',
        isLiked: isLiked,
      });
      this.services.postRequestDoc('UpdateVendorLikes', data).subscribe(
        (res) => {
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    } catch (err) {
      console.log(err);
    }
  }

  makeLikeprofile(Dietvendorid, like, from) {
    console.log('isliked', like);
    console.log('training centre id', Dietvendorid);
    console.log('like', from);
    try {
      if (this.storDietCmpnyProDetls.isLiked == null) {
        this.storDietCmpnyProDetls.isLiked = 'true';
        this.storDietCmpnyProDetls.likes_count =
          Number(this.storDietCmpnyProDetls.likes_count) + 1;
      }
      if (from == 1) {
        if (this.storDietCmpnyProDetls.isLiked == 'false') {
          this.storDietCmpnyProDetls.isLiked = 'true';
          this.storDietCmpnyProDetls.likes_count =
            Number(this.storDietCmpnyProDetls.likes_count) + 1;
        } else if (this.storDietCmpnyProDetls.isLiked == 'true') {
          this.storDietCmpnyProDetls.isLiked = 'false';
          this.storDietCmpnyProDetls.likes_count =
            Number(this.storDietCmpnyProDetls.likes_count) - 1;
        }
      }
      let data = JSON.stringify({
        vendor_id: Dietvendorid,
        like: like,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Diet',
      });
      this.services.postRequestDoc('UpdateVendorLikes', data).subscribe(
        (res) => {
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    } catch (err) {
      console.log(err);
    }
  }
  async openAdvr() {
    window.localStorage['addType'] = 2;
    let popover = await this.modalCtrl.create({
      component: AdvertisementPage,
      componentProps: {
        addImg: this.addImg,
      },
      cssClass: this.dynClass,
    });
    popover.onDidDismiss().then((data) => {
      this.Addcheckvarible = false;
      if (!this.Addcheckvarible) {
        this.didScrollEvent(event);
      }
    });
    return await popover.present();
  }

  getAdd() {
    try {
      let min = new Date(new Date().setTime(new Date().getTime() + 3600000));
      let CT =
        min.toISOString().split('T')[0] +
        'T' +
        min.toTimeString().split(' ')[0];
      this.tymVal = CT;
      window.localStorage['DocADD'] = CT;

      let today = new Date().toISOString().split('T')[0];
      let data = JSON.stringify({
        vendor_type_id: 8,
        current_date: today,
      });
      this.services
        .postRequestGndrl('admin/get_current_advertisement', data)
        .subscribe(
          (res) => {
            if (res.data.length > 0) {
              this.Addcheckvarible = true;
              this.addImg = res.data[0].ad_path_name;
              if (res.data[0].ad_size == '2') {
                this.dynClass = 'advertisement1';
              } else if (res.data[0].ad_size == '1') {
                this.dynClass = 'advertisement2';
              }
              this.openAdvr();
            } else {
              this.Addcheckvarible = false;
              setTimeout(() => {
                this.didScrollEvent(event);
              }, 1000);
            }
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  async presentModal1() {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: 'SUCCESS!',
        messageContent: 'pay',
      },
    });
    modal.onDidDismiss().then(async (data) => {
      if (data.data == 'Knet' || data.data == 'Credit card') {
        console.log('data', data);
        this.gopayment = true;
        this.payType = data.data;
        const loading = await this.loadingCtrl.create({
          message: 'Please wait we are redirecting you to the payment gateway',
        });

        const billamountmastercard = this.formatMoney(this.finalAmt)
        let number = this.formatMoney(billamountmastercard);
        let billamountknet = number.replace(/,/g, "");
        localStorage.setItem("paymentAmt", billamountknet)
        await this.storepayload();
        if (data.data == "Credit card") {
          await loading.present();
          console.log("this.tempMemberName, this.Email, this.Phoneno, billamountmastercard",this.tempMemberName, this.Email, this.Phoneno, billamountmastercard)
          this.payment.getInitiatePayment(this.tempMemberName, this.Email_w, this.Phoneno, billamountmastercard)
            await loading.dismiss();
        } else if (data.data == "Knet") {
          await loading.present();
          // this.payment.getKnetsessionid("", this.Email, this.Phoneno, billamount).then(async (res: any) => {
            console.log("this.tempMemberName, this.Email, this.Phoneno, billamountmastercard",this.tempMemberName, this.Email, this.Phoneno, billamountmastercard)
          this.payment.getKnetPayment(this.tempMemberName, this.Email_w, this.Phoneno, billamountknet)
            await loading.dismiss();
        }

        // let res = {
        //   status: '1',
        // };
        // this.paymentGatewayFunction(res, 'MASTER');
        // if (data.data == '1') {
        //   await loading.present();
        //   this.payment
        //     .getsessionid(
        //       this.slctdMemVal,
        //       this.Email,
        //       this.Phonno,
        //       this.finalAmt
        //     )
        //     .then(async (res: any) => {
        //       console.log(res, 'response');
        //       await loading.dismiss();
        //       this.paymentGatewayFunction(res, 'MASTER');
        //     });
        // } else if (data.data == '2') {
        //   await loading.present();
        //   this.payment
        //     .getKnetsessionid('', this.Email, this.Phonno, this.finalAmt)
        //     .then(async (res: any) => {
        //       console.log(res, 'response');
        //       await loading.dismiss();
        //       this.paymentGatewayFunction(res, 'KNET');
        //     });
        // }
        // else if (data.data == '3') {
        //   await loading.present();
        //   this.payment
        //     .getApplesessionid(this.slctdMemVal, this.Email, this.Phonno, this.finalAmt)
        //     .then(async (res: any) => {
        //       console.log(res, 'response');
        //       await loading.dismiss();
        //       this.paymentGatewayFunction(res, 'APPLE PAY');
        //     });
        // }

        // localStorage.setItem('payBack', 'dietmeal');
        this.payType = "";
        this.gopayment = false
      }
    });
    return await modal.present();
  }


  formatMoney (number: any) {
    const num = Number(number)
    const options = {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    };

    const formattedNumber = num.toLocaleString('en-US', options);
    const parts = formattedNumber.split('.');
    if (parts.length === 1) {
        return `${formattedNumber}.000`;
      } else {
        const decimalPart = parts[1].padEnd(3, '0');
        return `${parts[0]}.${decimalPart}`;
      }
  }


  async storepayload(){
    let cheat_day = [];
    if (this.is_cheat_day_available) {
      if (this.cheat_days.length > 0) {
        this.cheat_days.forEach((item) => {
          cheat_day.push(item.value);
        });
      }
    }
    if (!this.DeliveryAddress && (this.DeliveryAddress != null && this.DeliveryAddress != undefined && this.DeliveryAddress != "")) {
    }
    this.currentDate =
      new Date().getFullYear() +
      '-' +
      (new Date().getUTCMonth() + 1) +
      '-' +
      new Date().getDate() +
      ' ' +
      new Date().getHours() +
      ':' +
      new Date().getMinutes() +
      ':' +
      new Date().getSeconds();

    let requestdata  = JSON.stringify({
      heightcm: this.getHeight,
      height_unit: 'cm', //this.heightUnit
      weightkg: this.getWeight,
      weight_unit: 'kg', //this.weightUnit
      goal_weight: this.getGoalWeight,
      goal_weight_unit: 'kg', //this.weightUnit
      bmi: this.BMIvalue,
      intake_calsday: this.calPerDay,
      durationdays: this.durationDays,
      anymedication: this.getAnyMadication,
      anydisease: this.getAnyDisease,
      anysurgery: this.getAnySurgery,
      anygoals: 'no',
      patientId: this.patient_id_walk,
      diet_vendor_id: this.vendor_id_walk,
      diet_package_id: this.storeDietPkgId,
      from_date: this.dietFromDate,
      to_date: this.dietToDate,
      amount: this.finalAmt, //this.prtclrDietPkgInfo.diet_price,
      cancel_status: '0',
      delivery_address: this.DeliveryAddress,
      menuitem: this.storeSelectedDiet,
      selecteddays: this.selDays,
      billing_amount: this.totalPrice,
      deal_amount: this.dealAmt,
      deal_option: this.dealOtp1,
      bookedDate: this.currentDate,
      cheat_days: cheat_day.toString(),
      delivery_contact_no: this.delivery_contact_no != "" ? this.delivery_contact_no : this.Phonno,
      package_duration_id: this.duration_id,
      package_duration_detail_id: this.duration_detail_id,
      delivery_time_id: this.delivery_time_id,
      delivery_instruction: this.delivery_instruction,
      is_save_later: this.is_save_later ? 1 : 0,
      appointment_type:"walk",
      walkin_id :this.sendLinkid,
      // paymentid: this.paymentid,
      // referenceid: this.referenceid,
      // order_id: this.orderId,
      // paymentGateway: this.paymentGateway,
      // payment_status: localStorage.getItem("paymentstatus") == "completed" ? "2" : "0",
    });
    localStorage.setItem("requestdata",requestdata)
}




  async showKnetPaymentDetals(data: any, msg: string) {
    const modal = await this.modalCtrl.create({
      component: knetPaymentDetailsPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: msg,
        messageContent: data,
      },
    });

    modal.onDidDismiss().then(async (data) => {
      if (msg == 'Payment Success Details' || msg == "تفاصيل عملية الدفع") {
        this.router.navigate(['payment', { paymentstatus: 1 }]);
      }
    });
    return await modal.present();
  }

  getPackageGeneralDetail() {
    this.package_general_detail_data = [];
    let data = JSON.stringify({
      package_id: this.package_id,
      from: this.booking_id > 0 ? "Allpackage" : "Activepackage"
    });

    this.services.dietRequest('getPackageGeneralDetails', data).subscribe(
      (res) => {
        if (res.data.length > 0) {
          ;
          this.datevalue = res.data[0].book_in_days;
          this.is_cheat_day_available =
            res.data[0]['is_cheat_day_available'] == 1 ? true : false;
          let delivery_time =
            res.data[0]['delivery_time_details'] != '' &&
              res.data[0]['delivery_time_details']
              ? JSON.parse(res.data[0]['delivery_time_details'])
              : [];
          this.delivery_time_id = delivery_time[0].delivery_time_id;

          if (delivery_time.length > 0) {
            if (this.addCall.selectedLanguage != 'ea') {
              this.package_general_detail_data = delivery_time.map(
                (obj: any) => {
                  return {
                    id: obj.delivery_time_id,
                    value:
                      moment(obj.from_time, 'HH:mm:ss.SSSSSS').format(
                        'hh:mm a'
                      ) +
                      ' - ' +
                      moment(obj.to_time, 'HH:mm:ss.SSSSSS').format('hh:mm a'),
                  };
                }
              );
            } else if (this.addCall.selectedLanguage == 'ea') {
              this.package_general_detail_data = delivery_time.map(
                (obj: any) => {
                  return {
                    id: obj.delivery_time_id,
                    value:
                      moment(obj.to_time, 'HH:mm:ss.SSSSSS').format('hh:mm a') +
                      ' - ' +
                      moment(obj.from_time, 'HH:mm:ss.SSSSSS').format(
                        'hh:mm a'
                      ),
                  };
                }
              );
            }
            this.delivery_time = this.package_general_detail_data.filter(
              (obj) => {
                return obj.id == this.delivery_time_id;
              }
            )[0]['value'];
          } else {
            this.package_general_detail_data = [];
          }
        } else {
          this.package_general_detail_data = [];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  onDeliveryTimeChange(event: any) {
    this.delivery_time_id = event.detail.value;
    this.delivery_time = this.package_general_detail_data.filter((obj) => {
      return obj.id == this.delivery_time_id;
    })[0]['value'];
  }

  saveAndlaterChange() {
    this.is_save_later = !this.is_save_later;
  }

  getPackageDetailMenu() {
    let data = {
      detail_id: this.duration_detail_id,
      package_id: this.package_id,
      modulefrom: this.booking_id > 0 ? "Alldata" : "Active",
    };
    this.services.dietRequest('getDietPacakgeDetailsMenuList', data).subscribe(
      (res) => {
        if (res.data.length > 0) {
          let data = res.data.reduce((acc, item) => {
            const { master_menu_id, ...rest } = item;

            if (!acc[master_menu_id]) {
              acc[master_menu_id] = [];
            }

            acc[master_menu_id].push(rest);

            return acc;
          }, {});

          this.duration_detail_menu_list = [];
          let duration_detail_menu_list = [];
          this.master_menu_list.map((obj) => {
            if (data[obj['id']]) {
              obj.item_list.map((obj_data) => {
                obj_data['is_selected'] = false;
                let filter_data = data[obj['id']].filter((obj_filter_data) => {
                  return obj_filter_data.menu_id == obj_data.item_id;
                });
                if (filter_data.length > 0) {
                  obj_data['order_no'] = filter_data[0]['mmi'];
                }
                return obj_data;
              });
              obj.item_list = obj.item_list.sort(
                (a, b) => a.order_no - b.order_no
              );
              duration_detail_menu_list.push(obj);
            }
          });

          this.duration_detail_menu_list = duration_detail_menu_list;
          this.duration_detail_menu_list_copy = [
            ...this.duration_detail_menu_list,
          ];
          if (
            Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0
          ) {
            this.generateWeekArraySaveSelectLater();
          }
        } else {
          this.duration_detail_menu_list = [];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  getWeekNumberBasedOnDate(date, index, OldWeek) {
    const startOfYear = new Date(date.getFullYear(), date.getMonth(), 1);
    const days = Math.floor(
      (date.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000)
    );
    const weekNumber1 = Math.ceil((days + startOfYear.getDay() + 1) / 7);
    if (index == 0) {
      var oldWeekNumber = weekNumber1 >= 1 ? 1 : weekNumber1;
    } else {
      let i = index - 1;
      let OldWeekNumber = OldWeek[i].week_id;
      oldWeekNumber = OldWeekNumber + 1;
    }

    return oldWeekNumber;
  }

  dayCount: any = 0;
  cheat_daydays: any[] = [];
  diff: any;
  totalArray: any = [];

  isIsoDateFormat(dateString) {
    // Regular expression for "YYYY-MM-DD" format
    const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;
    return isoDatePattern.test(dateString);
  }
  convertToIsoFormat(dateString) {
    const monthMapping = {
      Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06', Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12',
      يناير: '01', فبراير: '02', مارس: '03', أبريل: '04', مايو: '05', يونيو: '06',
      يوليو: '07', أغسطس: '08', سبتمبر: '09', أكتوبر: '10', نوفمبر: '11', ديسمبر: '12'
    };
    const dateParts = dateString.split('-').map(part => part.trim());
    const day = dateParts[0].padStart(2, '0');
    const month = monthMapping[dateParts[1]];
    const year = '20' + dateParts[2];

    return `${year}-${month}-${day}`;
  }
  calculateDietToDate(dietFromDate, durationDays, cheatDays) {
    let startDate = new Date(dietFromDate);
    let Days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let completedDays = 0;
    let currentDate = new Date(startDate);

    // Debugging Output
    console.log(`Starting Calculation from: ${startDate.toDateString()}`);

    // Check if the starting day is a non-cheat day
    let startDay = currentDate.getDay();
    let startDayName = Days[startDay];
    let isStartCheatDay = cheatDays.some(cheatDay => cheatDay.is_checked && cheatDay.days === startDayName);

    if (!isStartCheatDay) {
      completedDays++; // Start day is counted as the first non-cheat day
      console.log(`Start Date is a Non-Cheat Day: ${startDayName}`);
    } else {
      console.log(`Start Date is a Cheat Day: ${startDayName}`);
    }

    // Continue searching for the remaining non-cheat days
    while (completedDays < durationDays) {
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
      let currentDay = currentDate.getDay();
      let dayName = Days[currentDay];

      // Debugging Output
      console.log(`Checking Date: ${currentDate.toDateString()} - ${dayName}`);

      // Check if the current day is NOT a cheat day
      let isCheatDay = cheatDays.some(cheatDay => cheatDay.is_checked && cheatDay.days === dayName);

      if (!isCheatDay) {
        completedDays++;
        // Debugging Output
        console.log(`Incrementing Days. Completed Days: ${completedDays}`);
      } else {
        // Debugging Output
        console.log(`Skipping Cheat Day: ${dayName}`);
      }
    }

    let year = currentDate.getFullYear();
    let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    let day = String(currentDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  generateWeekArray() {

    this.dayCount = 0;
    this.totalArray = [];
    const weeksArray = [];
    this.weekDietDetail = [];

    if (!this.isIsoDateFormat(this.dietFromDate)) {
      this.dietFromDate = this.convertToIsoFormat(this.dietFromDate);
    }

    let currentDated = new Date(this.dietFromDate);
    let i = 0;
    if (this.dietFromDate == this.dietToDate) {
      while (currentDated < new Date(this.dietToDate)) {
        const weekNumber = this.getWeekNumberBasedOnDate(
          currentDated,
          i,
          weeksArray
        );
        const weekName = this.addCall.title686 + weekNumber;
        const monthName = currentDated.toLocaleString(undefined, {
          month: 'short',
        });
        const weekStartDate = this.getWeekStartDate(currentDated);
        const weekEndDate = this.getWeekEndDate(currentDated);
        let dateArr = [];

        if (i == 0) {
          currentDated = weekStartDate;
          dateArr = [
            {
              date: this.formatDate(currentDated),
              day_id: currentDated.getDay(),
              day:
                currentDated.getDate() > 9
                  ? currentDated.getDate()
                  : '0' + currentDated.getDate(),
              day_txt: currentDated
                .toLocaleString('default', { weekday: 'long' })
                .substring(0, 3),
              daytext:
                localStorage.getItem('selectedLanguage') == 'ea'
                  ? currentDated.toLocaleString('ar', { weekday: 'long' })
                  : currentDated
                    .toLocaleString('default', { weekday: 'long' })
                    .substring(0, 3),
              is_disabled: this.checkIsDisabled(currentDated),
            },
          ];
        } else {
          currentDated = weekStartDate;
          dateArr = [
            {
              date: this.formatDate(currentDated),
              day_id: currentDated.getDay(),
              day:
                currentDated.getDate() > 9
                  ? currentDated.getDate()
                  : '0' + currentDated.getDate(),
              day_txt: currentDated
                .toLocaleString('default', { weekday: 'long' })
                .substring(0, 3),
              daytext:
                localStorage.getItem('selectedLanguage') == 'ea'
                  ? currentDated.toLocaleString('ar', { weekday: 'long' })
                  : currentDated
                    .toLocaleString('default', { weekday: 'long' })
                    .substring(0, 3),
              is_disabled: this.checkIsDisabled(currentDated),
            },
          ];
        }
        let nextDate = new Date(currentDated);
        nextDate.setDate(nextDate.getDate() + 1);
        while (nextDate <= weekEndDate) {
          var data = {
            date: this.formatDate(nextDate),
            day_id: nextDate.getDay(),
            day:
              nextDate.getDate() > 9
                ? nextDate.getDate()
                : '0' + nextDate.getDate(),
            day_txt: nextDate
              .toLocaleString('default', { weekday: 'long' })
              .substring(0, 3),
            daytext:
              localStorage.getItem('selectedLanguage') == 'ea'
                ? nextDate.toLocaleString('ar', { weekday: 'long' })
                : nextDate
                  .toLocaleString('default', { weekday: 'long' })
                  .substring(0, 3),
            is_disabled: this.checkIsDisabled(nextDate),
          };
          dateArr.push(data);
          nextDate.setDate(nextDate.getDate() + 1);
        }
        if (this.durationDays < 7) {
          for (let i = 0; i < dateArr.length; i++) {
            if (
              (new Date(dateArr[i].date) < new Date(this.dietFromDate) ||
                new Date(dateArr[i].date) >= new Date(this.dietToDate))
            ) {
              dateArr[i].is_availdisabled = true;
              dateArr[i].is_cheat_day_available = false;
            } else {
              dateArr[i].is_availdisabled = false;
              dateArr[i].is_cheat_day_available = false;
            }
            const element = dateArr;
          }

        }
        else {
          for (let i = 0; i < dateArr.length; i++) {
            if (
              new Date(dateArr[i].date) < new Date(this.dietFromDate) ||
              new Date(dateArr[i].date) > new Date(this.dietToDate)
            ) {
              dateArr[i].is_availdisabled = true;
              dateArr[i].is_cheat_day_available = false;
            } else {
              dateArr[i].is_availdisabled = false;
              dateArr[i].is_cheat_day_available = false;
            }
            const element = dateArr;
          }

        }
        if (this.is_cheat_day_available) {
          if (this.cheat_day.length >= 1) {
            if (this.cheat_day.value == 'Skip') {
              dateArr = dateArr.filter(
                (item1) =>
                  !this.cheat_day.some((item2) => item2.value === item1.day_txt)
              );
            } else {
              for (let index = 0; index < this.cheat_day.length; index++) {
                for (let i = 0; i < dateArr.length; i++) {
                  if (this.cheat_day[index].days == dateArr[i].day_txt) {
                    dateArr[i].is_cheat_day_available = true;
                    this.cheat_daydays.push(this.cheat_day[index].days);
                  }
                }
              }
            }
          } else {
            dateArr = dateArr;
          }
        }
        if (this.cheat_daydays.length > 0) {
          let uniqueArray = [];
          let seenElements = {};
          this.cheat_daydays.forEach((element) => {
            if (!seenElements[element]) {
              uniqueArray.push(element);
              seenElements[element] = true;
            }
          });
          this.cheat_daydays = [];
          this.cheat_daydays = uniqueArray;
        }
        let uniqueArray = [...new Set(this.cheat_daydays)];
        console.log(uniqueArray);
        this.dayCount = this.dayCount + dateArr.length;
        weeksArray.push({
          date_arr: dateArr,
          week_id: weekNumber,
          week_name: weekName,
          month_name: monthName,
        });

        i = i + 1;
        // Move to the next week
        if (this.durationDays <= 7) {
          currentDated = new Date(nextDate);
        } else {
          currentDated.setDate(currentDated.getDate() + 7);
        }
      }
    }
    else {
      if (this.cheat_days != "") {
        if (this.durationDays < 7) {

          this.dietToDate = this.calculateDietToDate(this.dietFromDate, this.durationDays, this.cheat_days);
        }

      }
      // console.log("checking",dietToDate)
      while (currentDated <= new Date(this.dietToDate)) {
        const weekNumber = this.getWeekNumberBasedOnDate(
          currentDated,
          i,
          weeksArray
        );
        const weekName = this.addCall.title686 + weekNumber;
        const monthName = currentDated.toLocaleString(undefined, {
          month: 'short',
        });
        const weekStartDate = this.getWeekStartDate(currentDated);
        const weekEndDate = this.getWeekEndDate(currentDated);
        let dateArr = [];

        if (i == 0) {
          currentDated = weekStartDate;
          dateArr = [
            {
              date: this.formatDate(currentDated),
              day_id: currentDated.getDay(),
              day:
                currentDated.getDate() > 9
                  ? currentDated.getDate()
                  : '0' + currentDated.getDate(),
              day_txt: currentDated
                .toLocaleString('default', { weekday: 'long' })
                .substring(0, 3),
              daytext:
                localStorage.getItem('selectedLanguage') == 'ea'
                  ? currentDated.toLocaleString('ar', { weekday: 'long' })
                  : currentDated
                    .toLocaleString('default', { weekday: 'long' })
                    .substring(0, 3),
              is_disabled: this.checkIsDisabled(currentDated),
            },
          ];
        } else {
          currentDated = weekStartDate;
          dateArr = [
            {
              date: this.formatDate(currentDated),
              day_id: currentDated.getDay(),
              day:
                currentDated.getDate() > 9
                  ? currentDated.getDate()
                  : '0' + currentDated.getDate(),
              day_txt: currentDated
                .toLocaleString('default', { weekday: 'long' })
                .substring(0, 3),
              daytext:
                localStorage.getItem('selectedLanguage') == 'ea'
                  ? currentDated.toLocaleString('ar', { weekday: 'long' })
                  : currentDated
                    .toLocaleString('default', { weekday: 'long' })
                    .substring(0, 3),
              is_disabled: this.checkIsDisabled(currentDated),
            },
          ];
        }
        let nextDate = new Date(currentDated);
        nextDate.setDate(nextDate.getDate() + 1);
        while (nextDate <= weekEndDate) {
          var data = {
            date: this.formatDate(nextDate),
            day_id: nextDate.getDay(),
            day:
              nextDate.getDate() > 9
                ? nextDate.getDate()
                : '0' + nextDate.getDate(),
            day_txt: nextDate
              .toLocaleString('default', { weekday: 'long' })
              .substring(0, 3),
            daytext:
              localStorage.getItem('selectedLanguage') == 'ea'
                ? nextDate.toLocaleString('ar', { weekday: 'long' })
                : nextDate
                  .toLocaleString('default', { weekday: 'long' })
                  .substring(0, 3),
            is_disabled: this.checkIsDisabled(nextDate),
          };
          dateArr.push(data);
          nextDate.setDate(nextDate.getDate() + 1);
        }
        if (this.durationDays < 7) {
          for (let i = 0; i < dateArr.length; i++) {
            if (
              (new Date(dateArr[i].date) < new Date(this.dietFromDate) ||
                new Date(dateArr[i].date) >= new Date(this.dietToDate))
            ) {
              dateArr[i].is_availdisabled = true;
              dateArr[i].is_cheat_day_available = false;
            } else {
              dateArr[i].is_availdisabled = false;
              dateArr[i].is_cheat_day_available = false;
            }
            const element = dateArr;
          }

        }
        else {
          for (let i = 0; i < dateArr.length; i++) {
            if (
              new Date(dateArr[i].date) < new Date(this.dietFromDate) ||
              new Date(dateArr[i].date) > new Date(this.dietToDate)
            ) {
              dateArr[i].is_availdisabled = true;
              dateArr[i].is_cheat_day_available = false;
            } else {
              dateArr[i].is_availdisabled = false;
              dateArr[i].is_cheat_day_available = false;
            }
            const element = dateArr;
          }

        }
        if (this.is_cheat_day_available) {
          if (this.cheat_day.length >= 1) {
            if (this.cheat_day.value == 'Skip') {
              dateArr = dateArr.filter(
                (item1) =>
                  !this.cheat_day.some((item2) => item2.value === item1.day_txt)
              );
            } else {
              for (let index = 0; index < this.cheat_day.length; index++) {
                for (let i = 0; i < dateArr.length; i++) {
                  if (this.cheat_day[index].days == dateArr[i].day_txt) {
                    dateArr[i].is_cheat_day_available = true;
                    this.cheat_daydays.push(this.cheat_day[index].days);
                  }
                }
              }
            }
          } else {
            dateArr = dateArr;
          }
        }
        if (this.cheat_daydays.length > 0) {
          let uniqueArray = [];
          let seenElements = {};
          this.cheat_daydays.forEach((element) => {
            if (!seenElements[element]) {
              uniqueArray.push(element);
              seenElements[element] = true;
            }
          });
          this.cheat_daydays = [];
          this.cheat_daydays = uniqueArray;
        }
        let uniqueArray = [...new Set(this.cheat_daydays)];
        console.log(uniqueArray);
        this.dayCount = this.dayCount + dateArr.length;
        weeksArray.push({
          date_arr: dateArr,
          week_id: weekNumber,
          week_name: weekName,
          month_name: monthName,
        });

        i = i + 1;
        // Move to the next week
        if (this.durationDays <= 7) {
          currentDated = new Date(nextDate);
        } else {
          currentDated.setDate(currentDated.getDate() + 7);
        }
      }
    }
    if (this.cheat_day.length > 0 && this.cheat_day[0].days != 'Skip') {
      for (let index = 0; index <= weeksArray.length; index++) {
        if (
          weeksArray[index] != undefined &&
          weeksArray[index].date_arr != undefined
        ) {
          for (let i = 0; i < weeksArray[index].date_arr.length; i++) {
            this.totalArray.push(weeksArray[index].date_arr[i]);
          }
        }
      }
      var total = this.totalArray.filter(
        (x) => x.is_availdisabled == false && x.is_cheat_day_available == false
      );
      if (Number(total.length) < Number(this.durationDays)) {
        var diff = Number(this.durationDays) - Number(total.length);
        if (diff > 0) {
          var endDate = new Date(this.dietToDate);
        }
        while (diff > 0) {
          endDate.setDate(endDate.getDate() + 1);
          let Days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
          let day = endDate.getDay();
          let dayName = Days[day];
          let dayCondition = this.cheat_daydays.includes(dayName);
          if (!dayCondition) {
            var finalArry = [];
            for (let index = 0; index <= this.weekDietDetail.length; index++) {
              if (
                this.weekDietDetail[index] != undefined &&
                this.weekDietDetail[index].date_arr != undefined
              ) {
                for (
                  let i = 0;
                  i < this.weekDietDetail[index].date_arr.length;
                  i++
                ) {
                  if (this.weekDietDetail[index].date_arr[i] != undefined) {
                    let contains = this.cheat_daydays.includes(
                      this.weekDietDetail[index].date_arr[i].day_txt
                    );
                    var level = finalArry.filter(
                      (x) =>
                        x.is_availdisabled == false &&
                        x.is_cheat_day_available == false
                    );
                    if (contains) {
                      if (this.durationDays < 7) {
                        var duration = this.durationDays - 1;
                        const endDate = this.calculateEndDate(this.dietFromDate, duration);
                        this.dietToDate = endDate

                        if (
                          new Date(this.weekDietDetail[index].date_arr[i].date) <
                          new Date(this.dietFromDate) ||
                          new Date(this.weekDietDetail[index].date_arr[i].date) >
                          new Date(this.dietToDate)
                        ) {
                          if (
                            level.length == Number(this.durationDays) ||
                            level.length == 0
                          ) {
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_cheat_day_available = false;
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_availdisabled = true;
                          } else {
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_cheat_day_available = true;
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_availdisabled = false;
                          }
                        } else {
                          // Cheat Day Available
                          this.weekDietDetail[index].date_arr[
                            i
                          ].is_cheat_day_available = true;
                          this.weekDietDetail[index].date_arr[
                            i
                          ].is_availdisabled = false;
                        }
                      }

                      else {
                        if (
                          new Date(this.weekDietDetail[index].date_arr[i].date) <
                          new Date(this.dietFromDate) ||
                          new Date(this.weekDietDetail[index].date_arr[i].date) >
                          new Date(this.dietToDate)
                        ) {
                          if (
                            level.length == Number(this.durationDays) ||
                            level.length == 0
                          ) {
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_cheat_day_available = false;
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_availdisabled = true;
                          } else {
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_cheat_day_available = true;
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_availdisabled = false;
                          }
                        } else {
                          // Cheat Day Available
                          this.weekDietDetail[index].date_arr[
                            i
                          ].is_cheat_day_available = true;
                          this.weekDietDetail[index].date_arr[
                            i
                          ].is_availdisabled = false;
                        }
                      }
                    } else {
                      if (
                        new Date(this.weekDietDetail[index].date_arr[i].date) <=
                        new Date(this.dietFromDate) ||
                        new Date(this.weekDietDetail[index].date_arr[i].date) >=
                        new Date(this.dietToDate)
                      ) {
                        if (
                          new Date(
                            this.weekDietDetail[index].date_arr[i].date
                          ) < new Date(this.dietFromDate)
                        ) {
                          this.weekDietDetail[index].date_arr[
                            i
                          ].is_availdisabled = true;
                          this.weekDietDetail[index].date_arr[
                            i
                          ].is_cheat_day_available = false;
                        } else {
                          var level = finalArry.filter(
                            (x) =>
                              x.is_availdisabled == false &&
                              x.is_cheat_day_available == false
                          );
                          if (level.length < Number(this.durationDays)) {
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_availdisabled = false;
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_cheat_day_available = false;
                          } else {
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_availdisabled = true;
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_cheat_day_available = false;
                          }
                        }
                      } else {
                        this.weekDietDetail[index].date_arr[
                          i
                        ].is_availdisabled = false;
                        this.weekDietDetail[index].date_arr[
                          i
                        ].is_cheat_day_available = false;
                      }
                    }
                    finalArry.push(this.weekDietDetail[index].date_arr[i]);
                  }
                }
              }
            }

            var final = finalArry.filter(
              (x) =>
                x.is_availdisabled == false && x.is_cheat_day_available == false
            );
            if (final.length == Number(this.durationDays)) {
              diff = 0;
            } else {
              if (this.durationDays < 7) {

              }
              else {
                this.dietToDate =
                  endDate.getFullYear() +
                  '-' +
                  ('0' + (endDate.getMonth() + 1)).slice(-2) +
                  '-' +
                  ('0' + endDate.getDate()).slice(-2);
              }
              this.generateWeek();
              continue;
            }
          } else {
            this.dietToDate = this.formatDate(endDate);
          }
        }
      }

      if (final.length == Number(this.durationDays)) {
        diff = 0;
      } else {
        this.generateWeekArrayCheatDays();
      }
    } else {
      this.generateWeekArrayCheatDays();
    }

    if (this.is_save_later && this.booking_id > 0) {
      var datas = this.getSaveandLaterDateLoad();
      this.loaddatesselect = datas;
      this.selectDay(datas, 0, 'save_later');
    } else {
      this.LoadInitialItemLoad(this.dietFromDate, 'SelectedDate');
    }
  }
  calculateEndDate(fromDate: string, durationDays: number): string {
    // Use Moment.js to parse and manipulate the date
    const endDate = moment(fromDate).add(durationDays, 'days').format('YYYY-MM-DD');

    return endDate;
  }




  generateWeek() {
    this.dayCount = 0;
    const weeksArray = [];
    let currentDate = new Date(this.dietFromDate);

    let i = 0;
    while (currentDate <= new Date(this.dietToDate)) {
      const weekNumber = this.getWeekNumberBasedOnDate(
        currentDate,
        i,
        weeksArray
      );
      const weekName = this.addCall.title686 + weekNumber;
      const monthName = currentDate.toLocaleString(undefined, {
        month: 'short',
      });
      const weekStartDate = this.getWeekStartDate(currentDate);
      const weekEndDate = this.getWeekEndDate(currentDate);
      let dateArr = [];

      if (i == 0) {
        currentDate = weekStartDate;
        // Create an array to hold dates for the current week
        dateArr = [
          {
            date: this.formatDate(currentDate),
            day_id: currentDate.getDay(),
            day:
              currentDate.getDate() > 9
                ? currentDate.getDate()
                : '0' + currentDate.getDate(),
            day_txt: currentDate
              .toLocaleString('default', { weekday: 'long' })
              .substring(0, 3),
            daytext:
              localStorage.getItem('selectedLanguage') == 'ea'
                ? currentDate.toLocaleString('ar', { weekday: 'long' })
                : currentDate
                  .toLocaleString('default', { weekday: 'long' })
                  .substring(0, 3),
            is_disabled: this.checkIsDisabled(currentDate),
          },
        ];
      } else {
        currentDate = weekStartDate;
        // Create an array to hold dates for the current week
        dateArr = [
          {
            date: this.formatDate(currentDate),
            day_id: currentDate.getDay(),
            day:
              currentDate.getDate() > 9
                ? currentDate.getDate()
                : '0' + currentDate.getDate(),
            day_txt: currentDate
              .toLocaleString('default', { weekday: 'long' })
              .substring(0, 3),
            daytext:
              localStorage.getItem('selectedLanguage') == 'ea'
                ? currentDate.toLocaleString('ar', { weekday: 'long' })
                : currentDate
                  .toLocaleString('default', { weekday: 'long' })
                  .substring(0, 3),
            is_disabled: this.checkIsDisabled(currentDate),
          },
        ];
      }

      // Add additional dates for the week
      let nextDate = new Date(currentDate);
      nextDate.setDate(nextDate.getDate() + 1);
      while (nextDate <= weekEndDate) {
        let data = {
          date: this.formatDate(nextDate),
          day_id: nextDate.getDay(),
          day:
            nextDate.getDate() > 9
              ? nextDate.getDate()
              : '0' + nextDate.getDate(),
          day_txt: nextDate
            .toLocaleString('default', { weekday: 'long' })
            .substring(0, 3),
          daytext:
            localStorage.getItem('selectedLanguage') == 'ea'
              ? nextDate.toLocaleString('ar', { weekday: 'long' })
              : nextDate
                .toLocaleString('default', { weekday: 'long' })
                .substring(0, 3),
          is_disabled: this.checkIsDisabled(nextDate),
        };
        dateArr.push(data);
        nextDate.setDate(nextDate.getDate() + 1);
      }

      for (let index = 0; index < this.cheat_day.length; index++) {
        if (this.cheat_day[index].days != undefined) {
          this.cheat_daydays.push(this.cheat_day[index].days);
        }
      }
      if (this.cheat_daydays.length > 0) {
        let uniqueArray = [];
        let seenElements = {};
        this.cheat_daydays.forEach((element) => {
          if (!seenElements[element]) {
            uniqueArray.push(element);
            seenElements[element] = true;
          }
        });
        this.cheat_daydays = [];
        this.cheat_daydays = uniqueArray;
      }

      weeksArray.push({
        date_arr: dateArr,
        week_id: weekNumber,
        week_name: weekName,
        month_name: monthName,
      });

      i = i + 1;
      // Move to the next week
      if (this.durationDays <= 7) {
        currentDate = new Date(nextDate);
      } else {
        currentDate.setDate(currentDate.getDate() + 7);
      }
    }
    this.weekDietDetail = weeksArray;
  }
  generateWeekArrayCheatDays() {
    this.dayCount = 0;
    const weeksArray = [];
    let currentDate = new Date(this.dietFromDate);
    let i = 0;
    while (currentDate <= new Date(this.dietToDate)) {
      const weekNumber = this.getWeekNumberBasedOnDate(
        currentDate,
        i,
        weeksArray
      );
      const weekName = this.addCall.title686 + weekNumber;
      const monthName = currentDate.toLocaleString(undefined, {
        month: 'short',
      });
      const weekStartDate = this.getWeekStartDate(currentDate);
      const weekEndDate = this.getWeekEndDate(currentDate);
      let dateArr = [];

      if (i == 0) {
        currentDate = weekStartDate;
        // Create an array to hold dates for the current week
        dateArr = [
          {
            date: this.formatDate(currentDate),
            day_id: currentDate.getDay(),
            day:
              currentDate.getDate() > 9
                ? currentDate.getDate()
                : '0' + currentDate.getDate(),
            day_txt: currentDate
              .toLocaleString('default', { weekday: 'long' })
              .substring(0, 3),
            daytext:
              localStorage.getItem('selectedLanguage') == 'ea'
                ? currentDate.toLocaleString('ar', { weekday: 'long' })
                : currentDate
                  .toLocaleString('default', { weekday: 'long' })
                  .substring(0, 3),
            is_disabled: this.checkIsDisabled(currentDate),
          },
        ];
      } else {
        currentDate = weekStartDate;
        // Create an array to hold dates for the current week
        dateArr = [
          {
            date: this.formatDate(currentDate),
            day_id: currentDate.getDay(),
            day:
              currentDate.getDate() > 9
                ? currentDate.getDate()
                : '0' + currentDate.getDate(),
            day_txt: currentDate
              .toLocaleString('default', { weekday: 'long' })
              .substring(0, 3),
            daytext:
              localStorage.getItem('selectedLanguage') == 'ea'
                ? currentDate.toLocaleString('ar', { weekday: 'long' })
                : currentDate
                  .toLocaleString('default', { weekday: 'long' })
                  .substring(0, 3),
            is_disabled: this.checkIsDisabled(currentDate),
          },
        ];
      }

      // Add additional dates for the week
      let nextDate = new Date(currentDate);
      nextDate.setDate(nextDate.getDate() + 1);
      while (nextDate <= weekEndDate) {
        var data = {
          date: this.formatDate(nextDate),
          day_id: nextDate.getDay(),
          day:
            nextDate.getDate() > 9
              ? nextDate.getDate()
              : '0' + nextDate.getDate(),
          day_txt: nextDate
            .toLocaleString('default', { weekday: 'long' })
            .substring(0, 3),
          daytext:
            localStorage.getItem('selectedLanguage') == 'ea'
              ? nextDate.toLocaleString('ar', { weekday: 'long' })
              : nextDate
                .toLocaleString('default', { weekday: 'long' })
                .substring(0, 3),
          is_disabled: this.checkIsDisabled(nextDate),
        };
        dateArr.push(data);
        nextDate.setDate(nextDate.getDate() + 1);
      }

      for (let index = 0; index < this.cheat_day.length; index++) {
        if (this.cheat_day[index].days != undefined) {
          this.cheat_daydays.push(this.cheat_day[index].days);
        }
      }
      if (this.cheat_daydays.length > 0) {
        let uniqueArray = [];
        let seenElements = {};
        this.cheat_daydays.forEach((element) => {
          if (!seenElements[element]) {
            uniqueArray.push(element);
            seenElements[element] = true;
          }
        });
        this.cheat_daydays = [];
        this.cheat_daydays = uniqueArray;
      }

      weeksArray.push({
        date_arr: dateArr,
        week_id: weekNumber,
        week_name: weekName,
        month_name: monthName,
      });

      i = i + 1;
      // Move to the next week
      if (this.durationDays <= 7) {
        currentDate = new Date(nextDate);
      } else {
        currentDate.setDate(currentDate.getDate() + 7);
      }
    }
    let finalArry = [];
    if (this.cheat_daydays.includes("الأحد")) {
      this.sundayinarabic = 0;
    }
    for (let index = 0; index <= weeksArray.length; index++) {
      if (
        weeksArray[index] != undefined &&
        weeksArray[index].date_arr != undefined
      ) {
        for (let i = 0; i < weeksArray[index].date_arr.length; i++) {
          if (weeksArray[index].date_arr[i] != undefined) {
            var contains = this.cheat_daydays.includes(
              weeksArray[index].date_arr[i].day_txt) || this.cheat_daydays.includes(
                weeksArray[index].date_arr[i].day_txt_ar) || this.cheat_daydays.includes(
                  weeksArray[index].date_arr[i].daytext_ar) || this.sundayinarabic == weeksArray[index].date_arr[i].day_id

            if (contains) {
              let level = finalArry.filter(
                (x) =>
                  x.is_availdisabled == false &&
                  x.is_cheat_day_available == false
              );
              if (
                new Date(weeksArray[index].date_arr[i].date) <=
                new Date(this.dietFromDate) ||
                new Date(weeksArray[index].date_arr[i].date) >=
                new Date(this.dietToDate)
              ) {
                if (
                  level.length == Number(this.durationDays) ||
                  level.length == 0
                ) {
                  weeksArray[index].date_arr[i].is_cheat_day_available = false;
                  weeksArray[index].date_arr[i].is_availdisabled = true;
                } else {
                  weeksArray[index].date_arr[i].is_cheat_day_available = true;
                  weeksArray[index].date_arr[i].is_availdisabled = false;
                }
              } else {
                weeksArray[index].date_arr[i].is_cheat_day_available = true;
                weeksArray[index].date_arr[i].is_availdisabled = false;
              }
            } else {
              if (
                new Date(weeksArray[index].date_arr[i].date) <
                new Date(this.dietFromDate) ||
                new Date(weeksArray[index].date_arr[i].date) >
                new Date(this.dietToDate)
              ) {
                if (
                  new Date(weeksArray[index].date_arr[i].date) <
                  new Date(this.dietFromDate) ||
                  new Date(weeksArray[index].date_arr[i].date) >
                  new Date(this.dietToDate)
                ) {
                  weeksArray[index].date_arr[i].is_availdisabled = true;
                  weeksArray[index].date_arr[i].is_cheat_day_available = false;
                } else {
                  let level = finalArry.filter(
                    (x) =>
                      x.is_availdisabled == false &&
                      x.is_cheat_day_available == false
                  );
                  if (level.length < Number(this.durationDays)) {
                    weeksArray[index].date_arr[i].is_availdisabled = false;
                    weeksArray[index].date_arr[i].is_cheat_day_available =
                      false;
                  } else {
                    weeksArray[index].date_arr[i].is_availdisabled = true;
                    weeksArray[index].date_arr[i].is_cheat_day_available =
                      false;
                  }
                }
              } else {
                weeksArray[index].date_arr[i].is_availdisabled = false;
                weeksArray[index].date_arr[i].is_cheat_day_available = false;
              }
            }
            finalArry.push(weeksArray[index].date_arr[i]);
          }
        }
      }
    }

    this.weekDietDetail = weeksArray;
    if (this.booking_id > 0) {
      var datas = this.getSaveandLaterDateLoad();
      this.loaddatesselect = datas;
      this.selectDay(datas, 0, 'save_later');
    } else {
      this.LoadInitialItemLoad(this.dietFromDate, 'SelectedDate');
    }
  }

  generateWeekArraySaveSelectLater() {
    const weeksArray = [];
    let currentDate = new Date(this.dietFromDate);
    let i = 0;
    while (currentDate <= new Date(this.dietToDate)) {
      const weekNumber = this.getWeekNumberBasedOnDate(
        currentDate,
        i,
        weeksArray
      );
      const weekName = this.addCall.title686 + weekNumber;
      const monthName = currentDate.toLocaleString(undefined, {
        month: 'short',
      });
      const weekStartDate = this.getWeekStartDate(currentDate);
      const weekEndDate = this.getWeekEndDate(currentDate);
      let dateArr = [];

      if (i == 0) {
        currentDate = weekStartDate;
        // Create an array to hold dates for the current week
        dateArr = [
          {
            date: this.formatDate(currentDate),
            day_id: currentDate.getDay(),
            day:
              currentDate.getDate() > 9
                ? currentDate.getDate()
                : '0' + currentDate.getDate(),
            day_txt: currentDate
              .toLocaleString('default', { weekday: 'long' })
              .substring(0, 3),
            daytext:
              localStorage.getItem('selectedLanguage') == 'ea'
                ? currentDate.toLocaleString('ar', { weekday: 'long' })
                : currentDate
                  .toLocaleString('default', { weekday: 'long' })
                  .substring(0, 3),
            is_disabled: this.checkIsDisabled(currentDate),
          },
        ];
      } else {
        currentDate = weekStartDate;
        // Create an array to hold dates for the current week
        dateArr = [
          {
            date: this.formatDate(currentDate),
            day_id: currentDate.getDay(),
            day:
              currentDate.getDate() > 9
                ? currentDate.getDate()
                : '0' + currentDate.getDate(),
            day_txt: currentDate
              .toLocaleString('default', { weekday: 'long' })
              .substring(0, 3),
            daytext:
              localStorage.getItem('selectedLanguage') == 'ea'
                ? currentDate.toLocaleString('ar', { weekday: 'long' })
                : currentDate
                  .toLocaleString('default', { weekday: 'long' })
                  .substring(0, 3),
            is_disabled: this.checkIsDisabled(currentDate),
          },
        ];
      }

      // Add additional dates for the week
      let nextDate = new Date(currentDate);
      nextDate.setDate(nextDate.getDate() + 1);
      while (nextDate <= weekEndDate) {
        var data = {
          date: this.formatDate(nextDate),
          day_id: nextDate.getDay(),
          day:
            nextDate.getDate() > 9
              ? nextDate.getDate()
              : '0' + nextDate.getDate(),
          day_txt: nextDate
            .toLocaleString('default', { weekday: 'long' })
            .substring(0, 3),
          daytext:
            localStorage.getItem('selectedLanguage') == 'ea'
              ? nextDate.toLocaleString('ar', { weekday: 'long' })
              : nextDate
                .toLocaleString('default', { weekday: 'long' })
                .substring(0, 3),
          is_disabled: this.checkIsDisabled(nextDate),
        };
        dateArr.push(data);
        nextDate.setDate(nextDate.getDate() + 1);
      }

      for (let i = 0; i < dateArr.length; i++) {
        if (
          new Date(dateArr[i].date) < new Date(this.dietFromDate) ||
          new Date(dateArr[i].date) > new Date(this.dietToDate)
        ) {
          dateArr[i].is_availdisabled = true;
          dateArr[i].is_cheat_day_available = false;
        } else {
          dateArr[i].is_availdisabled = false;
          dateArr[i].is_cheat_day_available = false;
        }
        const element = dateArr;
      }
      if (this.is_cheat_day_available) {
        if (this.cheat_day.length >= 1) {
          if (this.cheat_day.value == 'Skip') {
            dateArr = dateArr.filter(
              (item1) =>
                !this.cheat_day.some((item2) => item2.value === item1.day_txt)
            );
          } else {
            for (let index = 0; index < this.cheat_day.length; index++) {
              for (let i = 0; i < dateArr.length; i++) {
                if (this.cheat_day[index].days == dateArr[i].day_txt) {
                  dateArr[i].is_cheat_day_available = true;
                  this.cheat_daydays.push(this.cheat_day[index].days);
                }
              }
            }
          }
        } else {
          dateArr = dateArr;
        }
      }

      if (this.cheat_daydays.length > 0) {
        let uniqueArray = [];
        let seenElements = {};
        this.cheat_daydays.forEach((element) => {
          if (!seenElements[element]) {
            uniqueArray.push(element);
            seenElements[element] = true;
          }
        });
        this.cheat_daydays = [];
        this.cheat_daydays = uniqueArray;
      }
      let uniqueArray = [...new Set(this.cheat_daydays)];
      this.dayCount = this.dayCount + dateArr.length;
      console.log(uniqueArray);

      weeksArray.push({
        date_arr: dateArr,
        week_id: weekNumber,
        week_name: weekName,
        month_name: monthName,
      });

      i = i + 1;
      // Move to the next week
      if (this.durationDays <= 7) {
        currentDate = new Date(nextDate);
      } else {
        currentDate.setDate(currentDate.getDate() + 7);
      }
    }
    if (this.cheat_day.length > 0 && this.cheat_day[0].days != 'Skip') {
      for (let index = 0; index <= weeksArray.length; index++) {
        if (
          weeksArray[index] != undefined &&
          weeksArray[index].date_arr != undefined
        ) {
          for (let i = 0; i < weeksArray[index].date_arr.length; i++) {
            this.totalArray.push(weeksArray[index].date_arr[i]);
          }
        }
      }
      let total = this.totalArray.filter(
        (x) => x.is_availdisabled == false && x.is_cheat_day_available == false
      );
      if (Number(total.length) < Number(this.durationDays)) {
        let diff = Number(this.durationDays) - Number(total.length);
        if (diff > 0) {
          var endDate = new Date(this.dietToDate);
        }
        while (diff > 0) {
          endDate.setDate(endDate.getDate() + 1);
          let Days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
          let day = endDate.getDay();
          let dayName = Days[day];
          let dayCondition = this.cheat_daydays.includes(dayName);
          if (!dayCondition) {
            let finalArry = [];
            for (let index = 0; index <= this.weekDietDetail.length; index++) {
              if (
                this.weekDietDetail[index] != undefined &&
                this.weekDietDetail[index].date_arr != undefined
              ) {
                for (
                  let i = 0;
                  i < this.weekDietDetail[index].date_arr.length;
                  i++
                ) {
                  if (this.weekDietDetail[index].date_arr[i] != undefined) {
                    let contains = this.cheat_daydays.includes(
                      this.weekDietDetail[index].date_arr[i].day_txt
                    );
                    if (contains) {
                      if (
                        new Date(this.weekDietDetail[index].date_arr[i].date) >
                        new Date(this.dietToDate)
                      ) {
                        this.weekDietDetail[index].date_arr[
                          i
                        ].is_cheat_day_available = true;
                        this.weekDietDetail[index].date_arr[
                          i
                        ].is_availdisabled = false;
                      } else {
                        // Cheat Day Available
                        this.weekDietDetail[index].date_arr[
                          i
                        ].is_cheat_day_available = true;
                        this.weekDietDetail[index].date_arr[
                          i
                        ].is_availdisabled = false;
                      }
                    } else {
                      if (
                        new Date(this.weekDietDetail[index].date_arr[i].date) <=
                        new Date(this.dietFromDate) ||
                        new Date(this.weekDietDetail[index].date_arr[i].date) >=
                        new Date(this.dietToDate)
                      ) {
                        if (
                          new Date(
                            this.weekDietDetail[index].date_arr[i].date
                          ) < new Date(this.dietFromDate)
                        ) {
                          this.weekDietDetail[index].date_arr[
                            i
                          ].is_availdisabled = true;
                          this.weekDietDetail[index].date_arr[
                            i
                          ].is_cheat_day_available = false;
                        } else {
                          let level = finalArry.filter(
                            (x) =>
                              x.is_availdisabled == false &&
                              x.is_cheat_day_available == false
                          );
                          if (level.length < Number(this.durationDays)) {
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_availdisabled = false;
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_cheat_day_available = false;
                          } else {
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_availdisabled = true;
                            this.weekDietDetail[index].date_arr[
                              i
                            ].is_cheat_day_available = false;
                          }
                        }
                      } else {
                        this.weekDietDetail[index].date_arr[
                          i
                        ].is_availdisabled = false;
                        this.weekDietDetail[index].date_arr[
                          i
                        ].is_cheat_day_available = false;
                      }
                    }
                    finalArry.push(this.weekDietDetail[index].date_arr[i]);
                  }
                }
              }
            }

            let final = finalArry.filter(
              (x) =>
                x.is_availdisabled == false && x.is_cheat_day_available == false
            );
            if (final.length == Number(this.durationDays)) {
              diff = 0;
            } else {
              this.dietToDate =
                endDate.getFullYear() +
                '-' +
                ('0' + (endDate.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + endDate.getDate()).slice(-2);
              this.generateWeek();
              continue;
            }
          } else {
            this.dietToDate = this.formatDate(endDate);
          }
        }
      }
      this.generateWeekArrayCheatDays();
    } else {
      this.weekDietDetail = weeksArray;
    }
    if (this.booking_id > 0) {
      this.selectDay(this.edited_diet_menu[0], 0, 'save_later');
    } else {
      this.LoadInitialItemLoad(this.dietFromDate, 'SelectedDate');
    }
  }
  differDates: any[] = [];
  loaddatesselect: any;
  getSaveandLaterDateLoad(): any {
    for (let p = 0; p < this.weekDietDetail.length; p++) {
      const ele = this.weekDietDetail[p];
      var data = this.edited_diet_menu.filter(
        (x) => x.diet_week_id == ele.week_id
      );
      if (data.length > 0) {
        var getDiff = ele.date_arr.filter(
          (item1) =>
            !data.some(
              (item2) =>
                item2.dates === item1.date.split('-').reverse().join('-')
            )
        );
        if (getDiff.length > 0) {
          getDiff.forEach((item) => {
            (item.week_id = ele.week_id), (item.week_name = ele.week_name);
            this.differDates.push(item);
          });
        }
      }
    }
    this.loaddatesselect = this.dietFromDate;
    this.selectDate = this.loaddatesselect;
    var data = getDiff.find((x) => x.date == this.loaddatesselect);
    console.log('checking', data);
    return data;
  }

  minimumDate(): string {
    let minDate = this.differDates[0].date;
    let minWeek = this.differDates[0].week_id;

    for (let i = 1; i < this.differDates.length; i++) {
      if (
        this.differDates[i].date < minDate &&
        this.differDates[0].week_id < minWeek
      ) {
        minDate = this.differDates[i].date;
      }
    }
    return minDate;
  }
  loadMenuItemList: any[] = [];
  LoadInitialItemLoad(dietFromDate, type) {
    var format = this.isValidDateFormat(dietFromDate);
    if (
      Number(this.activeRoute.snapshot.paramMap.get('booking_id')) > 0 &&
      type == 'save_later'
    ) {
      if (format) {
        this.selectDate = dietFromDate;
        this.loadMenuItemList = [];
        if (this.duration_detail_menu_list.length > 0) {
          for (
            let index = 0;
            index < this.duration_detail_menu_list.length;
            index++
          ) {
            var menu_list = [];
            const element = this.duration_detail_menu_list[index];
            if (element.item_list.length > 0) {
              for (let i = 0; i < element.item_list.length; i++) {
                var available_date = element.item_list[
                  i
                ].available_date.includes(
                  dietFromDate.split('-').reverse().join('-')
                );
                if (available_date) {
                  element.item_list[i].selectedDate = this.dietFromDate;
                  element.item_list[i].week_id = this.week;
                  element.item_list[i].week_name = this.week_name;
                  menu_list.push(element.item_list[i]);
                }
              }
              if (menu_list.length > 0) {
                this.loadMenuItemList.push({
                  id: this.duration_detail_menu_list[index].id,
                  item_list: menu_list,
                  package_name:
                    this.duration_detail_menu_list[index].package_name,
                });
              }
            }
          }
        }
      } else {
        this.selectDate = dietFromDate;
        this.loadMenuItemList = [];
        if (this.duration_detail_menu_list.length > 0) {
          for (
            let index = 0;
            index < this.duration_detail_menu_list.length;
            index++
          ) {
            let menu_list = [];
            const element = this.duration_detail_menu_list[index];
            if (element.item_list.length > 0) {
              for (let i = 0; i < element.item_list.length; i++) {
                let available_date =
                  element.item_list[i].available_date.includes(dietFromDate);
                if (available_date) {
                  element.item_list[i].selectedDate = this.dietFromDate;
                  element.item_list[i].week_id = this.week;
                  element.item_list[i].week_name = this.week_name;
                  menu_list.push(element.item_list[i]);
                }
              }
              if (menu_list.length > 0) {
                this.loadMenuItemList.push({
                  id: this.duration_detail_menu_list[index].id,
                  item_list: menu_list,
                  package_name:
                    this.duration_detail_menu_list[index].package_name,
                });
              }
            }
          }
        }
      }
    } else {
      this.selectDate = dietFromDate;
      this.loadMenuItemList = [];
      if (this.duration_detail_menu_list.length > 0) {
        for (
          let index = 0;
          index < this.duration_detail_menu_list.length;
          index++
        ) {
          let menu_list = [];
          const element = this.duration_detail_menu_list[index];
          if (element.item_list.length > 0) {
            for (let i = 0; i < element.item_list.length; i++) {
              let available_date = element.item_list[i].available_date.includes(
                dietFromDate.split('-').reverse().join('-')
              );
              if (available_date) {
                element.item_list[i].selectedDate = this.dietFromDate;
                element.item_list[i].week_id = this.week;
                element.item_list[i].week_name = this.week_name;
                menu_list.push(element.item_list[i]);
              }
            }
            if (menu_list.length > 0) {
              this.loadMenuItemList.push({
                id: this.duration_detail_menu_list[index].id,
                item_list: menu_list,
                package_name:
                  this.duration_detail_menu_list[index].package_name,
              });
            }
          }
        }
      }
    }
  }

  isValidDateFormat(dateString: string): boolean {
    // Regular expression to match the format YYYY-MM-DD
    const regex = /^\d{4}-\d{2}-\d{2}$/;

    return regex.test(dateString);
  }

  getWeekNumber(date: Date): any {
    const tempDate = new Date(date);
    tempDate.setDate(tempDate.getDate() + 4 - (tempDate.getDay() || 7));
    const yearStart = new Date(tempDate.getFullYear(), 0, 1);
    const weekNumber = Math.ceil(
      ((tempDate.getTime() - yearStart.getTime()) / 86400000 + 1) / 7
    );
    if (weekNumber === 0) {
      return this.getWeekNumber(new Date(tempDate.getFullYear() - 1, 11, 31));
    }
    return weekNumber;
  }

  getWeekStartDate(date: Date): Date {
    const tempDate = new Date(date);
    const diff = tempDate.getDate() - tempDate.getDay();
    tempDate.setDate(diff);
    return tempDate;
  }

  getWeekEndDate(date: Date): Date {
    const tempDate = new Date(date);
    const diff = tempDate.getDate() - tempDate.getDay() + 6;
    tempDate.setDate(diff);
    return tempDate;
  }

  formatDate(date: Date): string {
    return date.toISOString().slice(0, 10);
  }

  checkIsDisabled(date) {
    let day_id = date.getDay();
    if (this.cheat_days.includes(day_id)) {
      return true;
    } else {
      return false;
    }
  }

  selectMenu() {
    if (this.duration_detail_id != 0) {
      if (this.is_cheat_day_available) {
        this.openCheatDay();
      } else {
        this.helthyEatspage('MealPlan', this.packind);
      }
    } else {
      this.presentToast('Please select duration detail');
    }
  }
  async openCheatDay() {
    const cheatDayModal = await this.modalCtrl.create({
      component: ViewmodelPage,
      cssClass: 'cheat_modal',
      backdropDismiss: false,
      componentProps: {
        From: 'cheat_day',
        cheat_days: this.cheat_days,
      },
    });
    await cheatDayModal.present();

    cheatDayModal.onDidDismiss().then((data) => {
      if (data) {
        this.cheat_days = data.data;
        this.cheat_day = data.role;
        this.helthyEatspage('MealPlan', this.packind);
      }
    });
  }
  menuLevel: any;


  async dietexplainervideo(vendor_id, menu_id) {

    const dietvideo = await this.modalCtrl.create({
      component: ViewmodelPage,
      cssClass: 'diethowtobookvideo',
      backdropDismiss: false,
      componentProps: {
        dietHowToBooks: 'dietexplainervideo',
        vendorid: vendor_id,
        menuid: menu_id,
      },
    });
    await dietvideo.present();
  }




  async openStartDateModel(value) {
    const cheatDayModal = await this.modalCtrl.create({
      component: ViewmodelPage,
      cssClass: 'startdate_model',
      backdropDismiss: false,
      componentProps: {
        From: 'startdate_model',
        startdatevalue: value,
      },
    });
    await cheatDayModal.present();
    cheatDayModal.onDidDismiss().then((data) => {

      this.start_cheatday = false;
    });
  }
  async openSaveAndSelectLater() {
    const openSaveandSelectLater = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: 'saveandselectlater',
      },
      cssClass: 'selectandSaveLater',
    });
    await openSaveandSelectLater.present();

    openSaveandSelectLater.onDidDismiss().then((data) => {
      if (data) {
        if (data.data == 'BookConfirmPage') {
          this.menuLevel = 'Yes';
          this.is_save_later = true;
          this.confirmBook();
        }
        if (data.data == 'Cancel') {
          this.menuLevel = 'NO';
        }
      }
    });
  }

  async openIsSaveAndSelectLater() {
    const openIsSaveAndSelectLater = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: 'isSaveAndSelectlater',
      },
      cssClass: 'isSaveAndSelectlater',
    });
    await openIsSaveAndSelectLater.present();
  }

  async ModifyAddress() {
    const deliveryAddressModal = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: 'delivery_address_update',
        DeliveryAddress: this.DeliveryAddress,
        delivery_contact_no: this.Phonno,
        cc_code_details: this.cccode,
        delivery_time: this.delivery_time,
        delivery_instruction: this.delivery_instruction,
      },
      cssClass: 'delivery_address_modal',
    });
    await deliveryAddressModal.present();

    deliveryAddressModal.onDidDismiss().then((data) => {
      if (data) {
        if (data.data != undefined) {
          (this.DeliveryAddress = data.data.DeliveryAddress),
            (this.delivery_contact_no = data.data.delivery_contact_no);
          (this.cc_code_details = data.data.cc_code_details);
          this.delivery_instruction = data.data.delivery_instruction;
        }
      }
    });
  }

  editBooking() {
    this.saveandselect = true;
    this.router.navigate([
      '/tabs/dietmeal',
      { booking_id: this.storeParticularData.dietbookingId },
    ]);
  }

  async updateBooking() {
    if (!this.booking_updated) {
      this.booking_updated = true;
      let selected_diet_menu = [];
      if (this.finalArrayFood.length > 0) {
        this.finalArrayFood.map((obj: any) => {
          if (obj.is_selected == true) {
            let final_obj = {
              diet_menu_item_id: obj['item_id'],
              diet_menu_id: obj['master_menu_id'],
              diet_day_id: obj['day_id'],
              diet_week_id: obj['week_id'],
              dates: obj['selectedDate'].split('-').reverse().join('-'),
              is_active: '1',
            };
            this.calPerDay = this.calPerDay;
            selected_diet_menu.push(final_obj);
          }
        });
      }

      let uniqueObject = {};
      let uniqueArray = [];
      this.finalArrayFood.forEach((item) => {
        if (!uniqueObject[item['selectedDate']]) {
          uniqueObject[item['selectedDate']] = true;
          uniqueArray.push(item);
        }
      });
      this.selDays = uniqueArray.length;

      this.storeSelectedDiet = selected_diet_menu;
      const loading = await this.loadingCtrl.create({
        message: 'Processing Your Payment Status',
      });
      let apiData = JSON.stringify({
        booking_id: this.booking_id,
        patient_id: localStorage.getItem('patient_id'),
        vendor_id: this.storeDietVendorId,
        package_id: this.package_id,
        menuitem: this.storeSelectedDiet,
        intake_calsday: this.calPerDay,
        is_save_later: this.is_save_later ? 1 : 0,
        selecteddays: this.selDays,
      });
      this.insertDietBookReq = this.services
        .postRequest('updatedietbooking', apiData)
        .subscribe(async (res) => {
          console.log('insertBooking=>', res);
          await loading.dismiss();
          if (res.status == 1) {
            this.bookingupdateSucess(this.addCall.title717, 1);
          } else {
            this.bookingupdateSucess(this.addCall.title718, 0);
          }
        });
    }
  }

  async bookingupdateSucess(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    await alert.present();
    alert.onDidDismiss().then((data) => {
      if (status == 1) {
        this.booking_updated = false;
        // this.router.navigate(['/tabs/home']);
      }
    });
  }

  TC_Array: any = [];

  isShowVendorTC(data: any) {
    var body = {
      vendor_id: data,
    };
    this.services.dietGetRequest('getTermsAndConditionsList', body).subscribe(
      (res) => {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].is_active == '1') {
              this.TC_Array.push(res.data[i]);
            }
          }

          this.tcmodelcontroller();
        } else {
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  async tcmodelcontroller() {
    const modal = await this.modalCtrl.create({
      component: VendorTCComponent,
      cssClass: 'tc-model-controller',
      componentProps: {
        data: this.TC_Array,
      },
    });
    modal.onDidDismiss().then((data) => {
      this.TC_Array = [];
    });
    return await modal.present();
  }

  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate1(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  // openTerms() {
  //   const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
  //   const params = new HttpParams().set('vendorcategory', 'Diet');

  //   this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
  //     .subscribe(
  //       response => {
  //         if (response && response.data && response.data.length > 0) {
  //           const lastIndex = response.data.length - 1;
  //           this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
  //           const decryptedData = this.decryptContent(this.terms_and_condition_file);
  //           console.log("Decrypted data:", decryptedData);

  //           if (!decryptedData) {
  //             throw new Error('Decryption failed');
  //           }

  //           const content = htmlToPdfmake(decryptedData);
  //           console.log("PDF content:", content);

  //           if (!content || !Array.isArray(content)) {
  //             throw new Error('Invalid content structure');
  //           }

  //           const documentDefinition = {
  //             content: content,
  //             styles: {
  //               header: {
  //                 fontSize: 12,
  //                 bold: true,
  //                 margin: [40, 10, 40, 10],
  //               },
  //               footer: {
  //                 fontSize: 10,
  //                 margin: [40, 0, 40, 0],
  //               },
  //               footerText: {
  //                 fontSize: 10,
  //               },
  //             },
  //             header: (currentPage, pageCount, pageSize) => {
  //               const modified_on = new Date();
  //               return {
  //                 text: ``,
  //                 alignment: 'left',
  //                 style: 'header',
  //                 color: '#510F30',
  //                 margin: [30, 40, 0, 0],
  //               };
  //             },
  //             footer: (currentPage, pageCount, pageSize) => {

  //               const modified_on = new Date();

  //               return {
  //                 margin: [40, 40, 40, 40],
  //                 columns: [
  //                   {
  //                     stack: [
  //                       {
  //                         text: `Page ${currentPage}/${pageCount}`,
  //                         alignment: "right",
  //                         color: "#510F30",
  //                         style: "footerText",
  //                       },
  //                     ],
  //                   },
  //                 ],
  //               };
  //             },
  //             pageMargins: [40, 70, 40, 180],
  //           };
  //           pdfMake.createPdf(documentDefinition).getBlob(async (blob: Blob) => {
  //             console.log("PDF Blob:", blob);
  //             try {
  //               const localBlob = new Blob([blob], { type: 'application/pdf' });
  //               const fileName = `report_${new Date().getTime()}.pdf`;
  //               await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
  //                 .then((fileEntry) => {
  //                   console.log("File entry:", fileEntry);
  //                   this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
  //                     .then(() => console.log('File is opened'))
  //                     .catch(e => console.log('Error opening file', e));
  //                 })
  //                 .catch(e => console.log('Error writing file', e));
  //             } catch (error) {
  //               console.error('Error uploading file', error);
  //             }
  //           });

  //         } else {
  //           console.error('Unexpected response format:', response);
  //         }
  //       },
  //       error => {
  //         console.error('Error:', error);
  //       }
  //     );
  // }


  openTerms() {
    const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
    const params = new HttpParams().set('vendorcategory', 'Diet');
  
    this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
      .subscribe(
        response => {
          if (response && response.data && response.data.length > 0) {
            const lastIndex = response.data.length - 1;
            this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
            const decryptedData = this.decryptContent(this.terms_and_condition_file);
            console.log("Decrypted data:", decryptedData);
  
            if (!decryptedData) {
              throw new Error('Decryption failed');
            }
  
            const content = htmlToPdfmake(decryptedData);
            console.log("PDF content:", content);
  
            if (!content || !Array.isArray(content)) {
              throw new Error('Invalid content structure');
            }
  
            const documentDefinition = {
              content: content,
              styles: {
                header: {
                  fontSize: 12,
                  bold: true,
                  margin: [40, 10, 40, 10],
                },
                footer: {
                  fontSize: 10,
                  margin: [40, 0, 40, 0],
                },
                footerText: {
                  fontSize: 10,
                },
              },
              header: (currentPage, pageCount, pageSize) => {
                const modified_on = new Date();
                return {
                  text: ``,
                  alignment: 'left',
                  style: 'header',
                  color: '#510F30',
                  margin: [30, 40, 0, 0],
                };
              },
              footer: (currentPage, pageCount, pageSize) => {
                const modified_on = new Date();
                return {
                  margin: [40, 40, 40, 40],
                  columns: [
                    {
                      stack: [
                        {
                          text: `Page ${currentPage}/${pageCount}`,
                          alignment: "right",
                          color: "#510F30",
                          style: "footerText",
                        },
                      ],
                    },
                  ],
                };
              },
              pageMargins: [40, 70, 40, 180],
            };
  
            // Generate the PDF Blob and open in a new tab on the web
            pdfMake.createPdf(documentDefinition).getBlob((blob: Blob) => {
              console.log("PDF Blob:", blob);
              const pdfURL = URL.createObjectURL(blob);
              window.open(pdfURL, '_blank'); // Open PDF in a new browser tab
            });
  
          } else {
            console.error('Unexpected response format:', response);
          }
        },
        error => {
          console.error('Error:', error);
        }
      );
  }
  


}
function output(): (target: DietmealPage, propertyKey: 'press') => void {
  throw new Error('Function not implemented.');
}